var nl = Object.defineProperty;
var il = (e, t, n) => t in e ? nl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Pe = (e, t, n) => (il(e, typeof t != "symbol" ? t + "" : t, n), n);
function is(e, t) {
  const n = /* @__PURE__ */ Object.create(null), i = e.split(",");
  for (let s = 0; s < i.length; s++)
    n[i[s]] = !0;
  return t ? (s) => !!n[s.toLowerCase()] : (s) => !!n[s];
}
function Mt(e) {
  if (q(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const i = e[n], s = Ie(i) ? al(i) : Mt(i);
      if (s)
        for (const o in s)
          t[o] = s[o];
    }
    return t;
  } else {
    if (Ie(e))
      return e;
    if (ge(e))
      return e;
  }
}
const sl = /;(?![^(]*\))/g, ol = /:([^]+)/, rl = /\/\*.*?\*\//gs;
function al(e) {
  const t = {};
  return e.replace(rl, "").split(sl).forEach((n) => {
    if (n) {
      const i = n.split(ol);
      i.length > 1 && (t[i[0].trim()] = i[1].trim());
    }
  }), t;
}
function M(e) {
  let t = "";
  if (Ie(e))
    t = e;
  else if (q(e))
    for (let n = 0; n < e.length; n++) {
      const i = M(e[n]);
      i && (t += i + " ");
    }
  else if (ge(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const ll = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", dl = /* @__PURE__ */ is(ll);
function er(e) {
  return !!e || e === "";
}
const j = (e) => Ie(e) ? e : e == null ? "" : q(e) || ge(e) && (e.toString === sr || !Y(e.toString)) ? JSON.stringify(e, tr, 2) : String(e), tr = (e, t) => t && t.__v_isRef ? tr(e, t.value) : Vt(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce((n, [i, s]) => (n[`${i} =>`] = s, n), {})
} : nr(t) ? {
  [`Set(${t.size})`]: [...t.values()]
} : ge(t) && !q(t) && !or(t) ? String(t) : t, he = {}, Ht = [], We = () => {
}, cl = () => !1, pl = /^on[^a-z]/, Xn = (e) => pl.test(e), ss = (e) => e.startsWith("onUpdate:"), Se = Object.assign, os = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, ul = Object.prototype.hasOwnProperty, oe = (e, t) => ul.call(e, t), q = Array.isArray, Vt = (e) => ei(e) === "[object Map]", nr = (e) => ei(e) === "[object Set]", Y = (e) => typeof e == "function", Ie = (e) => typeof e == "string", rs = (e) => typeof e == "symbol", ge = (e) => e !== null && typeof e == "object", ir = (e) => ge(e) && Y(e.then) && Y(e.catch), sr = Object.prototype.toString, ei = (e) => sr.call(e), ml = (e) => ei(e).slice(8, -1), or = (e) => ei(e) === "[object Object]", as = (e) => Ie(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Rn = /* @__PURE__ */ is(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), ti = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, fl = /-(\w)/g, Le = ti((e) => e.replace(fl, (t, n) => n ? n.toUpperCase() : "")), gl = /\B([A-Z])/g, Fe = ti((e) => e.replace(gl, "-$1").toLowerCase()), ni = ti((e) => e.charAt(0).toUpperCase() + e.slice(1)), Ln = ti((e) => e ? `on${ni(e)}` : ""), mn = (e, t) => !Object.is(e, t), Si = (e, t) => {
  for (let n = 0; n < e.length; n++)
    e[n](t);
}, Wn = (e, t, n) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    value: n
  });
}, hl = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, ji = (e) => {
  const t = Ie(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let eo;
const bl = () => eo || (eo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
let Re;
class rr {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this.parent = Re, !t && Re && (this.index = (Re.scopes || (Re.scopes = [])).push(this) - 1);
  }
  get active() {
    return this._active;
  }
  run(t) {
    if (this._active) {
      const n = Re;
      try {
        return Re = this, t();
      } finally {
        Re = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Re = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Re = this.parent;
  }
  stop(t) {
    if (this._active) {
      let n, i;
      for (n = 0, i = this.effects.length; n < i; n++)
        this.effects[n].stop();
      for (n = 0, i = this.cleanups.length; n < i; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, i = this.scopes.length; n < i; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !t) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function ar(e) {
  return new rr(e);
}
function xl(e, t = Re) {
  t && t.active && t.effects.push(e);
}
function lr() {
  return Re;
}
function dr(e) {
  Re && Re.cleanups.push(e);
}
const ls = (e) => {
  const t = new Set(e);
  return t.w = 0, t.n = 0, t;
}, cr = (e) => (e.w & _t) > 0, pr = (e) => (e.n & _t) > 0, _l = ({ deps: e }) => {
  if (e.length)
    for (let t = 0; t < e.length; t++)
      e[t].w |= _t;
}, Cl = (e) => {
  const { deps: t } = e;
  if (t.length) {
    let n = 0;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      cr(s) && !pr(s) ? s.delete(e) : t[n++] = s, s.w &= ~_t, s.n &= ~_t;
    }
    t.length = n;
  }
}, Zn = /* @__PURE__ */ new WeakMap();
let rn = 0, _t = 1;
const Fi = 30;
let Ve;
const Et = Symbol(""), Ui = Symbol("");
class ds {
  constructor(t, n = null, i) {
    this.fn = t, this.scheduler = n, this.active = !0, this.deps = [], this.parent = void 0, xl(this, i);
  }
  run() {
    if (!this.active)
      return this.fn();
    let t = Ve, n = ht;
    for (; t; ) {
      if (t === this)
        return;
      t = t.parent;
    }
    try {
      return this.parent = Ve, Ve = this, ht = !0, _t = 1 << ++rn, rn <= Fi ? _l(this) : to(this), this.fn();
    } finally {
      rn <= Fi && Cl(this), _t = 1 << --rn, Ve = this.parent, ht = n, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    Ve === this ? this.deferStop = !0 : this.active && (to(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function to(e) {
  const { deps: t } = e;
  if (t.length) {
    for (let n = 0; n < t.length; n++)
      t[n].delete(e);
    t.length = 0;
  }
}
let ht = !0;
const ur = [];
function Yt() {
  ur.push(ht), ht = !1;
}
function Gt() {
  const e = ur.pop();
  ht = e === void 0 ? !0 : e;
}
function Me(e, t, n) {
  if (ht && Ve) {
    let i = Zn.get(e);
    i || Zn.set(e, i = /* @__PURE__ */ new Map());
    let s = i.get(n);
    s || i.set(n, s = ls()), mr(s);
  }
}
function mr(e, t) {
  let n = !1;
  rn <= Fi ? pr(e) || (e.n |= _t, n = !cr(e)) : n = !e.has(Ve), n && (e.add(Ve), Ve.deps.push(e));
}
function st(e, t, n, i, s, o) {
  const r = Zn.get(e);
  if (!r)
    return;
  let a = [];
  if (t === "clear")
    a = [...r.values()];
  else if (n === "length" && q(e)) {
    const l = Number(i);
    r.forEach((d, c) => {
      (c === "length" || c >= l) && a.push(d);
    });
  } else
    switch (n !== void 0 && a.push(r.get(n)), t) {
      case "add":
        q(e) ? as(n) && a.push(r.get("length")) : (a.push(r.get(Et)), Vt(e) && a.push(r.get(Ui)));
        break;
      case "delete":
        q(e) || (a.push(r.get(Et)), Vt(e) && a.push(r.get(Ui)));
        break;
      case "set":
        Vt(e) && a.push(r.get(Et));
        break;
    }
  if (a.length === 1)
    a[0] && zi(a[0]);
  else {
    const l = [];
    for (const d of a)
      d && l.push(...d);
    zi(ls(l));
  }
}
function zi(e, t) {
  const n = q(e) ? e : [...e];
  for (const i of n)
    i.computed && no(i);
  for (const i of n)
    i.computed || no(i);
}
function no(e, t) {
  (e !== Ve || e.allowRecurse) && (e.scheduler ? e.scheduler() : e.run());
}
function yl(e, t) {
  var n;
  return (n = Zn.get(e)) === null || n === void 0 ? void 0 : n.get(t);
}
const vl = /* @__PURE__ */ is("__proto__,__v_isRef,__isVue"), fr = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(rs)
), wl = /* @__PURE__ */ cs(), Il = /* @__PURE__ */ cs(!1, !0), kl = /* @__PURE__ */ cs(!0), io = /* @__PURE__ */ Al();
function Al() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((t) => {
    e[t] = function(...n) {
      const i = ne(this);
      for (let o = 0, r = this.length; o < r; o++)
        Me(i, "get", o + "");
      const s = i[t](...n);
      return s === -1 || s === !1 ? i[t](...n.map(ne)) : s;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((t) => {
    e[t] = function(...n) {
      Yt();
      const i = ne(this)[t].apply(this, n);
      return Gt(), i;
    };
  }), e;
}
function Sl(e) {
  const t = ne(this);
  return Me(t, "has", e), t.hasOwnProperty(e);
}
function cs(e = !1, t = !1) {
  return function(i, s, o) {
    if (s === "__v_isReactive")
      return !e;
    if (s === "__v_isReadonly")
      return e;
    if (s === "__v_isShallow")
      return t;
    if (s === "__v_raw" && o === (e ? t ? Hl : _r : t ? xr : br).get(i))
      return i;
    const r = q(i);
    if (!e) {
      if (r && oe(io, s))
        return Reflect.get(io, s, o);
      if (s === "hasOwnProperty")
        return Sl;
    }
    const a = Reflect.get(i, s, o);
    return (rs(s) ? fr.has(s) : vl(s)) || (e || Me(i, "get", s), t) ? a : ye(a) ? r && as(s) ? a : a.value : ge(a) ? e ? ms(a) : si(a) : a;
  };
}
const Tl = /* @__PURE__ */ gr(), $l = /* @__PURE__ */ gr(!0);
function gr(e = !1) {
  return function(n, i, s, o) {
    let r = n[i];
    if (Wt(r) && ye(r) && !ye(s))
      return !1;
    if (!e && (!Kn(s) && !Wt(s) && (r = ne(r), s = ne(s)), !q(n) && ye(r) && !ye(s)))
      return r.value = s, !0;
    const a = q(n) && as(i) ? Number(i) < n.length : oe(n, i), l = Reflect.set(n, i, s, o);
    return n === ne(o) && (a ? mn(s, r) && st(n, "set", i, s) : st(n, "add", i, s)), l;
  };
}
function Dl(e, t) {
  const n = oe(e, t);
  e[t];
  const i = Reflect.deleteProperty(e, t);
  return i && n && st(e, "delete", t, void 0), i;
}
function Nl(e, t) {
  const n = Reflect.has(e, t);
  return (!rs(t) || !fr.has(t)) && Me(e, "has", t), n;
}
function El(e) {
  return Me(e, "iterate", q(e) ? "length" : Et), Reflect.ownKeys(e);
}
const hr = {
  get: wl,
  set: Tl,
  deleteProperty: Dl,
  has: Nl,
  ownKeys: El
}, Ol = {
  get: kl,
  set(e, t) {
    return !0;
  },
  deleteProperty(e, t) {
    return !0;
  }
}, Ml = /* @__PURE__ */ Se({}, hr, {
  get: Il,
  set: $l
}), ps = (e) => e, ii = (e) => Reflect.getPrototypeOf(e);
function $n(e, t, n = !1, i = !1) {
  e = e.__v_raw;
  const s = ne(e), o = ne(t);
  n || (t !== o && Me(s, "get", t), Me(s, "get", o));
  const { has: r } = ii(s), a = i ? ps : n ? gs : fn;
  if (r.call(s, t))
    return a(e.get(t));
  if (r.call(s, o))
    return a(e.get(o));
  e !== s && e.get(t);
}
function Dn(e, t = !1) {
  const n = this.__v_raw, i = ne(n), s = ne(e);
  return t || (e !== s && Me(i, "has", e), Me(i, "has", s)), e === s ? n.has(e) : n.has(e) || n.has(s);
}
function Nn(e, t = !1) {
  return e = e.__v_raw, !t && Me(ne(e), "iterate", Et), Reflect.get(e, "size", e);
}
function so(e) {
  e = ne(e);
  const t = ne(this);
  return ii(t).has.call(t, e) || (t.add(e), st(t, "add", e, e)), this;
}
function oo(e, t) {
  t = ne(t);
  const n = ne(this), { has: i, get: s } = ii(n);
  let o = i.call(n, e);
  o || (e = ne(e), o = i.call(n, e));
  const r = s.call(n, e);
  return n.set(e, t), o ? mn(t, r) && st(n, "set", e, t) : st(n, "add", e, t), this;
}
function ro(e) {
  const t = ne(this), { has: n, get: i } = ii(t);
  let s = n.call(t, e);
  s || (e = ne(e), s = n.call(t, e)), i && i.call(t, e);
  const o = t.delete(e);
  return s && st(t, "delete", e, void 0), o;
}
function ao() {
  const e = ne(this), t = e.size !== 0, n = e.clear();
  return t && st(e, "clear", void 0, void 0), n;
}
function En(e, t) {
  return function(i, s) {
    const o = this, r = o.__v_raw, a = ne(r), l = t ? ps : e ? gs : fn;
    return !e && Me(a, "iterate", Et), r.forEach((d, c) => i.call(s, l(d), l(c), o));
  };
}
function On(e, t, n) {
  return function(...i) {
    const s = this.__v_raw, o = ne(s), r = Vt(o), a = e === "entries" || e === Symbol.iterator && r, l = e === "keys" && r, d = s[e](...i), c = n ? ps : t ? gs : fn;
    return !t && Me(o, "iterate", l ? Ui : Et), {
      // iterator protocol
      next() {
        const { value: f, done: h } = d.next();
        return h ? { value: f, done: h } : {
          value: a ? [c(f[0]), c(f[1])] : c(f),
          done: h
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function dt(e) {
  return function(...t) {
    return e === "delete" ? !1 : this;
  };
}
function Bl() {
  const e = {
    get(o) {
      return $n(this, o);
    },
    get size() {
      return Nn(this);
    },
    has: Dn,
    add: so,
    set: oo,
    delete: ro,
    clear: ao,
    forEach: En(!1, !1)
  }, t = {
    get(o) {
      return $n(this, o, !1, !0);
    },
    get size() {
      return Nn(this);
    },
    has: Dn,
    add: so,
    set: oo,
    delete: ro,
    clear: ao,
    forEach: En(!1, !0)
  }, n = {
    get(o) {
      return $n(this, o, !0);
    },
    get size() {
      return Nn(this, !0);
    },
    has(o) {
      return Dn.call(this, o, !0);
    },
    add: dt(
      "add"
      /* TriggerOpTypes.ADD */
    ),
    set: dt(
      "set"
      /* TriggerOpTypes.SET */
    ),
    delete: dt(
      "delete"
      /* TriggerOpTypes.DELETE */
    ),
    clear: dt(
      "clear"
      /* TriggerOpTypes.CLEAR */
    ),
    forEach: En(!0, !1)
  }, i = {
    get(o) {
      return $n(this, o, !0, !0);
    },
    get size() {
      return Nn(this, !0);
    },
    has(o) {
      return Dn.call(this, o, !0);
    },
    add: dt(
      "add"
      /* TriggerOpTypes.ADD */
    ),
    set: dt(
      "set"
      /* TriggerOpTypes.SET */
    ),
    delete: dt(
      "delete"
      /* TriggerOpTypes.DELETE */
    ),
    clear: dt(
      "clear"
      /* TriggerOpTypes.CLEAR */
    ),
    forEach: En(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((o) => {
    e[o] = On(o, !1, !1), n[o] = On(o, !0, !1), t[o] = On(o, !1, !0), i[o] = On(o, !0, !0);
  }), [
    e,
    n,
    t,
    i
  ];
}
const [Rl, Ll, Pl, jl] = /* @__PURE__ */ Bl();
function us(e, t) {
  const n = t ? e ? jl : Pl : e ? Ll : Rl;
  return (i, s, o) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? i : Reflect.get(oe(n, s) && s in i ? n : i, s, o);
}
const Fl = {
  get: /* @__PURE__ */ us(!1, !1)
}, Ul = {
  get: /* @__PURE__ */ us(!1, !0)
}, zl = {
  get: /* @__PURE__ */ us(!0, !1)
}, br = /* @__PURE__ */ new WeakMap(), xr = /* @__PURE__ */ new WeakMap(), _r = /* @__PURE__ */ new WeakMap(), Hl = /* @__PURE__ */ new WeakMap();
function Vl(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function ql(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Vl(ml(e));
}
function si(e) {
  return Wt(e) ? e : fs(e, !1, hr, Fl, br);
}
function Wl(e) {
  return fs(e, !1, Ml, Ul, xr);
}
function ms(e) {
  return fs(e, !0, Ol, zl, _r);
}
function fs(e, t, n, i, s) {
  if (!ge(e) || e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const o = s.get(e);
  if (o)
    return o;
  const r = ql(e);
  if (r === 0)
    return e;
  const a = new Proxy(e, r === 2 ? i : n);
  return s.set(e, a), a;
}
function bt(e) {
  return Wt(e) ? bt(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Wt(e) {
  return !!(e && e.__v_isReadonly);
}
function Kn(e) {
  return !!(e && e.__v_isShallow);
}
function Cr(e) {
  return bt(e) || Wt(e);
}
function ne(e) {
  const t = e && e.__v_raw;
  return t ? ne(t) : e;
}
function Zt(e) {
  return Wn(e, "__v_skip", !0), e;
}
const fn = (e) => ge(e) ? si(e) : e, gs = (e) => ge(e) ? ms(e) : e;
function yr(e) {
  ht && Ve && (e = ne(e), mr(e.dep || (e.dep = ls())));
}
function vr(e, t) {
  e = ne(e);
  const n = e.dep;
  n && zi(n);
}
function ye(e) {
  return !!(e && e.__v_isRef === !0);
}
function J(e) {
  return Zl(e, !1);
}
function Zl(e, t) {
  return ye(e) ? e : new Kl(e, t);
}
class Kl {
  constructor(t, n) {
    this.__v_isShallow = n, this.dep = void 0, this.__v_isRef = !0, this._rawValue = n ? t : ne(t), this._value = n ? t : fn(t);
  }
  get value() {
    return yr(this), this._value;
  }
  set value(t) {
    const n = this.__v_isShallow || Kn(t) || Wt(t);
    t = n ? t : ne(t), mn(t, this._rawValue) && (this._rawValue = t, this._value = n ? t : fn(t), vr(this));
  }
}
function _e(e) {
  return ye(e) ? e.value : e;
}
const Jl = {
  get: (e, t, n) => _e(Reflect.get(e, t, n)),
  set: (e, t, n, i) => {
    const s = e[t];
    return ye(s) && !ye(n) ? (s.value = n, !0) : Reflect.set(e, t, n, i);
  }
};
function wr(e) {
  return bt(e) ? e : new Proxy(e, Jl);
}
function Yl(e) {
  const t = q(e) ? new Array(e.length) : {};
  for (const n in e)
    t[n] = Ql(e, n);
  return t;
}
class Gl {
  constructor(t, n, i) {
    this._object = t, this._key = n, this._defaultValue = i, this.__v_isRef = !0;
  }
  get value() {
    const t = this._object[this._key];
    return t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return yl(ne(this._object), this._key);
  }
}
function Ql(e, t, n) {
  const i = e[t];
  return ye(i) ? i : new Gl(e, t, n);
}
var Ir;
class Xl {
  constructor(t, n, i, s) {
    this._setter = n, this.dep = void 0, this.__v_isRef = !0, this[Ir] = !1, this._dirty = !0, this.effect = new ds(t, () => {
      this._dirty || (this._dirty = !0, vr(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !s, this.__v_isReadonly = i;
  }
  get value() {
    const t = ne(this);
    return yr(t), (t._dirty || !t._cacheable) && (t._dirty = !1, t._value = t.effect.run()), t._value;
  }
  set value(t) {
    this._setter(t);
  }
}
Ir = "__v_isReadonly";
function ed(e, t, n = !1) {
  let i, s;
  const o = Y(e);
  return o ? (i = e, s = We) : (i = e.get, s = e.set), new Xl(i, s, o || !s, n);
}
function xt(e, t, n, i) {
  let s;
  try {
    s = i ? e(...i) : e();
  } catch (o) {
    oi(o, t, n);
  }
  return s;
}
function Ue(e, t, n, i) {
  if (Y(e)) {
    const o = xt(e, t, n, i);
    return o && ir(o) && o.catch((r) => {
      oi(r, t, n);
    }), o;
  }
  const s = [];
  for (let o = 0; o < e.length; o++)
    s.push(Ue(e[o], t, n, i));
  return s;
}
function oi(e, t, n, i = !0) {
  const s = t ? t.vnode : null;
  if (t) {
    let o = t.parent;
    const r = t.proxy, a = n;
    for (; o; ) {
      const d = o.ec;
      if (d) {
        for (let c = 0; c < d.length; c++)
          if (d[c](e, r, a) === !1)
            return;
      }
      o = o.parent;
    }
    const l = t.appContext.config.errorHandler;
    if (l) {
      xt(l, null, 10, [e, r, a]);
      return;
    }
  }
  td(e, n, s, i);
}
function td(e, t, n, i = !0) {
  console.error(e);
}
let gn = !1, Hi = !1;
const $e = [];
let Qe = 0;
const qt = [];
let nt = null, $t = 0;
const kr = /* @__PURE__ */ Promise.resolve();
let hs = null;
function vn(e) {
  const t = hs || kr;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function nd(e) {
  let t = Qe + 1, n = $e.length;
  for (; t < n; ) {
    const i = t + n >>> 1;
    hn($e[i]) < e ? t = i + 1 : n = i;
  }
  return t;
}
function bs(e) {
  (!$e.length || !$e.includes(e, gn && e.allowRecurse ? Qe + 1 : Qe)) && (e.id == null ? $e.push(e) : $e.splice(nd(e.id), 0, e), Ar());
}
function Ar() {
  !gn && !Hi && (Hi = !0, hs = kr.then(Tr));
}
function id(e) {
  const t = $e.indexOf(e);
  t > Qe && $e.splice(t, 1);
}
function sd(e) {
  q(e) ? qt.push(...e) : (!nt || !nt.includes(e, e.allowRecurse ? $t + 1 : $t)) && qt.push(e), Ar();
}
function lo(e, t = gn ? Qe + 1 : 0) {
  for (; t < $e.length; t++) {
    const n = $e[t];
    n && n.pre && ($e.splice(t, 1), t--, n());
  }
}
function Sr(e) {
  if (qt.length) {
    const t = [...new Set(qt)];
    if (qt.length = 0, nt) {
      nt.push(...t);
      return;
    }
    for (nt = t, nt.sort((n, i) => hn(n) - hn(i)), $t = 0; $t < nt.length; $t++)
      nt[$t]();
    nt = null, $t = 0;
  }
}
const hn = (e) => e.id == null ? 1 / 0 : e.id, od = (e, t) => {
  const n = hn(e) - hn(t);
  if (n === 0) {
    if (e.pre && !t.pre)
      return -1;
    if (t.pre && !e.pre)
      return 1;
  }
  return n;
};
function Tr(e) {
  Hi = !1, gn = !0, $e.sort(od);
  const t = We;
  try {
    for (Qe = 0; Qe < $e.length; Qe++) {
      const n = $e[Qe];
      n && n.active !== !1 && xt(
        n,
        null,
        14
        /* ErrorCodes.SCHEDULER */
      );
    }
  } finally {
    Qe = 0, $e.length = 0, Sr(), gn = !1, hs = null, ($e.length || qt.length) && Tr();
  }
}
function rd(e, t, ...n) {
  if (e.isUnmounted)
    return;
  const i = e.vnode.props || he;
  let s = n;
  const o = t.startsWith("update:"), r = o && t.slice(7);
  if (r && r in i) {
    const c = `${r === "modelValue" ? "model" : r}Modifiers`, { number: f, trim: h } = i[c] || he;
    h && (s = n.map((y) => Ie(y) ? y.trim() : y)), f && (s = n.map(hl));
  }
  let a, l = i[a = Ln(t)] || // also try camelCase event handler (#2249)
  i[a = Ln(Le(t))];
  !l && o && (l = i[a = Ln(Fe(t))]), l && Ue(l, e, 6, s);
  const d = i[a + "Once"];
  if (d) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Ue(d, e, 6, s);
  }
}
function $r(e, t, n = !1) {
  const i = t.emitsCache, s = i.get(e);
  if (s !== void 0)
    return s;
  const o = e.emits;
  let r = {}, a = !1;
  if (!Y(e)) {
    const l = (d) => {
      const c = $r(d, t, !0);
      c && (a = !0, Se(r, c));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !o && !a ? (ge(e) && i.set(e, null), null) : (q(o) ? o.forEach((l) => r[l] = null) : Se(r, o), ge(e) && i.set(e, r), r);
}
function ri(e, t) {
  return !e || !Xn(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), oe(e, t[0].toLowerCase() + t.slice(1)) || oe(e, Fe(t)) || oe(e, t));
}
let De = null, Dr = null;
function Jn(e) {
  const t = De;
  return De = e, Dr = e && e.type.__scopeId || null, t;
}
function Ae(e, t = De, n) {
  if (!t || e._n)
    return e;
  const i = (...s) => {
    i._d && _o(-1);
    const o = Jn(t);
    let r;
    try {
      r = e(...s);
    } finally {
      Jn(o), i._d && _o(1);
    }
    return r;
  };
  return i._n = !0, i._c = !0, i._d = !0, i;
}
function Ti(e) {
  const { type: t, vnode: n, proxy: i, withProxy: s, props: o, propsOptions: [r], slots: a, attrs: l, emit: d, render: c, renderCache: f, data: h, setupState: y, ctx: _, inheritAttrs: k } = e;
  let K, U;
  const ae = Jn(e);
  try {
    if (n.shapeFlag & 4) {
      const G = s || i;
      K = Ge(c.call(G, G, f, o, y, h, _)), U = l;
    } else {
      const G = t;
      K = Ge(G.length > 1 ? G(o, { attrs: l, slots: a, emit: d }) : G(
        o,
        null
        /* we know it doesn't need it */
      )), U = t.props ? l : ad(l);
    }
  } catch (G) {
    cn.length = 0, oi(
      G,
      e,
      1
      /* ErrorCodes.RENDER_FUNCTION */
    ), K = V(ze);
  }
  let P = K;
  if (U && k !== !1) {
    const G = Object.keys(U), { shapeFlag: se } = P;
    G.length && se & 7 && (r && G.some(ss) && (U = ld(U, r)), P = Ct(P, U));
  }
  return n.dirs && (P = Ct(P), P.dirs = P.dirs ? P.dirs.concat(n.dirs) : n.dirs), n.transition && (P.transition = n.transition), K = P, Jn(ae), K;
}
const ad = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || Xn(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, ld = (e, t) => {
  const n = {};
  for (const i in e)
    (!ss(i) || !(i.slice(9) in t)) && (n[i] = e[i]);
  return n;
};
function dd(e, t, n) {
  const { props: i, children: s, component: o } = e, { props: r, children: a, patchFlag: l } = t, d = o.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return i ? co(i, r, d) : !!r;
    if (l & 8) {
      const c = t.dynamicProps;
      for (let f = 0; f < c.length; f++) {
        const h = c[f];
        if (r[h] !== i[h] && !ri(d, h))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : i === r ? !1 : i ? r ? co(i, r, d) : !0 : !!r;
  return !1;
}
function co(e, t, n) {
  const i = Object.keys(t);
  if (i.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < i.length; s++) {
    const o = i[s];
    if (t[o] !== e[o] && !ri(n, o))
      return !0;
  }
  return !1;
}
function cd({ vnode: e, parent: t }, n) {
  for (; t && t.subTree === e; )
    (e = t.vnode).el = n, t = t.parent;
}
const pd = (e) => e.__isSuspense;
function ud(e, t) {
  t && t.pendingBranch ? q(e) ? t.effects.push(...e) : t.effects.push(e) : sd(e);
}
function md(e, t) {
  if (Ce) {
    let n = Ce.provides;
    const i = Ce.parent && Ce.parent.provides;
    i === n && (n = Ce.provides = Object.create(i)), n[e] = t;
  }
}
function an(e, t, n = !1) {
  const i = Ce || De;
  if (i) {
    const s = i.parent == null ? i.vnode.appContext && i.vnode.appContext.provides : i.parent.provides;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return n && Y(t) ? t.call(i.proxy) : t;
  }
}
const Mn = {};
function Ze(e, t, n) {
  return Nr(e, t, n);
}
function Nr(e, t, { immediate: n, deep: i, flush: s, onTrack: o, onTrigger: r } = he) {
  const a = lr() === (Ce == null ? void 0 : Ce.scope) ? Ce : null;
  let l, d = !1, c = !1;
  if (ye(e) ? (l = () => e.value, d = Kn(e)) : bt(e) ? (l = () => e, i = !0) : q(e) ? (c = !0, d = e.some((P) => bt(P) || Kn(P)), l = () => e.map((P) => {
    if (ye(P))
      return P.value;
    if (bt(P))
      return jt(P);
    if (Y(P))
      return xt(
        P,
        a,
        2
        /* ErrorCodes.WATCH_GETTER */
      );
  })) : Y(e) ? t ? l = () => xt(
    e,
    a,
    2
    /* ErrorCodes.WATCH_GETTER */
  ) : l = () => {
    if (!(a && a.isUnmounted))
      return f && f(), Ue(e, a, 3, [h]);
  } : l = We, t && i) {
    const P = l;
    l = () => jt(P());
  }
  let f, h = (P) => {
    f = U.onStop = () => {
      xt(
        P,
        a,
        4
        /* ErrorCodes.WATCH_CLEANUP */
      );
    };
  }, y;
  if (Cn)
    if (h = We, t ? n && Ue(t, a, 3, [
      l(),
      c ? [] : void 0,
      h
    ]) : l(), s === "sync") {
      const P = sc();
      y = P.__watcherHandles || (P.__watcherHandles = []);
    } else
      return We;
  let _ = c ? new Array(e.length).fill(Mn) : Mn;
  const k = () => {
    if (U.active)
      if (t) {
        const P = U.run();
        (i || d || (c ? P.some((G, se) => mn(G, _[se])) : mn(P, _))) && (f && f(), Ue(t, a, 3, [
          P,
          // pass undefined as the old value when it's changed for the first time
          _ === Mn ? void 0 : c && _[0] === Mn ? [] : _,
          h
        ]), _ = P);
      } else
        U.run();
  };
  k.allowRecurse = !!t;
  let K;
  s === "sync" ? K = k : s === "post" ? K = () => Ee(k, a && a.suspense) : (k.pre = !0, a && (k.id = a.uid), K = () => bs(k));
  const U = new ds(l, K);
  t ? n ? k() : _ = U.run() : s === "post" ? Ee(U.run.bind(U), a && a.suspense) : U.run();
  const ae = () => {
    U.stop(), a && a.scope && os(a.scope.effects, U);
  };
  return y && y.push(ae), ae;
}
function fd(e, t, n) {
  const i = this.proxy, s = Ie(e) ? e.includes(".") ? Er(i, e) : () => i[e] : e.bind(i, i);
  let o;
  Y(t) ? o = t : (o = t.handler, n = t);
  const r = Ce;
  Kt(this);
  const a = Nr(s, o.bind(i), n);
  return r ? Kt(r) : Ot(), a;
}
function Er(e, t) {
  const n = t.split(".");
  return () => {
    let i = e;
    for (let s = 0; s < n.length && i; s++)
      i = i[n[s]];
    return i;
  };
}
function jt(e, t) {
  if (!ge(e) || e.__v_skip || (t = t || /* @__PURE__ */ new Set(), t.has(e)))
    return e;
  if (t.add(e), ye(e))
    jt(e.value, t);
  else if (q(e))
    for (let n = 0; n < e.length; n++)
      jt(e[n], t);
  else if (nr(e) || Vt(e))
    e.forEach((n) => {
      jt(n, t);
    });
  else if (or(e))
    for (const n in e)
      jt(e[n], t);
  return e;
}
function Or() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return at(() => {
    e.isMounted = !0;
  }), Lr(() => {
    e.isUnmounting = !0;
  }), e;
}
const je = [Function, Array], gd = {
  name: "BaseTransition",
  props: {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: je,
    onEnter: je,
    onAfterEnter: je,
    onEnterCancelled: je,
    // leave
    onBeforeLeave: je,
    onLeave: je,
    onAfterLeave: je,
    onLeaveCancelled: je,
    // appear
    onBeforeAppear: je,
    onAppear: je,
    onAfterAppear: je,
    onAppearCancelled: je
  },
  setup(e, { slots: t }) {
    const n = ks(), i = Or();
    let s;
    return () => {
      const o = t.default && xs(t.default(), !0);
      if (!o || !o.length)
        return;
      let r = o[0];
      if (o.length > 1) {
        for (const k of o)
          if (k.type !== ze) {
            r = k;
            break;
          }
      }
      const a = ne(e), { mode: l } = a;
      if (i.isLeaving)
        return $i(r);
      const d = po(r);
      if (!d)
        return $i(r);
      const c = bn(d, a, i, n);
      xn(d, c);
      const f = n.subTree, h = f && po(f);
      let y = !1;
      const { getTransitionKey: _ } = d.type;
      if (_) {
        const k = _();
        s === void 0 ? s = k : k !== s && (s = k, y = !0);
      }
      if (h && h.type !== ze && (!Dt(d, h) || y)) {
        const k = bn(h, a, i, n);
        if (xn(h, k), l === "out-in")
          return i.isLeaving = !0, k.afterLeave = () => {
            i.isLeaving = !1, n.update.active !== !1 && n.update();
          }, $i(r);
        l === "in-out" && d.type !== ze && (k.delayLeave = (K, U, ae) => {
          const P = Br(i, h);
          P[String(h.key)] = h, K._leaveCb = () => {
            U(), K._leaveCb = void 0, delete c.delayedLeave;
          }, c.delayedLeave = ae;
        });
      }
      return r;
    };
  }
}, Mr = gd;
function Br(e, t) {
  const { leavingVNodes: n } = e;
  let i = n.get(t.type);
  return i || (i = /* @__PURE__ */ Object.create(null), n.set(t.type, i)), i;
}
function bn(e, t, n, i) {
  const { appear: s, mode: o, persisted: r = !1, onBeforeEnter: a, onEnter: l, onAfterEnter: d, onEnterCancelled: c, onBeforeLeave: f, onLeave: h, onAfterLeave: y, onLeaveCancelled: _, onBeforeAppear: k, onAppear: K, onAfterAppear: U, onAppearCancelled: ae } = t, P = String(e.key), G = Br(n, e), se = (O, B) => {
    O && Ue(O, i, 9, B);
  }, be = (O, B) => {
    const N = B[1];
    se(O, B), q(O) ? O.every((Q) => Q.length <= 1) && N() : O.length <= 1 && N();
  }, ee = {
    mode: o,
    persisted: r,
    beforeEnter(O) {
      let B = a;
      if (!n.isMounted)
        if (s)
          B = k || a;
        else
          return;
      O._leaveCb && O._leaveCb(
        !0
        /* cancelled */
      );
      const N = G[P];
      N && Dt(e, N) && N.el._leaveCb && N.el._leaveCb(), se(B, [O]);
    },
    enter(O) {
      let B = l, N = d, Q = c;
      if (!n.isMounted)
        if (s)
          B = K || l, N = U || d, Q = ae || c;
        else
          return;
      let R = !1;
      const ce = O._enterCb = (F) => {
        R || (R = !0, F ? se(Q, [O]) : se(N, [O]), ee.delayedLeave && ee.delayedLeave(), O._enterCb = void 0);
      };
      B ? be(B, [O, ce]) : ce();
    },
    leave(O, B) {
      const N = String(e.key);
      if (O._enterCb && O._enterCb(
        !0
        /* cancelled */
      ), n.isUnmounting)
        return B();
      se(f, [O]);
      let Q = !1;
      const R = O._leaveCb = (ce) => {
        Q || (Q = !0, B(), ce ? se(_, [O]) : se(y, [O]), O._leaveCb = void 0, G[N] === e && delete G[N]);
      };
      G[N] = e, h ? be(h, [O, R]) : R();
    },
    clone(O) {
      return bn(O, t, n, i);
    }
  };
  return ee;
}
function $i(e) {
  if (ai(e))
    return e = Ct(e), e.children = null, e;
}
function po(e) {
  return ai(e) ? e.children ? e.children[0] : void 0 : e;
}
function xn(e, t) {
  e.shapeFlag & 6 && e.component ? xn(e.component.subTree, t) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function xs(e, t = !1, n) {
  let i = [], s = 0;
  for (let o = 0; o < e.length; o++) {
    let r = e[o];
    const a = n == null ? r.key : String(n) + String(r.key != null ? r.key : o);
    r.type === X ? (r.patchFlag & 128 && s++, i = i.concat(xs(r.children, t, a))) : (t || r.type !== ze) && i.push(a != null ? Ct(r, { key: a }) : r);
  }
  if (s > 1)
    for (let o = 0; o < i.length; o++)
      i[o].patchFlag = -2;
  return i;
}
function Z(e) {
  return Y(e) ? { setup: e, name: e.name } : e;
}
const ln = (e) => !!e.type.__asyncLoader, ai = (e) => e.type.__isKeepAlive;
function hd(e, t) {
  Rr(e, "a", t);
}
function bd(e, t) {
  Rr(e, "da", t);
}
function Rr(e, t, n = Ce) {
  const i = e.__wdc || (e.__wdc = () => {
    let s = n;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return e();
  });
  if (li(t, i, n), n) {
    let s = n.parent;
    for (; s && s.parent; )
      ai(s.parent.vnode) && xd(i, t, n, s), s = s.parent;
  }
}
function xd(e, t, n, i) {
  const s = li(
    t,
    e,
    i,
    !0
    /* prepend */
  );
  Qt(() => {
    os(i[t], s);
  }, n);
}
function li(e, t, n = Ce, i = !1) {
  if (n) {
    const s = n[e] || (n[e] = []), o = t.__weh || (t.__weh = (...r) => {
      if (n.isUnmounted)
        return;
      Yt(), Kt(n);
      const a = Ue(t, n, e, r);
      return Ot(), Gt(), a;
    });
    return i ? s.unshift(o) : s.push(o), o;
  }
}
const rt = (e) => (t, n = Ce) => (
  // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
  (!Cn || e === "sp") && li(e, (...i) => t(...i), n)
), _d = rt(
  "bm"
  /* LifecycleHooks.BEFORE_MOUNT */
), at = rt(
  "m"
  /* LifecycleHooks.MOUNTED */
), Cd = rt(
  "bu"
  /* LifecycleHooks.BEFORE_UPDATE */
), _s = rt(
  "u"
  /* LifecycleHooks.UPDATED */
), Lr = rt(
  "bum"
  /* LifecycleHooks.BEFORE_UNMOUNT */
), Qt = rt(
  "um"
  /* LifecycleHooks.UNMOUNTED */
), yd = rt(
  "sp"
  /* LifecycleHooks.SERVER_PREFETCH */
), vd = rt(
  "rtg"
  /* LifecycleHooks.RENDER_TRIGGERED */
), wd = rt(
  "rtc"
  /* LifecycleHooks.RENDER_TRACKED */
);
function Id(e, t = Ce) {
  li("ec", e, t);
}
function kt(e, t, n, i) {
  const s = e.dirs, o = t && t.dirs;
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    o && (a.oldValue = o[r].value);
    let l = a.dir[i];
    l && (Yt(), Ue(l, n, 8, [
      e.el,
      a,
      e,
      t
    ]), Gt());
  }
}
const Cs = "components";
function ie(e, t) {
  return jr(Cs, e, !0, t) || e;
}
const Pr = Symbol();
function di(e) {
  return Ie(e) ? jr(Cs, e, !1) || e : e || Pr;
}
function jr(e, t, n = !0, i = !1) {
  const s = De || Ce;
  if (s) {
    const o = s.type;
    if (e === Cs) {
      const a = ec(
        o,
        !1
        /* do not include inferred name to avoid breaking existing code */
      );
      if (a && (a === t || a === Le(t) || a === ni(Le(t))))
        return o;
    }
    const r = (
      // local registration
      // check instance[type] first which is resolved for options API
      uo(s[e] || o[e], t) || // global registration
      uo(s.appContext[e], t)
    );
    return !r && i ? o : r;
  }
}
function uo(e, t) {
  return e && (e[t] || e[Le(t)] || e[ni(Le(t))]);
}
function Bt(e, t, n, i) {
  let s;
  const o = n && n[i];
  if (q(e) || Ie(e)) {
    s = new Array(e.length);
    for (let r = 0, a = e.length; r < a; r++)
      s[r] = t(e[r], r, void 0, o && o[r]);
  } else if (typeof e == "number") {
    s = new Array(e);
    for (let r = 0; r < e; r++)
      s[r] = t(r + 1, r, void 0, o && o[r]);
  } else if (ge(e))
    if (e[Symbol.iterator])
      s = Array.from(e, (r, a) => t(r, a, void 0, o && o[a]));
    else {
      const r = Object.keys(e);
      s = new Array(r.length);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s[a] = t(e[d], d, a, o && o[a]);
      }
    }
  else
    s = [];
  return n && (n[i] = s), s;
}
function kd(e, t) {
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    if (q(i))
      for (let s = 0; s < i.length; s++)
        e[i[s].name] = i[s].fn;
    else
      i && (e[i.name] = i.key ? (...s) => {
        const o = i.fn(...s);
        return o && (o.key = i.key), o;
      } : i.fn);
  }
  return e;
}
function fe(e, t, n = {}, i, s) {
  if (De.isCE || De.parent && ln(De.parent) && De.parent.isCE)
    return t !== "default" && (n.name = t), V("slot", n, i && i());
  let o = e[t];
  o && o._c && (o._d = !1), u();
  const r = o && Fr(o(n)), a = le(
    X,
    {
      key: n.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      r && r.key || `_${t}`
    },
    r || (i ? i() : []),
    r && e._ === 1 ? 64 : -2
    /* PatchFlags.BAIL */
  );
  return !s && a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), o && o._c && (o._d = !0), a;
}
function Fr(e) {
  return e.some((t) => Gn(t) ? !(t.type === ze || t.type === X && !Fr(t.children)) : !0) ? e : null;
}
function Ad(e, t) {
  const n = {};
  for (const i in e)
    n[t && /[A-Z]/.test(i) ? `on:${i}` : Ln(i)] = e[i];
  return n;
}
const Vi = (e) => e ? Gr(e) ? As(e) || e.proxy : Vi(e.parent) : null, dn = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Se(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => Vi(e.parent),
    $root: (e) => Vi(e.root),
    $emit: (e) => e.emit,
    $options: (e) => ys(e),
    $forceUpdate: (e) => e.f || (e.f = () => bs(e.update)),
    $nextTick: (e) => e.n || (e.n = vn.bind(e.proxy)),
    $watch: (e) => fd.bind(e)
  })
), Di = (e, t) => e !== he && !e.__isScriptSetup && oe(e, t), Sd = {
  get({ _: e }, t) {
    const { ctx: n, setupState: i, data: s, props: o, accessCache: r, type: a, appContext: l } = e;
    let d;
    if (t[0] !== "$") {
      const y = r[t];
      if (y !== void 0)
        switch (y) {
          case 1:
            return i[t];
          case 2:
            return s[t];
          case 4:
            return n[t];
          case 3:
            return o[t];
        }
      else {
        if (Di(i, t))
          return r[t] = 1, i[t];
        if (s !== he && oe(s, t))
          return r[t] = 2, s[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (d = e.propsOptions[0]) && oe(d, t)
        )
          return r[t] = 3, o[t];
        if (n !== he && oe(n, t))
          return r[t] = 4, n[t];
        qi && (r[t] = 0);
      }
    }
    const c = dn[t];
    let f, h;
    if (c)
      return t === "$attrs" && Me(e, "get", t), c(e);
    if (
      // css module (injected by vue-loader)
      (f = a.__cssModules) && (f = f[t])
    )
      return f;
    if (n !== he && oe(n, t))
      return r[t] = 4, n[t];
    if (
      // global properties
      h = l.config.globalProperties, oe(h, t)
    )
      return h[t];
  },
  set({ _: e }, t, n) {
    const { data: i, setupState: s, ctx: o } = e;
    return Di(s, t) ? (s[t] = n, !0) : i !== he && oe(i, t) ? (i[t] = n, !0) : oe(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (o[t] = n, !0);
  },
  has({ _: { data: e, setupState: t, accessCache: n, ctx: i, appContext: s, propsOptions: o } }, r) {
    let a;
    return !!n[r] || e !== he && oe(e, r) || Di(t, r) || (a = o[0]) && oe(a, r) || oe(i, r) || oe(dn, r) || oe(s.config.globalProperties, r);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : oe(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
let qi = !0;
function Td(e) {
  const t = ys(e), n = e.proxy, i = e.ctx;
  qi = !1, t.beforeCreate && mo(
    t.beforeCreate,
    e,
    "bc"
    /* LifecycleHooks.BEFORE_CREATE */
  );
  const {
    // state
    data: s,
    computed: o,
    methods: r,
    watch: a,
    provide: l,
    inject: d,
    // lifecycle
    created: c,
    beforeMount: f,
    mounted: h,
    beforeUpdate: y,
    updated: _,
    activated: k,
    deactivated: K,
    beforeDestroy: U,
    beforeUnmount: ae,
    destroyed: P,
    unmounted: G,
    render: se,
    renderTracked: be,
    renderTriggered: ee,
    errorCaptured: O,
    serverPrefetch: B,
    // public API
    expose: N,
    inheritAttrs: Q,
    // assets
    components: R,
    directives: ce,
    filters: F
  } = t;
  if (d && $d(d, i, null, e.appContext.config.unwrapInjectedRef), r)
    for (const xe in r) {
      const pe = r[xe];
      Y(pe) && (i[xe] = pe.bind(n));
    }
  if (s) {
    const xe = s.call(n, n);
    ge(xe) && (e.data = si(xe));
  }
  if (qi = !0, o)
    for (const xe in o) {
      const pe = o[xe], wt = Y(pe) ? pe.bind(n, n) : Y(pe.get) ? pe.get.bind(n, n) : We, Sn = !Y(pe) && Y(pe.set) ? pe.set.bind(n) : We, It = D({
        get: wt,
        set: Sn
      });
      Object.defineProperty(i, xe, {
        enumerable: !0,
        configurable: !0,
        get: () => It.value,
        set: (Ke) => It.value = Ke
      });
    }
  if (a)
    for (const xe in a)
      Ur(a[xe], i, n, xe);
  if (l) {
    const xe = Y(l) ? l.call(n) : l;
    Reflect.ownKeys(xe).forEach((pe) => {
      md(pe, xe[pe]);
    });
  }
  c && mo(
    c,
    e,
    "c"
    /* LifecycleHooks.CREATED */
  );
  function ve(xe, pe) {
    q(pe) ? pe.forEach((wt) => xe(wt.bind(n))) : pe && xe(pe.bind(n));
  }
  if (ve(_d, f), ve(at, h), ve(Cd, y), ve(_s, _), ve(hd, k), ve(bd, K), ve(Id, O), ve(wd, be), ve(vd, ee), ve(Lr, ae), ve(Qt, G), ve(yd, B), q(N))
    if (N.length) {
      const xe = e.exposed || (e.exposed = {});
      N.forEach((pe) => {
        Object.defineProperty(xe, pe, {
          get: () => n[pe],
          set: (wt) => n[pe] = wt
        });
      });
    } else
      e.exposed || (e.exposed = {});
  se && e.render === We && (e.render = se), Q != null && (e.inheritAttrs = Q), R && (e.components = R), ce && (e.directives = ce);
}
function $d(e, t, n = We, i = !1) {
  q(e) && (e = Wi(e));
  for (const s in e) {
    const o = e[s];
    let r;
    ge(o) ? "default" in o ? r = an(
      o.from || s,
      o.default,
      !0
      /* treat default function as factory */
    ) : r = an(o.from || s) : r = an(o), ye(r) && i ? Object.defineProperty(t, s, {
      enumerable: !0,
      configurable: !0,
      get: () => r.value,
      set: (a) => r.value = a
    }) : t[s] = r;
  }
}
function mo(e, t, n) {
  Ue(q(e) ? e.map((i) => i.bind(t.proxy)) : e.bind(t.proxy), t, n);
}
function Ur(e, t, n, i) {
  const s = i.includes(".") ? Er(n, i) : () => n[i];
  if (Ie(e)) {
    const o = t[e];
    Y(o) && Ze(s, o);
  } else if (Y(e))
    Ze(s, e.bind(n));
  else if (ge(e))
    if (q(e))
      e.forEach((o) => Ur(o, t, n, i));
    else {
      const o = Y(e.handler) ? e.handler.bind(n) : t[e.handler];
      Y(o) && Ze(s, o, e);
    }
}
function ys(e) {
  const t = e.type, { mixins: n, extends: i } = t, { mixins: s, optionsCache: o, config: { optionMergeStrategies: r } } = e.appContext, a = o.get(t);
  let l;
  return a ? l = a : !s.length && !n && !i ? l = t : (l = {}, s.length && s.forEach((d) => Yn(l, d, r, !0)), Yn(l, t, r)), ge(t) && o.set(t, l), l;
}
function Yn(e, t, n, i = !1) {
  const { mixins: s, extends: o } = t;
  o && Yn(e, o, n, !0), s && s.forEach((r) => Yn(e, r, n, !0));
  for (const r in t)
    if (!(i && r === "expose")) {
      const a = Dd[r] || n && n[r];
      e[r] = a ? a(e[r], t[r]) : t[r];
    }
  return e;
}
const Dd = {
  data: fo,
  props: Tt,
  emits: Tt,
  // objects
  methods: Tt,
  computed: Tt,
  // lifecycle
  beforeCreate: Ne,
  created: Ne,
  beforeMount: Ne,
  mounted: Ne,
  beforeUpdate: Ne,
  updated: Ne,
  beforeDestroy: Ne,
  beforeUnmount: Ne,
  destroyed: Ne,
  unmounted: Ne,
  activated: Ne,
  deactivated: Ne,
  errorCaptured: Ne,
  serverPrefetch: Ne,
  // assets
  components: Tt,
  directives: Tt,
  // watch
  watch: Ed,
  // provide / inject
  provide: fo,
  inject: Nd
};
function fo(e, t) {
  return t ? e ? function() {
    return Se(Y(e) ? e.call(this, this) : e, Y(t) ? t.call(this, this) : t);
  } : t : e;
}
function Nd(e, t) {
  return Tt(Wi(e), Wi(t));
}
function Wi(e) {
  if (q(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Ne(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Tt(e, t) {
  return e ? Se(Se(/* @__PURE__ */ Object.create(null), e), t) : t;
}
function Ed(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  const n = Se(/* @__PURE__ */ Object.create(null), e);
  for (const i in t)
    n[i] = Ne(e[i], t[i]);
  return n;
}
function Od(e, t, n, i = !1) {
  const s = {}, o = {};
  Wn(o, pi, 1), e.propsDefaults = /* @__PURE__ */ Object.create(null), zr(e, t, s, o);
  for (const r in e.propsOptions[0])
    r in s || (s[r] = void 0);
  n ? e.props = i ? s : Wl(s) : e.type.props ? e.props = s : e.props = o, e.attrs = o;
}
function Md(e, t, n, i) {
  const { props: s, attrs: o, vnode: { patchFlag: r } } = e, a = ne(s), [l] = e.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (i || r > 0) && !(r & 16)
  ) {
    if (r & 8) {
      const c = e.vnode.dynamicProps;
      for (let f = 0; f < c.length; f++) {
        let h = c[f];
        if (ri(e.emitsOptions, h))
          continue;
        const y = t[h];
        if (l)
          if (oe(o, h))
            y !== o[h] && (o[h] = y, d = !0);
          else {
            const _ = Le(h);
            s[_] = Zi(
              l,
              a,
              _,
              y,
              e,
              !1
              /* isAbsent */
            );
          }
        else
          y !== o[h] && (o[h] = y, d = !0);
      }
    }
  } else {
    zr(e, t, s, o) && (d = !0);
    let c;
    for (const f in a)
      (!t || // for camelCase
      !oe(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = Fe(f)) === f || !oe(t, c))) && (l ? n && // for camelCase
      (n[f] !== void 0 || // for kebab-case
      n[c] !== void 0) && (s[f] = Zi(
        l,
        a,
        f,
        void 0,
        e,
        !0
        /* isAbsent */
      )) : delete s[f]);
    if (o !== a)
      for (const f in o)
        (!t || !oe(t, f)) && (delete o[f], d = !0);
  }
  d && st(e, "set", "$attrs");
}
function zr(e, t, n, i) {
  const [s, o] = e.propsOptions;
  let r = !1, a;
  if (t)
    for (let l in t) {
      if (Rn(l))
        continue;
      const d = t[l];
      let c;
      s && oe(s, c = Le(l)) ? !o || !o.includes(c) ? n[c] = d : (a || (a = {}))[c] = d : ri(e.emitsOptions, l) || (!(l in i) || d !== i[l]) && (i[l] = d, r = !0);
    }
  if (o) {
    const l = ne(n), d = a || he;
    for (let c = 0; c < o.length; c++) {
      const f = o[c];
      n[f] = Zi(s, l, f, d[f], e, !oe(d, f));
    }
  }
  return r;
}
function Zi(e, t, n, i, s, o) {
  const r = e[n];
  if (r != null) {
    const a = oe(r, "default");
    if (a && i === void 0) {
      const l = r.default;
      if (r.type !== Function && Y(l)) {
        const { propsDefaults: d } = s;
        n in d ? i = d[n] : (Kt(s), i = d[n] = l.call(null, t), Ot());
      } else
        i = l;
    }
    r[
      0
      /* BooleanFlags.shouldCast */
    ] && (o && !a ? i = !1 : r[
      1
      /* BooleanFlags.shouldCastTrue */
    ] && (i === "" || i === Fe(n)) && (i = !0));
  }
  return i;
}
function Hr(e, t, n = !1) {
  const i = t.propsCache, s = i.get(e);
  if (s)
    return s;
  const o = e.props, r = {}, a = [];
  let l = !1;
  if (!Y(e)) {
    const c = (f) => {
      l = !0;
      const [h, y] = Hr(f, t, !0);
      Se(r, h), y && a.push(...y);
    };
    !n && t.mixins.length && t.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  if (!o && !l)
    return ge(e) && i.set(e, Ht), Ht;
  if (q(o))
    for (let c = 0; c < o.length; c++) {
      const f = Le(o[c]);
      go(f) && (r[f] = he);
    }
  else if (o)
    for (const c in o) {
      const f = Le(c);
      if (go(f)) {
        const h = o[c], y = r[f] = q(h) || Y(h) ? { type: h } : Object.assign({}, h);
        if (y) {
          const _ = xo(Boolean, y.type), k = xo(String, y.type);
          y[
            0
            /* BooleanFlags.shouldCast */
          ] = _ > -1, y[
            1
            /* BooleanFlags.shouldCastTrue */
          ] = k < 0 || _ < k, (_ > -1 || oe(y, "default")) && a.push(f);
        }
      }
    }
  const d = [r, a];
  return ge(e) && i.set(e, d), d;
}
function go(e) {
  return e[0] !== "$";
}
function ho(e) {
  const t = e && e.toString().match(/^\s*(function|class) (\w+)/);
  return t ? t[2] : e === null ? "null" : "";
}
function bo(e, t) {
  return ho(e) === ho(t);
}
function xo(e, t) {
  return q(t) ? t.findIndex((n) => bo(n, e)) : Y(t) && bo(t, e) ? 0 : -1;
}
const Vr = (e) => e[0] === "_" || e === "$stable", vs = (e) => q(e) ? e.map(Ge) : [Ge(e)], Bd = (e, t, n) => {
  if (t._n)
    return t;
  const i = Ae((...s) => vs(t(...s)), n);
  return i._c = !1, i;
}, qr = (e, t, n) => {
  const i = e._ctx;
  for (const s in e) {
    if (Vr(s))
      continue;
    const o = e[s];
    if (Y(o))
      t[s] = Bd(s, o, i);
    else if (o != null) {
      const r = vs(o);
      t[s] = () => r;
    }
  }
}, Wr = (e, t) => {
  const n = vs(t);
  e.slots.default = () => n;
}, Rd = (e, t) => {
  if (e.vnode.shapeFlag & 32) {
    const n = t._;
    n ? (e.slots = ne(t), Wn(t, "_", n)) : qr(t, e.slots = {});
  } else
    e.slots = {}, t && Wr(e, t);
  Wn(e.slots, pi, 1);
}, Ld = (e, t, n) => {
  const { vnode: i, slots: s } = e;
  let o = !0, r = he;
  if (i.shapeFlag & 32) {
    const a = t._;
    a ? n && a === 1 ? o = !1 : (Se(s, t), !n && a === 1 && delete s._) : (o = !t.$stable, qr(t, s)), r = t;
  } else
    t && (Wr(e, t), r = { default: 1 });
  if (o)
    for (const a in s)
      !Vr(a) && !(a in r) && delete s[a];
};
function Zr() {
  return {
    app: null,
    config: {
      isNativeTag: cl,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Pd = 0;
function jd(e, t) {
  return function(i, s = null) {
    Y(i) || (i = Object.assign({}, i)), s != null && !ge(s) && (s = null);
    const o = Zr(), r = /* @__PURE__ */ new Set();
    let a = !1;
    const l = o.app = {
      _uid: Pd++,
      _component: i,
      _props: s,
      _container: null,
      _context: o,
      _instance: null,
      version: oc,
      get config() {
        return o.config;
      },
      set config(d) {
      },
      use(d, ...c) {
        return r.has(d) || (d && Y(d.install) ? (r.add(d), d.install(l, ...c)) : Y(d) && (r.add(d), d(l, ...c))), l;
      },
      mixin(d) {
        return o.mixins.includes(d) || o.mixins.push(d), l;
      },
      component(d, c) {
        return c ? (o.components[d] = c, l) : o.components[d];
      },
      directive(d, c) {
        return c ? (o.directives[d] = c, l) : o.directives[d];
      },
      mount(d, c, f) {
        if (!a) {
          const h = V(i, s);
          return h.appContext = o, c && t ? t(h, d) : e(h, d, f), a = !0, l._container = d, d.__vue_app__ = l, As(h.component) || h.component.proxy;
        }
      },
      unmount() {
        a && (e(null, l._container), delete l._container.__vue_app__);
      },
      provide(d, c) {
        return o.provides[d] = c, l;
      }
    };
    return l;
  };
}
function Ki(e, t, n, i, s = !1) {
  if (q(e)) {
    e.forEach((h, y) => Ki(h, t && (q(t) ? t[y] : t), n, i, s));
    return;
  }
  if (ln(i) && !s)
    return;
  const o = i.shapeFlag & 4 ? As(i.component) || i.component.proxy : i.el, r = s ? null : o, { i: a, r: l } = e, d = t && t.r, c = a.refs === he ? a.refs = {} : a.refs, f = a.setupState;
  if (d != null && d !== l && (Ie(d) ? (c[d] = null, oe(f, d) && (f[d] = null)) : ye(d) && (d.value = null)), Y(l))
    xt(l, a, 12, [r, c]);
  else {
    const h = Ie(l), y = ye(l);
    if (h || y) {
      const _ = () => {
        if (e.f) {
          const k = h ? oe(f, l) ? f[l] : c[l] : l.value;
          s ? q(k) && os(k, o) : q(k) ? k.includes(o) || k.push(o) : h ? (c[l] = [o], oe(f, l) && (f[l] = c[l])) : (l.value = [o], e.k && (c[e.k] = l.value));
        } else
          h ? (c[l] = r, oe(f, l) && (f[l] = r)) : y && (l.value = r, e.k && (c[e.k] = r));
      };
      r ? (_.id = -1, Ee(_, n)) : _();
    }
  }
}
const Ee = ud;
function Fd(e) {
  return Ud(e);
}
function Ud(e, t) {
  const n = bl();
  n.__VUE__ = !0;
  const { insert: i, remove: s, patchProp: o, createElement: r, createText: a, createComment: l, setText: d, setElementText: c, parentNode: f, nextSibling: h, setScopeId: y = We, insertStaticContent: _ } = e, k = (p, m, x, w = null, v = null, T = null, E = !1, S = null, $ = !!m.dynamicChildren) => {
    if (p === m)
      return;
    p && !Dt(p, m) && (w = Tn(p), Ke(p, v, T, !0), p = null), m.patchFlag === -2 && ($ = !1, m.dynamicChildren = null);
    const { type: I, ref: z, shapeFlag: L } = m;
    switch (I) {
      case ci:
        K(p, m, x, w);
        break;
      case ze:
        U(p, m, x, w);
        break;
      case Pn:
        p == null && ae(m, x, w, E);
        break;
      case X:
        R(p, m, x, w, v, T, E, S, $);
        break;
      default:
        L & 1 ? se(p, m, x, w, v, T, E, S, $) : L & 6 ? ce(p, m, x, w, v, T, E, S, $) : (L & 64 || L & 128) && I.process(p, m, x, w, v, T, E, S, $, Rt);
    }
    z != null && v && Ki(z, p && p.ref, T, m || p, !m);
  }, K = (p, m, x, w) => {
    if (p == null)
      i(m.el = a(m.children), x, w);
    else {
      const v = m.el = p.el;
      m.children !== p.children && d(v, m.children);
    }
  }, U = (p, m, x, w) => {
    p == null ? i(m.el = l(m.children || ""), x, w) : m.el = p.el;
  }, ae = (p, m, x, w) => {
    [p.el, p.anchor] = _(p.children, m, x, w, p.el, p.anchor);
  }, P = ({ el: p, anchor: m }, x, w) => {
    let v;
    for (; p && p !== m; )
      v = h(p), i(p, x, w), p = v;
    i(m, x, w);
  }, G = ({ el: p, anchor: m }) => {
    let x;
    for (; p && p !== m; )
      x = h(p), s(p), p = x;
    s(m);
  }, se = (p, m, x, w, v, T, E, S, $) => {
    E = E || m.type === "svg", p == null ? be(m, x, w, v, T, E, S, $) : B(p, m, v, T, E, S, $);
  }, be = (p, m, x, w, v, T, E, S) => {
    let $, I;
    const { type: z, props: L, shapeFlag: H, transition: W, dirs: te } = p;
    if ($ = p.el = r(p.type, T, L && L.is, L), H & 8 ? c($, p.children) : H & 16 && O(p.children, $, null, w, v, T && z !== "foreignObject", E, S), te && kt(p, null, w, "created"), ee($, p, p.scopeId, E, w), L) {
      for (const de in L)
        de !== "value" && !Rn(de) && o($, de, null, L[de], T, p.children, w, v, et);
      "value" in L && o($, "value", null, L.value), (I = L.onVnodeBeforeMount) && Ye(I, w, p);
    }
    te && kt(p, null, w, "beforeMount");
    const ue = (!v || v && !v.pendingBranch) && W && !W.persisted;
    ue && W.beforeEnter($), i($, m, x), ((I = L && L.onVnodeMounted) || ue || te) && Ee(() => {
      I && Ye(I, w, p), ue && W.enter($), te && kt(p, null, w, "mounted");
    }, v);
  }, ee = (p, m, x, w, v) => {
    if (x && y(p, x), w)
      for (let T = 0; T < w.length; T++)
        y(p, w[T]);
    if (v) {
      let T = v.subTree;
      if (m === T) {
        const E = v.vnode;
        ee(p, E, E.scopeId, E.slotScopeIds, v.parent);
      }
    }
  }, O = (p, m, x, w, v, T, E, S, $ = 0) => {
    for (let I = $; I < p.length; I++) {
      const z = p[I] = S ? mt(p[I]) : Ge(p[I]);
      k(null, z, m, x, w, v, T, E, S);
    }
  }, B = (p, m, x, w, v, T, E) => {
    const S = m.el = p.el;
    let { patchFlag: $, dynamicChildren: I, dirs: z } = m;
    $ |= p.patchFlag & 16;
    const L = p.props || he, H = m.props || he;
    let W;
    x && At(x, !1), (W = H.onVnodeBeforeUpdate) && Ye(W, x, m, p), z && kt(m, p, x, "beforeUpdate"), x && At(x, !0);
    const te = v && m.type !== "foreignObject";
    if (I ? N(p.dynamicChildren, I, S, x, w, te, T) : E || pe(p, m, S, null, x, w, te, T, !1), $ > 0) {
      if ($ & 16)
        Q(S, m, L, H, x, w, v);
      else if ($ & 2 && L.class !== H.class && o(S, "class", null, H.class, v), $ & 4 && o(S, "style", L.style, H.style, v), $ & 8) {
        const ue = m.dynamicProps;
        for (let de = 0; de < ue.length; de++) {
          const we = ue[de], He = L[we], Lt = H[we];
          (Lt !== He || we === "value") && o(S, we, He, Lt, v, p.children, x, w, et);
        }
      }
      $ & 1 && p.children !== m.children && c(S, m.children);
    } else
      !E && I == null && Q(S, m, L, H, x, w, v);
    ((W = H.onVnodeUpdated) || z) && Ee(() => {
      W && Ye(W, x, m, p), z && kt(m, p, x, "updated");
    }, w);
  }, N = (p, m, x, w, v, T, E) => {
    for (let S = 0; S < m.length; S++) {
      const $ = p[S], I = m[S], z = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        $.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        ($.type === X || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Dt($, I) || // - In the case of a component, it could contain anything.
        $.shapeFlag & 70) ? f($.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          x
        )
      );
      k($, I, z, null, w, v, T, E, !0);
    }
  }, Q = (p, m, x, w, v, T, E) => {
    if (x !== w) {
      if (x !== he)
        for (const S in x)
          !Rn(S) && !(S in w) && o(p, S, x[S], null, E, m.children, v, T, et);
      for (const S in w) {
        if (Rn(S))
          continue;
        const $ = w[S], I = x[S];
        $ !== I && S !== "value" && o(p, S, I, $, E, m.children, v, T, et);
      }
      "value" in w && o(p, "value", x.value, w.value);
    }
  }, R = (p, m, x, w, v, T, E, S, $) => {
    const I = m.el = p ? p.el : a(""), z = m.anchor = p ? p.anchor : a("");
    let { patchFlag: L, dynamicChildren: H, slotScopeIds: W } = m;
    W && (S = S ? S.concat(W) : W), p == null ? (i(I, x, w), i(z, x, w), O(m.children, x, z, v, T, E, S, $)) : L > 0 && L & 64 && H && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    p.dynamicChildren ? (N(p.dynamicChildren, H, x, v, T, E, S), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (m.key != null || v && m === v.subTree) && Kr(
      p,
      m,
      !0
      /* shallow */
    )) : pe(p, m, x, z, v, T, E, S, $);
  }, ce = (p, m, x, w, v, T, E, S, $) => {
    m.slotScopeIds = S, p == null ? m.shapeFlag & 512 ? v.ctx.activate(m, x, w, E, $) : F(m, x, w, v, T, E, $) : me(p, m, $);
  }, F = (p, m, x, w, v, T, E) => {
    const S = p.component = Jd(p, w, v);
    if (ai(p) && (S.ctx.renderer = Rt), Yd(S), S.asyncDep) {
      if (v && v.registerDep(S, ve), !p.el) {
        const $ = S.subTree = V(ze);
        U(null, $, m, x);
      }
      return;
    }
    ve(S, p, m, x, v, T, E);
  }, me = (p, m, x) => {
    const w = m.component = p.component;
    if (dd(p, m, x))
      if (w.asyncDep && !w.asyncResolved) {
        xe(w, m, x);
        return;
      } else
        w.next = m, id(w.update), w.update();
    else
      m.el = p.el, w.vnode = m;
  }, ve = (p, m, x, w, v, T, E) => {
    const S = () => {
      if (p.isMounted) {
        let { next: z, bu: L, u: H, parent: W, vnode: te } = p, ue = z, de;
        At(p, !1), z ? (z.el = te.el, xe(p, z, E)) : z = te, L && Si(L), (de = z.props && z.props.onVnodeBeforeUpdate) && Ye(de, W, z, te), At(p, !0);
        const we = Ti(p), He = p.subTree;
        p.subTree = we, k(
          He,
          we,
          // parent may have changed if it's in a teleport
          f(He.el),
          // anchor may have changed if it's in a fragment
          Tn(He),
          p,
          v,
          T
        ), z.el = we.el, ue === null && cd(p, we.el), H && Ee(H, v), (de = z.props && z.props.onVnodeUpdated) && Ee(() => Ye(de, W, z, te), v);
      } else {
        let z;
        const { el: L, props: H } = m, { bm: W, m: te, parent: ue } = p, de = ln(m);
        if (At(p, !1), W && Si(W), !de && (z = H && H.onVnodeBeforeMount) && Ye(z, ue, m), At(p, !0), L && Ai) {
          const we = () => {
            p.subTree = Ti(p), Ai(L, p.subTree, p, v, null);
          };
          de ? m.type.__asyncLoader().then(
            // note: we are moving the render call into an async callback,
            // which means it won't track dependencies - but it's ok because
            // a server-rendered async wrapper is already in resolved state
            // and it will never need to change.
            () => !p.isUnmounted && we()
          ) : we();
        } else {
          const we = p.subTree = Ti(p);
          k(null, we, x, w, p, v, T), m.el = we.el;
        }
        if (te && Ee(te, v), !de && (z = H && H.onVnodeMounted)) {
          const we = m;
          Ee(() => Ye(z, ue, we), v);
        }
        (m.shapeFlag & 256 || ue && ln(ue.vnode) && ue.vnode.shapeFlag & 256) && p.a && Ee(p.a, v), p.isMounted = !0, m = x = w = null;
      }
    }, $ = p.effect = new ds(
      S,
      () => bs(I),
      p.scope
      // track it in component's effect scope
    ), I = p.update = () => $.run();
    I.id = p.uid, At(p, !0), I();
  }, xe = (p, m, x) => {
    m.component = p;
    const w = p.vnode.props;
    p.vnode = m, p.next = null, Md(p, m.props, w, x), Ld(p, m.children, x), Yt(), lo(), Gt();
  }, pe = (p, m, x, w, v, T, E, S, $ = !1) => {
    const I = p && p.children, z = p ? p.shapeFlag : 0, L = m.children, { patchFlag: H, shapeFlag: W } = m;
    if (H > 0) {
      if (H & 128) {
        Sn(I, L, x, w, v, T, E, S, $);
        return;
      } else if (H & 256) {
        wt(I, L, x, w, v, T, E, S, $);
        return;
      }
    }
    W & 8 ? (z & 16 && et(I, v, T), L !== I && c(x, L)) : z & 16 ? W & 16 ? Sn(I, L, x, w, v, T, E, S, $) : et(I, v, T, !0) : (z & 8 && c(x, ""), W & 16 && O(L, x, w, v, T, E, S, $));
  }, wt = (p, m, x, w, v, T, E, S, $) => {
    p = p || Ht, m = m || Ht;
    const I = p.length, z = m.length, L = Math.min(I, z);
    let H;
    for (H = 0; H < L; H++) {
      const W = m[H] = $ ? mt(m[H]) : Ge(m[H]);
      k(p[H], W, x, null, v, T, E, S, $);
    }
    I > z ? et(p, v, T, !0, !1, L) : O(m, x, w, v, T, E, S, $, L);
  }, Sn = (p, m, x, w, v, T, E, S, $) => {
    let I = 0;
    const z = m.length;
    let L = p.length - 1, H = z - 1;
    for (; I <= L && I <= H; ) {
      const W = p[I], te = m[I] = $ ? mt(m[I]) : Ge(m[I]);
      if (Dt(W, te))
        k(W, te, x, null, v, T, E, S, $);
      else
        break;
      I++;
    }
    for (; I <= L && I <= H; ) {
      const W = p[L], te = m[H] = $ ? mt(m[H]) : Ge(m[H]);
      if (Dt(W, te))
        k(W, te, x, null, v, T, E, S, $);
      else
        break;
      L--, H--;
    }
    if (I > L) {
      if (I <= H) {
        const W = H + 1, te = W < z ? m[W].el : w;
        for (; I <= H; )
          k(null, m[I] = $ ? mt(m[I]) : Ge(m[I]), x, te, v, T, E, S, $), I++;
      }
    } else if (I > H)
      for (; I <= L; )
        Ke(p[I], v, T, !0), I++;
    else {
      const W = I, te = I, ue = /* @__PURE__ */ new Map();
      for (I = te; I <= H; I++) {
        const Be = m[I] = $ ? mt(m[I]) : Ge(m[I]);
        Be.key != null && ue.set(Be.key, I);
      }
      let de, we = 0;
      const He = H - te + 1;
      let Lt = !1, Gs = 0;
      const tn = new Array(He);
      for (I = 0; I < He; I++)
        tn[I] = 0;
      for (I = W; I <= L; I++) {
        const Be = p[I];
        if (we >= He) {
          Ke(Be, v, T, !0);
          continue;
        }
        let Je;
        if (Be.key != null)
          Je = ue.get(Be.key);
        else
          for (de = te; de <= H; de++)
            if (tn[de - te] === 0 && Dt(Be, m[de])) {
              Je = de;
              break;
            }
        Je === void 0 ? Ke(Be, v, T, !0) : (tn[Je - te] = I + 1, Je >= Gs ? Gs = Je : Lt = !0, k(Be, m[Je], x, null, v, T, E, S, $), we++);
      }
      const Qs = Lt ? zd(tn) : Ht;
      for (de = Qs.length - 1, I = He - 1; I >= 0; I--) {
        const Be = te + I, Je = m[Be], Xs = Be + 1 < z ? m[Be + 1].el : w;
        tn[I] === 0 ? k(null, Je, x, Xs, v, T, E, S, $) : Lt && (de < 0 || I !== Qs[de] ? It(
          Je,
          x,
          Xs,
          2
          /* MoveType.REORDER */
        ) : de--);
      }
    }
  }, It = (p, m, x, w, v = null) => {
    const { el: T, type: E, transition: S, children: $, shapeFlag: I } = p;
    if (I & 6) {
      It(p.component.subTree, m, x, w);
      return;
    }
    if (I & 128) {
      p.suspense.move(m, x, w);
      return;
    }
    if (I & 64) {
      E.move(p, m, x, Rt);
      return;
    }
    if (E === X) {
      i(T, m, x);
      for (let L = 0; L < $.length; L++)
        It($[L], m, x, w);
      i(p.anchor, m, x);
      return;
    }
    if (E === Pn) {
      P(p, m, x);
      return;
    }
    if (w !== 2 && I & 1 && S)
      if (w === 0)
        S.beforeEnter(T), i(T, m, x), Ee(() => S.enter(T), v);
      else {
        const { leave: L, delayLeave: H, afterLeave: W } = S, te = () => i(T, m, x), ue = () => {
          L(T, () => {
            te(), W && W();
          });
        };
        H ? H(T, te, ue) : ue();
      }
    else
      i(T, m, x);
  }, Ke = (p, m, x, w = !1, v = !1) => {
    const { type: T, props: E, ref: S, children: $, dynamicChildren: I, shapeFlag: z, patchFlag: L, dirs: H } = p;
    if (S != null && Ki(S, null, x, p, !0), z & 256) {
      m.ctx.deactivate(p);
      return;
    }
    const W = z & 1 && H, te = !ln(p);
    let ue;
    if (te && (ue = E && E.onVnodeBeforeUnmount) && Ye(ue, m, p), z & 6)
      tl(p.component, x, w);
    else {
      if (z & 128) {
        p.suspense.unmount(x, w);
        return;
      }
      W && kt(p, null, m, "beforeUnmount"), z & 64 ? p.type.remove(p, m, x, v, Rt, w) : I && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (T !== X || L > 0 && L & 64) ? et(I, m, x, !1, !0) : (T === X && L & 384 || !v && z & 16) && et($, m, x), w && Js(p);
    }
    (te && (ue = E && E.onVnodeUnmounted) || W) && Ee(() => {
      ue && Ye(ue, m, p), W && kt(p, null, m, "unmounted");
    }, x);
  }, Js = (p) => {
    const { type: m, el: x, anchor: w, transition: v } = p;
    if (m === X) {
      el(x, w);
      return;
    }
    if (m === Pn) {
      G(p);
      return;
    }
    const T = () => {
      s(x), v && !v.persisted && v.afterLeave && v.afterLeave();
    };
    if (p.shapeFlag & 1 && v && !v.persisted) {
      const { leave: E, delayLeave: S } = v, $ = () => E(x, T);
      S ? S(p.el, T, $) : $();
    } else
      T();
  }, el = (p, m) => {
    let x;
    for (; p !== m; )
      x = h(p), s(p), p = x;
    s(m);
  }, tl = (p, m, x) => {
    const { bum: w, scope: v, update: T, subTree: E, um: S } = p;
    w && Si(w), v.stop(), T && (T.active = !1, Ke(E, p, m, x)), S && Ee(S, m), Ee(() => {
      p.isUnmounted = !0;
    }, m), m && m.pendingBranch && !m.isUnmounted && p.asyncDep && !p.asyncResolved && p.suspenseId === m.pendingId && (m.deps--, m.deps === 0 && m.resolve());
  }, et = (p, m, x, w = !1, v = !1, T = 0) => {
    for (let E = T; E < p.length; E++)
      Ke(p[E], m, x, w, v);
  }, Tn = (p) => p.shapeFlag & 6 ? Tn(p.component.subTree) : p.shapeFlag & 128 ? p.suspense.next() : h(p.anchor || p.el), Ys = (p, m, x) => {
    p == null ? m._vnode && Ke(m._vnode, null, null, !0) : k(m._vnode || null, p, m, null, null, null, x), lo(), Sr(), m._vnode = p;
  }, Rt = {
    p: k,
    um: Ke,
    m: It,
    r: Js,
    mt: F,
    mc: O,
    pc: pe,
    pbc: N,
    n: Tn,
    o: e
  };
  let ki, Ai;
  return t && ([ki, Ai] = t(Rt)), {
    render: Ys,
    hydrate: ki,
    createApp: jd(Ys, ki)
  };
}
function At({ effect: e, update: t }, n) {
  e.allowRecurse = t.allowRecurse = n;
}
function Kr(e, t, n = !1) {
  const i = e.children, s = t.children;
  if (q(i) && q(s))
    for (let o = 0; o < i.length; o++) {
      const r = i[o];
      let a = s[o];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[o] = mt(s[o]), a.el = r.el), n || Kr(r, a)), a.type === ci && (a.el = r.el);
    }
}
function zd(e) {
  const t = e.slice(), n = [0];
  let i, s, o, r, a;
  const l = e.length;
  for (i = 0; i < l; i++) {
    const d = e[i];
    if (d !== 0) {
      if (s = n[n.length - 1], e[s] < d) {
        t[i] = s, n.push(i);
        continue;
      }
      for (o = 0, r = n.length - 1; o < r; )
        a = o + r >> 1, e[n[a]] < d ? o = a + 1 : r = a;
      d < e[n[o]] && (o > 0 && (t[i] = n[o - 1]), n[o] = i);
    }
  }
  for (o = n.length, r = n[o - 1]; o-- > 0; )
    n[o] = r, r = t[r];
  return n;
}
const Hd = (e) => e.__isTeleport, X = Symbol(void 0), ci = Symbol(void 0), ze = Symbol(void 0), Pn = Symbol(void 0), cn = [];
let qe = null;
function u(e = !1) {
  cn.push(qe = e ? null : []);
}
function Vd() {
  cn.pop(), qe = cn[cn.length - 1] || null;
}
let _n = 1;
function _o(e) {
  _n += e;
}
function Jr(e) {
  return e.dynamicChildren = _n > 0 ? qe || Ht : null, Vd(), _n > 0 && qe && qe.push(e), e;
}
function g(e, t, n, i, s, o) {
  return Jr(b(
    e,
    t,
    n,
    i,
    s,
    o,
    !0
    /* isBlock */
  ));
}
function le(e, t, n, i, s) {
  return Jr(V(
    e,
    t,
    n,
    i,
    s,
    !0
    /* isBlock: prevent a block from tracking itself */
  ));
}
function Gn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Dt(e, t) {
  return e.type === t.type && e.key === t.key;
}
const pi = "__vInternal", Yr = ({ key: e }) => e ?? null, jn = ({ ref: e, ref_key: t, ref_for: n }) => e != null ? Ie(e) || ye(e) || Y(e) ? { i: De, r: e, k: t, f: !!n } : e : null;
function b(e, t = null, n = null, i = 0, s = null, o = e === X ? 0 : 1, r = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Yr(t),
    ref: t && jn(t),
    scopeId: Dr,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: i,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: De
  };
  return a ? (ws(l, n), o & 128 && e.normalize(l)) : n && (l.shapeFlag |= Ie(n) ? 8 : 16), _n > 0 && // avoid a block node from tracking itself
  !r && // has current parent block
  qe && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && qe.push(l), l;
}
const V = qd;
function qd(e, t = null, n = null, i = 0, s = null, o = !1) {
  if ((!e || e === Pr) && (e = ze), Gn(e)) {
    const a = Ct(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && ws(a, n), _n > 0 && !o && qe && (a.shapeFlag & 6 ? qe[qe.indexOf(e)] = a : qe.push(a)), a.patchFlag |= -2, a;
  }
  if (tc(e) && (e = e.__vccOpts), t) {
    t = Wd(t);
    let { class: a, style: l } = t;
    a && !Ie(a) && (t.class = M(a)), ge(l) && (Cr(l) && !q(l) && (l = Se({}, l)), t.style = Mt(l));
  }
  const r = Ie(e) ? 1 : pd(e) ? 128 : Hd(e) ? 64 : ge(e) ? 4 : Y(e) ? 2 : 0;
  return b(e, t, n, i, s, r, o, !0);
}
function Wd(e) {
  return e ? Cr(e) || pi in e ? Se({}, e) : e : null;
}
function Ct(e, t, n = !1) {
  const { props: i, ref: s, patchFlag: o, children: r } = e, a = t ? Is(i || {}, t) : i;
  return {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: a,
    key: a && Yr(a),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && s ? q(s) ? s.concat(jn(t)) : [s, jn(t)] : jn(t)
    ) : s,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: r,
    target: e.target,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== X ? o === -1 ? 16 : o | 16 : o,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: e.transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Ct(e.ssContent),
    ssFallback: e.ssFallback && Ct(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
}
function ke(e = " ", t = 0) {
  return V(ci, null, e, t);
}
function ui(e, t) {
  const n = V(Pn, null, e);
  return n.staticCount = t, n;
}
function A(e = "", t = !1) {
  return t ? (u(), le(ze, null, e)) : V(ze, null, e);
}
function Ge(e) {
  return e == null || typeof e == "boolean" ? V(ze) : q(e) ? V(
    X,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : typeof e == "object" ? mt(e) : V(ci, null, String(e));
}
function mt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Ct(e);
}
function ws(e, t) {
  let n = 0;
  const { shapeFlag: i } = e;
  if (t == null)
    t = null;
  else if (q(t))
    n = 16;
  else if (typeof t == "object")
    if (i & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), ws(e, s()), s._c && (s._d = !0));
      return;
    } else {
      n = 32;
      const s = t._;
      !s && !(pi in t) ? t._ctx = De : s === 3 && De && (De.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else
    Y(t) ? (t = { default: t, _ctx: De }, n = 32) : (t = String(t), i & 64 ? (n = 16, t = [ke(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Is(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const i = e[n];
    for (const s in i)
      if (s === "class")
        t.class !== i.class && (t.class = M([t.class, i.class]));
      else if (s === "style")
        t.style = Mt([t.style, i.style]);
      else if (Xn(s)) {
        const o = t[s], r = i[s];
        r && o !== r && !(q(o) && o.includes(r)) && (t[s] = o ? [].concat(o, r) : r);
      } else
        s !== "" && (t[s] = i[s]);
  }
  return t;
}
function Ye(e, t, n, i = null) {
  Ue(e, t, 7, [
    n,
    i
  ]);
}
const Zd = Zr();
let Kd = 0;
function Jd(e, t, n) {
  const i = e.type, s = (t ? t.appContext : e.appContext) || Zd, o = {
    uid: Kd++,
    vnode: e,
    type: i,
    parent: t,
    appContext: s,
    root: null,
    next: null,
    subTree: null,
    effect: null,
    update: null,
    scope: new rr(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Hr(i, s),
    emitsOptions: $r(i, s),
    // emit
    emit: null,
    emitted: null,
    // props default value
    propsDefaults: he,
    // inheritAttrs
    inheritAttrs: i.inheritAttrs,
    // state
    ctx: he,
    data: he,
    props: he,
    attrs: he,
    slots: he,
    refs: he,
    setupState: he,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = t ? t.root : o, o.emit = rd.bind(null, o), e.ce && e.ce(o), o;
}
let Ce = null;
const ks = () => Ce || De, Kt = (e) => {
  Ce = e, e.scope.on();
}, Ot = () => {
  Ce && Ce.scope.off(), Ce = null;
};
function Gr(e) {
  return e.vnode.shapeFlag & 4;
}
let Cn = !1;
function Yd(e, t = !1) {
  Cn = t;
  const { props: n, children: i } = e.vnode, s = Gr(e);
  Od(e, n, s, t), Rd(e, i);
  const o = s ? Gd(e, t) : void 0;
  return Cn = !1, o;
}
function Gd(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = Zt(new Proxy(e.ctx, Sd));
  const { setup: i } = n;
  if (i) {
    const s = e.setupContext = i.length > 1 ? Xd(e) : null;
    Kt(e), Yt();
    const o = xt(i, e, 0, [e.props, s]);
    if (Gt(), Ot(), ir(o)) {
      if (o.then(Ot, Ot), t)
        return o.then((r) => {
          Co(e, r, t);
        }).catch((r) => {
          oi(
            r,
            e,
            0
            /* ErrorCodes.SETUP_FUNCTION */
          );
        });
      e.asyncDep = o;
    } else
      Co(e, o, t);
  } else
    Qr(e, t);
}
function Co(e, t, n) {
  Y(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : ge(t) && (e.setupState = wr(t)), Qr(e, n);
}
let yo;
function Qr(e, t, n) {
  const i = e.type;
  if (!e.render) {
    if (!t && yo && !i.render) {
      const s = i.template || ys(e).template;
      if (s) {
        const { isCustomElement: o, compilerOptions: r } = e.appContext.config, { delimiters: a, compilerOptions: l } = i, d = Se(Se({
          isCustomElement: o,
          delimiters: a
        }, r), l);
        i.render = yo(s, d);
      }
    }
    e.render = i.render || We;
  }
  Kt(e), Yt(), Td(e), Gt(), Ot();
}
function Qd(e) {
  return new Proxy(e.attrs, {
    get(t, n) {
      return Me(e, "get", "$attrs"), t[n];
    }
  });
}
function Xd(e) {
  const t = (i) => {
    e.exposed = i || {};
  };
  let n;
  return {
    get attrs() {
      return n || (n = Qd(e));
    },
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function As(e) {
  if (e.exposed)
    return e.exposeProxy || (e.exposeProxy = new Proxy(wr(Zt(e.exposed)), {
      get(t, n) {
        if (n in t)
          return t[n];
        if (n in dn)
          return dn[n](e);
      },
      has(t, n) {
        return n in t || n in dn;
      }
    }));
}
function ec(e, t = !0) {
  return Y(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function tc(e) {
  return Y(e) && "__vccOpts" in e;
}
const D = (e, t) => ed(e, t, Cn);
function nc(e, t, n) {
  const i = arguments.length;
  return i === 2 ? ge(t) && !q(t) ? Gn(t) ? V(e, null, [t]) : V(e, t) : V(e, null, t) : (i > 3 ? n = Array.prototype.slice.call(arguments, 2) : i === 3 && Gn(n) && (n = [n]), V(e, t, n));
}
const ic = Symbol(""), sc = () => an(ic), oc = "3.2.47", rc = "http://www.w3.org/2000/svg", Nt = typeof document < "u" ? document : null, vo = Nt && /* @__PURE__ */ Nt.createElement("template"), ac = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, i) => {
    const s = t ? Nt.createElementNS(rc, e) : Nt.createElement(e, n ? { is: n } : void 0);
    return e === "select" && i && i.multiple != null && s.setAttribute("multiple", i.multiple), s;
  },
  createText: (e) => Nt.createTextNode(e),
  createComment: (e) => Nt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Nt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, i, s, o) {
    const r = n ? n.previousSibling : t.lastChild;
    if (s && (s === o || s.nextSibling))
      for (; t.insertBefore(s.cloneNode(!0), n), !(s === o || !(s = s.nextSibling)); )
        ;
    else {
      vo.innerHTML = i ? `<svg>${e}</svg>` : e;
      const a = vo.content;
      if (i) {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, n);
    }
    return [
      // first
      r ? r.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
};
function lc(e, t, n) {
  const i = e._vtc;
  i && (t = (t ? [t, ...i] : [...i]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
function dc(e, t, n) {
  const i = e.style, s = Ie(n);
  if (n && !s) {
    if (t && !Ie(t))
      for (const o in t)
        n[o] == null && Ji(i, o, "");
    for (const o in n)
      Ji(i, o, n[o]);
  } else {
    const o = i.display;
    s ? t !== n && (i.cssText = n) : t && e.removeAttribute("style"), "_vod" in e && (i.display = o);
  }
}
const wo = /\s*!important$/;
function Ji(e, t, n) {
  if (q(n))
    n.forEach((i) => Ji(e, t, i));
  else if (n == null && (n = ""), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const i = cc(e, t);
    wo.test(n) ? e.setProperty(Fe(i), n.replace(wo, ""), "important") : e[i] = n;
  }
}
const Io = ["Webkit", "Moz", "ms"], Ni = {};
function cc(e, t) {
  const n = Ni[t];
  if (n)
    return n;
  let i = Le(t);
  if (i !== "filter" && i in e)
    return Ni[t] = i;
  i = ni(i);
  for (let s = 0; s < Io.length; s++) {
    const o = Io[s] + i;
    if (o in e)
      return Ni[t] = o;
  }
  return t;
}
const ko = "http://www.w3.org/1999/xlink";
function pc(e, t, n, i, s) {
  if (i && t.startsWith("xlink:"))
    n == null ? e.removeAttributeNS(ko, t.slice(6, t.length)) : e.setAttributeNS(ko, t, n);
  else {
    const o = dl(t);
    n == null || o && !er(n) ? e.removeAttribute(t) : e.setAttribute(t, o ? "" : n);
  }
}
function uc(e, t, n, i, s, o, r) {
  if (t === "innerHTML" || t === "textContent") {
    i && r(i, s, o), e[t] = n ?? "";
    return;
  }
  if (t === "value" && e.tagName !== "PROGRESS" && // custom elements may use _value internally
  !e.tagName.includes("-")) {
    e._value = n;
    const l = n ?? "";
    (e.value !== l || // #4956: always set for OPTION elements because its value falls back to
    // textContent if no value attribute is present. And setting .value for
    // OPTION has no side effect
    e.tagName === "OPTION") && (e.value = l), n == null && e.removeAttribute(t);
    return;
  }
  let a = !1;
  if (n === "" || n == null) {
    const l = typeof e[t];
    l === "boolean" ? n = er(n) : n == null && l === "string" ? (n = "", a = !0) : l === "number" && (n = 0, a = !0);
  }
  try {
    e[t] = n;
  } catch {
  }
  a && e.removeAttribute(t);
}
function mc(e, t, n, i) {
  e.addEventListener(t, n, i);
}
function fc(e, t, n, i) {
  e.removeEventListener(t, n, i);
}
function gc(e, t, n, i, s = null) {
  const o = e._vei || (e._vei = {}), r = o[t];
  if (i && r)
    r.value = i;
  else {
    const [a, l] = hc(t);
    if (i) {
      const d = o[t] = _c(i, s);
      mc(e, a, d, l);
    } else
      r && (fc(e, a, r, l), o[t] = void 0);
  }
}
const Ao = /(?:Once|Passive|Capture)$/;
function hc(e) {
  let t;
  if (Ao.test(e)) {
    t = {};
    let i;
    for (; i = e.match(Ao); )
      e = e.slice(0, e.length - i[0].length), t[i[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Fe(e.slice(2)), t];
}
let Ei = 0;
const bc = /* @__PURE__ */ Promise.resolve(), xc = () => Ei || (bc.then(() => Ei = 0), Ei = Date.now());
function _c(e, t) {
  const n = (i) => {
    if (!i._vts)
      i._vts = Date.now();
    else if (i._vts <= n.attached)
      return;
    Ue(Cc(i, n.value), t, 5, [i]);
  };
  return n.value = e, n.attached = xc(), n;
}
function Cc(e, t) {
  if (q(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map((i) => (s) => !s._stopped && i && i(s));
  } else
    return t;
}
const So = /^on[a-z]/, yc = (e, t, n, i, s = !1, o, r, a, l) => {
  t === "class" ? lc(e, i, s) : t === "style" ? dc(e, n, i) : Xn(t) ? ss(t) || gc(e, t, n, i, r) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : vc(e, t, i, s)) ? uc(e, t, i, o, r, a, l) : (t === "true-value" ? e._trueValue = i : t === "false-value" && (e._falseValue = i), pc(e, t, i, s));
};
function vc(e, t, n, i) {
  return i ? !!(t === "innerHTML" || t === "textContent" || t in e && So.test(t) && Y(n)) : t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA" || So.test(t) && Ie(n) ? !1 : t in e;
}
function wc(e, t) {
  const n = Z(e);
  class i extends Ss {
    constructor(o) {
      super(n, o, t);
    }
  }
  return i.def = n, i;
}
const Ic = typeof HTMLElement < "u" ? HTMLElement : class {
};
class Ss extends Ic {
  constructor(t, n = {}, i) {
    super(), this._def = t, this._props = n, this._instance = null, this._connected = !1, this._resolved = !1, this._numberProps = null, this.shadowRoot && i ? i(this._createVNode(), this.shadowRoot) : (this.attachShadow({ mode: "open" }), this._def.__asyncLoader || this._resolveProps(this._def));
  }
  connectedCallback() {
    this._connected = !0, this._instance || (this._resolved ? this._update() : this._resolveDef());
  }
  disconnectedCallback() {
    this._connected = !1, vn(() => {
      this._connected || (Bo(null, this.shadowRoot), this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    this._resolved = !0;
    for (let i = 0; i < this.attributes.length; i++)
      this._setAttr(this.attributes[i].name);
    new MutationObserver((i) => {
      for (const s of i)
        this._setAttr(s.attributeName);
    }).observe(this, { attributes: !0 });
    const t = (i, s = !1) => {
      const { props: o, styles: r } = i;
      let a;
      if (o && !q(o))
        for (const l in o) {
          const d = o[l];
          (d === Number || d && d.type === Number) && (l in this._props && (this._props[l] = ji(this._props[l])), (a || (a = /* @__PURE__ */ Object.create(null)))[Le(l)] = !0);
        }
      this._numberProps = a, s && this._resolveProps(i), this._applyStyles(r), this._update();
    }, n = this._def.__asyncLoader;
    n ? n().then((i) => t(i, !0)) : t(this._def);
  }
  _resolveProps(t) {
    const { props: n } = t, i = q(n) ? n : Object.keys(n || {});
    for (const s of Object.keys(this))
      s[0] !== "_" && i.includes(s) && this._setProp(s, this[s], !0, !1);
    for (const s of i.map(Le))
      Object.defineProperty(this, s, {
        get() {
          return this._getProp(s);
        },
        set(o) {
          this._setProp(s, o);
        }
      });
  }
  _setAttr(t) {
    let n = this.getAttribute(t);
    const i = Le(t);
    this._numberProps && this._numberProps[i] && (n = ji(n)), this._setProp(i, n, !1);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, i = !0, s = !0) {
    n !== this._props[t] && (this._props[t] = n, s && this._instance && this._update(), i && (n === !0 ? this.setAttribute(Fe(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(Fe(t), n + "") : n || this.removeAttribute(Fe(t))));
  }
  _update() {
    Bo(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const t = V(this._def, Se({}, this._props));
    return this._instance || (t.ce = (n) => {
      this._instance = n, n.isCE = !0;
      const i = (o, r) => {
        this.dispatchEvent(new CustomEvent(o, {
          detail: r
        }));
      };
      n.emit = (o, ...r) => {
        i(o, r), Fe(o) !== o && i(Fe(o), r);
      };
      let s = this;
      for (; s = s && (s.parentNode || s.host); )
        if (s instanceof Ss) {
          n.parent = s._instance, n.provides = s._instance.provides;
          break;
        }
    }), t;
  }
  _applyStyles(t) {
    t && t.forEach((n) => {
      const i = document.createElement("style");
      i.textContent = n, this.shadowRoot.appendChild(i);
    });
  }
}
const ct = "transition", nn = "animation", Ts = (e, { slots: t }) => nc(Mr, ea(e), t);
Ts.displayName = "Transition";
const Xr = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, kc = Ts.props = /* @__PURE__ */ Se({}, Mr.props, Xr), St = (e, t = []) => {
  q(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, To = (e) => e ? q(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function ea(e) {
  const t = {};
  for (const R in e)
    R in Xr || (t[R] = e[R]);
  if (e.css === !1)
    return t;
  const { name: n = "v", type: i, duration: s, enterFromClass: o = `${n}-enter-from`, enterActiveClass: r = `${n}-enter-active`, enterToClass: a = `${n}-enter-to`, appearFromClass: l = o, appearActiveClass: d = r, appearToClass: c = a, leaveFromClass: f = `${n}-leave-from`, leaveActiveClass: h = `${n}-leave-active`, leaveToClass: y = `${n}-leave-to` } = e, _ = Ac(s), k = _ && _[0], K = _ && _[1], { onBeforeEnter: U, onEnter: ae, onEnterCancelled: P, onLeave: G, onLeaveCancelled: se, onBeforeAppear: be = U, onAppear: ee = ae, onAppearCancelled: O = P } = t, B = (R, ce, F) => {
    ut(R, ce ? c : a), ut(R, ce ? d : r), F && F();
  }, N = (R, ce) => {
    R._isLeaving = !1, ut(R, f), ut(R, y), ut(R, h), ce && ce();
  }, Q = (R) => (ce, F) => {
    const me = R ? ee : ae, ve = () => B(ce, R, F);
    St(me, [ce, ve]), $o(() => {
      ut(ce, R ? l : o), tt(ce, R ? c : a), To(me) || Do(ce, i, k, ve);
    });
  };
  return Se(t, {
    onBeforeEnter(R) {
      St(U, [R]), tt(R, o), tt(R, r);
    },
    onBeforeAppear(R) {
      St(be, [R]), tt(R, l), tt(R, d);
    },
    onEnter: Q(!1),
    onAppear: Q(!0),
    onLeave(R, ce) {
      R._isLeaving = !0;
      const F = () => N(R, ce);
      tt(R, f), na(), tt(R, h), $o(() => {
        R._isLeaving && (ut(R, f), tt(R, y), To(G) || Do(R, i, K, F));
      }), St(G, [R, F]);
    },
    onEnterCancelled(R) {
      B(R, !1), St(P, [R]);
    },
    onAppearCancelled(R) {
      B(R, !0), St(O, [R]);
    },
    onLeaveCancelled(R) {
      N(R), St(se, [R]);
    }
  });
}
function Ac(e) {
  if (e == null)
    return null;
  if (ge(e))
    return [Oi(e.enter), Oi(e.leave)];
  {
    const t = Oi(e);
    return [t, t];
  }
}
function Oi(e) {
  return ji(e);
}
function tt(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e._vtc || (e._vtc = /* @__PURE__ */ new Set())).add(t);
}
function ut(e, t) {
  t.split(/\s+/).forEach((i) => i && e.classList.remove(i));
  const { _vtc: n } = e;
  n && (n.delete(t), n.size || (e._vtc = void 0));
}
function $o(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let Sc = 0;
function Do(e, t, n, i) {
  const s = e._endId = ++Sc, o = () => {
    s === e._endId && i();
  };
  if (n)
    return setTimeout(o, n);
  const { type: r, timeout: a, propCount: l } = ta(e, t);
  if (!r)
    return i();
  const d = r + "end";
  let c = 0;
  const f = () => {
    e.removeEventListener(d, h), o();
  }, h = (y) => {
    y.target === e && ++c >= l && f();
  };
  setTimeout(() => {
    c < l && f();
  }, a + 1), e.addEventListener(d, h);
}
function ta(e, t) {
  const n = window.getComputedStyle(e), i = (_) => (n[_] || "").split(", "), s = i(`${ct}Delay`), o = i(`${ct}Duration`), r = No(s, o), a = i(`${nn}Delay`), l = i(`${nn}Duration`), d = No(a, l);
  let c = null, f = 0, h = 0;
  t === ct ? r > 0 && (c = ct, f = r, h = o.length) : t === nn ? d > 0 && (c = nn, f = d, h = l.length) : (f = Math.max(r, d), c = f > 0 ? r > d ? ct : nn : null, h = c ? c === ct ? o.length : l.length : 0);
  const y = c === ct && /\b(transform|all)(,|$)/.test(i(`${ct}Property`).toString());
  return {
    type: c,
    timeout: f,
    propCount: h,
    hasTransform: y
  };
}
function No(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, i) => Eo(n) + Eo(e[i])));
}
function Eo(e) {
  return Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function na() {
  return document.body.offsetHeight;
}
const ia = /* @__PURE__ */ new WeakMap(), sa = /* @__PURE__ */ new WeakMap(), oa = {
  name: "TransitionGroup",
  props: /* @__PURE__ */ Se({}, kc, {
    tag: String,
    moveClass: String
  }),
  setup(e, { slots: t }) {
    const n = ks(), i = Or();
    let s, o;
    return _s(() => {
      if (!s.length)
        return;
      const r = e.moveClass || `${e.name || "v"}-move`;
      if (!Oc(s[0].el, n.vnode.el, r))
        return;
      s.forEach(Dc), s.forEach(Nc);
      const a = s.filter(Ec);
      na(), a.forEach((l) => {
        const d = l.el, c = d.style;
        tt(d, r), c.transform = c.webkitTransform = c.transitionDuration = "";
        const f = d._moveCb = (h) => {
          h && h.target !== d || (!h || /transform$/.test(h.propertyName)) && (d.removeEventListener("transitionend", f), d._moveCb = null, ut(d, r));
        };
        d.addEventListener("transitionend", f);
      });
    }), () => {
      const r = ne(e), a = ea(r);
      let l = r.tag || X;
      s = o, o = t.default ? xs(t.default()) : [];
      for (let d = 0; d < o.length; d++) {
        const c = o[d];
        c.key != null && xn(c, bn(c, a, i, n));
      }
      if (s)
        for (let d = 0; d < s.length; d++) {
          const c = s[d];
          xn(c, bn(c, a, i, n)), ia.set(c, c.el.getBoundingClientRect());
        }
      return V(l, null, o);
    };
  }
}, Tc = (e) => delete e.mode;
oa.props;
const $c = oa;
function Dc(e) {
  const t = e.el;
  t._moveCb && t._moveCb(), t._enterCb && t._enterCb();
}
function Nc(e) {
  sa.set(e, e.el.getBoundingClientRect());
}
function Ec(e) {
  const t = ia.get(e), n = sa.get(e), i = t.left - n.left, s = t.top - n.top;
  if (i || s) {
    const o = e.el.style;
    return o.transform = o.webkitTransform = `translate(${i}px,${s}px)`, o.transitionDuration = "0s", e;
  }
}
function Oc(e, t, n) {
  const i = e.cloneNode();
  e._vtc && e._vtc.forEach((r) => {
    r.split(/\s+/).forEach((a) => a && i.classList.remove(a));
  }), n.split(/\s+/).forEach((r) => r && i.classList.add(r)), i.style.display = "none";
  const s = t.nodeType === 1 ? t : t.parentNode;
  s.appendChild(i);
  const { hasTransform: o } = ta(i);
  return s.removeChild(i), o;
}
const Mc = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, Oo = (e, t) => (n) => {
  if (!("key" in n))
    return;
  const i = Fe(n.key);
  if (t.some((s) => s === i || Mc[s] === i))
    return e(n);
}, Bc = /* @__PURE__ */ Se({ patchProp: yc }, ac);
let Mo;
function Rc() {
  return Mo || (Mo = Fd(Bc));
}
const Bo = (...e) => {
  Rc().render(...e);
};
var ra = Z({
  name: "DsAccordion",
  props: {
    ariaLabel: String
  }
});
const Lc = ["aria-label"];
function Pc(e, t, n, i, s, o) {
  return u(), g("ul", {
    class: "ds-accordion",
    "aria-label": e.ariaLabel
  }, [
    fe(e.$slots, "default")
  ], 8, Lc);
}
ra.render = Pc;
ra.__file = "src/components/DsAccordion/DsAccordion.vue";
const Ro = () => {
}, $s = () => typeof window < "u", Lo = () => typeof document < "u", jc = (e) => {
  switch (e) {
    case 1:
      return "simpel";
    case 2:
      return "normal";
    case 3:
      return "pfiffig";
    default:
      return "n/a";
  }
}, Fc = (e) => {
  const t = new Date(), n = new Date(e);
  if (!(n instanceof Date) || isNaN(n.getTime()))
    throw "invalid input";
  const i = t.getTime() - n.getTime(), s = Math.floor(i / (1e3 * 3600)), o = Math.floor(s / 24);
  if (o === 0)
    return s === 0 ? "vor wenigen Minuten" : `vor ${s} Stunde${s === 1 ? "" : "n"}`;
  if (o === 1)
    return "vor 1 Tag";
  if (o < 7)
    return `vor ${o} Tagen`;
  if (o < 28) {
    const a = Math.round(o / 7);
    return `vor ${a} Woche${a === 1 ? "" : "n"}`;
  }
  if (o < 365) {
    const a = Math.round(o / 30);
    return `vor ${a} Monat${a === 1 ? "" : "en"}`;
  }
  const r = Math.round(o / 365);
  return `vor ${r} Jahr${r === 1 ? "" : "en"}`;
}, aa = () => Date.now().toString(36) + Math.random().toString(36);
var la = Z({
  name: "DsAccordionItem",
  props: {
    title: {
      type: String,
      required: !0
    },
    isExpanded: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onToggle"],
  setup(e, { emit: t }) {
    const n = J(e.isExpanded), i = aa(), s = `accordion-button-${i}`, o = `accordion-content-${i}`;
    return {
      buttonId: s,
      contentId: o,
      expanded: n,
      id: i,
      onToggle: (a) => {
        t("onToggle", a), n.value = !n.value;
      }
    };
  }
});
const Uc = ["aria-expanded", "id", "aria-controls"], zc = /* @__PURE__ */ b(
  "i",
  { class: "ds-accordion__btn-icon chefkoch-icons" },
  "",
  -1
  /* HOISTED */
), Hc = ["aria-hidden", "id"], Vc = { class: "ds-accordion__inner" };
function qc(e, t, n, i, s, o) {
  return u(), g(
    "li",
    {
      key: e.id,
      class: M(["ds-accordion__item", { "ds-accordion__item--active": e.expanded }])
    },
    [
      b("button", {
        class: "ds-accordion__btn ds-text-sans ds-h4",
        "aria-expanded": e.expanded ? "true" : "false",
        id: e.buttonId,
        "aria-controls": e.contentId,
        onClick: t[0] || (t[0] = (...r) => e.onToggle && e.onToggle(...r))
      }, [
        ke(
          j(e.title),
          1
          /* TEXT */
        ),
        zc
      ], 8, Uc),
      b("div", {
        class: "ds-accordion__content",
        "aria-hidden": e.expanded ? "false" : "true",
        id: e.contentId
      }, [
        b("div", Vc, [
          fe(e.$slots, "default")
        ])
      ], 8, Hc)
    ],
    2
    /* CLASS */
  );
}
la.render = qc;
la.__file = "src/components/DsAccordionItem/DsAccordionItem.vue";
var vt = Z({
  name: "DsPlusBadge",
  props: {
    mobileSmall: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return {
      classes: D(() => `${e.mobileSmall && !e.small ? "ds-plus-badge--mobile-small" : ""}${e.small ? "ds-plus-badge--small" : ""}`)
    };
  }
});
function Wc(e, t, n, i, s, o) {
  return u(), g(
    "div",
    {
      class: M(["ds-plus-badge", e.classes]),
      role: "img",
      "aria-label": "Chefkoch PLUS"
    },
    null,
    2
    /* CLASS */
  );
}
vt.render = Wc;
vt.__file = "src/components/DsPlusBadge/DsPlusBadge.vue";
var da = Z({
  components: { DsPlusBadge: vt },
  name: "DsActionCard",
  props: {
    label: {
      type: String,
      required: !0
    },
    imageAlt: {
      type: String
    },
    imageUrl: {
      type: String
    },
    isPlus: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    return {
      onClick: (i) => {
        t("onClick", i);
      }
    };
  }
});
const Zc = {
  key: 0,
  class: "ds-action-card__image"
}, Kc = ["alt", "src"], Jc = { class: "ds-action-card__body" }, Yc = {
  key: 0,
  class: "ds-action-card__badge"
}, Gc = /* @__PURE__ */ b(
  "i",
  { class: "ds-action-card__icon chefkoch-icons" },
  "",
  -1
  /* HOISTED */
);
function Qc(e, t, n, i, s, o) {
  const r = ie("ds-plus-badge");
  return u(), g("div", {
    class: "ds-action-card",
    onClick: t[0] || (t[0] = (a) => e.onClick(a))
  }, [
    e.imageUrl ? (u(), g("div", Zc, [
      b("img", {
        alt: e.imageAlt,
        height: "96",
        width: "64",
        src: e.imageUrl
      }, null, 8, Kc)
    ])) : A("v-if", !0),
    b("div", Jc, [
      e.isPlus ? (u(), g("div", Yc, [
        V(r, { mobileSmall: "" })
      ])) : A("v-if", !0),
      ke(
        j(e.label),
        1
        /* TEXT */
      )
    ]),
    Gc
  ]);
}
da.render = Qc;
da.__file = "src/components/DsActionCard/DsActionCard.vue";
var Xt = Z({
  name: "DsAuthor",
  props: {
    avatarUrl: {
      type: String,
      required: !1
    },
    isVerified: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return {
      avatarAltText: D(() => `Bild von ${e.name}`)
    };
  }
});
const Xc = { class: "ds-author ds-text-caption" }, ep = ["alt", "src"], tp = /* @__PURE__ */ ke("von "), np = { class: "ds-author__name" }, ip = {
  key: 1,
  class: "ds-author__verified-icon chefkoch-icons"
};
function sp(e, t, n, i, s, o) {
  return u(), g("div", Xc, [
    e.avatarUrl ? (u(), g("img", {
      key: 0,
      width: "32",
      height: "32",
      class: "ds-author__avatar",
      alt: e.avatarAltText,
      src: e.avatarUrl
    }, null, 8, ep)) : A("v-if", !0),
    tp,
    b(
      "strong",
      np,
      j(e.name),
      1
      /* TEXT */
    ),
    e.isVerified ? (u(), g("i", ip, "")) : A("v-if", !0)
  ]);
}
Xt.render = sp;
Xt.__file = "src/components/DsAuthor/DsAuthor.vue";
var mi = Z({
  name: "DsLoader"
});
const op = { class: "ds-loader ds-animate ds-animate--rotate ds-animate--infinite" }, rp = /* @__PURE__ */ b(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20px 20px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  [
    /* @__PURE__ */ b("circle", {
      cx: "50%",
      cy: "50%",
      r: "8",
      class: "ds-loader__circle"
    })
  ],
  -1
  /* HOISTED */
), ap = [
  rp
];
function lp(e, t, n, i, s, o) {
  return u(), g("div", op, ap);
}
mi.render = lp;
mi.__file = "src/components/DsLoader/DsLoader.vue";
var ot = Z({
  name: "DsButton",
  components: { DsLoader: mi },
  props: {
    disabled: Boolean,
    label: {
      type: String
    },
    icon: {
      type: String
    },
    iconPosition: {
      type: String,
      enum: ["leading", "trailing"]
    },
    srOnly: {
      type: String
    },
    flat: {
      type: Boolean
    },
    active: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    mode: {
      type: String,
      enum: [
        "primary",
        "secondary",
        "tertiary",
        "danger",
        "conversion",
        "monochrome",
        "tertiary-danger",
        "control",
        "action-menu"
      ],
      default: "primary"
    }
  },
  setup(e) {
    const t = D(() => `ds-btn--${e.mode}${e.label ? "" : " ds-btn--round"}${e.flat ? " ds-btn--flat" : ""}${e.active ? " ds-btn--active" : ""}${!e.icon && e.loading ? " ds-btn--loading" : ""}`), n = D(() => e.disabled || e.loading);
    return {
      classes: t,
      isDisabled: n
    };
  },
  methods: {
    onClick(e) {
      this.$emit("onClick", e);
    }
  }
});
const dp = ["disabled"], cp = {
  key: 0,
  class: "ds-sr-only"
}, pp = {
  key: 3,
  class: "ds-btn__label"
}, up = {
  key: 4,
  class: "ds-btn__icon ds-btn__icon--loading"
}, mp = {
  key: 5,
  class: "chefkoch-icons ds-btn__icon ds-btn__icon--trailing"
};
function fp(e, t, n, i, s, o) {
  const r = ie("ds-loader");
  return u(), g("button", {
    class: M(["ds-btn", e.classes]),
    disabled: e.isDisabled,
    onClick: t[0] || (t[0] = (a) => e.onClick(a))
  }, [
    e.srOnly ? (u(), g(
      "span",
      cp,
      j(e.srOnly),
      1
      /* TEXT */
    )) : A("v-if", !0),
    e.icon && e.label && e.iconPosition === "leading" ? (u(), g(
      "i",
      {
        key: 1,
        class: M(["ds-btn__icon ds-btn__icon--leading", { "chefkoch-icons": !e.loading }])
      },
      [
        e.loading ? (u(), le(r, { key: 0 })) : (u(), g(
          X,
          { key: 1 },
          [
            ke(
              j(e.icon),
              1
              /* TEXT */
            )
          ],
          2112
          /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
        ))
      ],
      2
      /* CLASS */
    )) : A("v-if", !0),
    e.icon && !e.label ? (u(), g(
      "i",
      {
        key: 2,
        class: M(["ds-btn__icon", { "chefkoch-icons": !e.loading }])
      },
      [
        e.loading ? (u(), le(r, { key: 0 })) : (u(), g(
          X,
          { key: 1 },
          [
            ke(
              j(e.icon),
              1
              /* TEXT */
            )
          ],
          2112
          /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
        ))
      ],
      2
      /* CLASS */
    )) : A("v-if", !0),
    e.label ? (u(), g(
      "span",
      pp,
      j(e.label),
      1
      /* TEXT */
    )) : A("v-if", !0),
    !e.icon && e.label && e.loading ? (u(), g("i", up, [
      V(r)
    ])) : A("v-if", !0),
    e.icon && e.label && e.iconPosition === "trailing" ? (u(), g(
      "i",
      mp,
      j(e.icon),
      1
      /* TEXT */
    )) : A("v-if", !0)
  ], 10, dp);
}
ot.render = fp;
ot.__file = "src/components/DsButton/DsButton.vue";
var fi = Z({
  name: "DsButtonBox",
  props: {
    stackedMobile: Boolean,
    spaceBetween: Boolean
  },
  setup(e, t) {
    return {
      hasThirdButton: D(() => !!t.slots.third)
    };
  }
});
const gp = {
  key: 0,
  class: "ds-btn-box__item ds-btn-box__item--first"
}, hp = {
  key: 1,
  class: "ds-btn-box__item ds-btn-box__item--last ds-btn-box__item--line-break"
};
function bp(e, t, n, i, s, o) {
  return u(), g(
    "div",
    {
      class: M(["ds-btn-box", [{ "ds-btn-box--stack-to-xs": e.stackedMobile }, { "ds-btn-box--space-between": e.spaceBetween }]])
    },
    [
      e.$slots.first ? (u(), g("div", gp, [
        fe(e.$slots, "first")
      ])) : A("v-if", !0),
      b(
        "div",
        {
          class: M(["ds-btn-box__item", { "ds-btn-box__item--first": !e.$slots.first, "ds-btn-box__item--last": !e.$slots.third }])
        },
        [
          fe(e.$slots, "second")
        ],
        2
        /* CLASS */
      ),
      e.$slots.third ? (u(), g("div", hp, [
        fe(e.$slots, "third")
      ])) : A("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
fi.render = bp;
fi.__file = "src/components/DsButtonBox/DsButtonBox.vue";
const ca = (e, t) => {
  const n = (i) => {
    i.composedPath().includes(_e(e)) || t();
  };
  if ($s()) {
    let i = Ro;
    const s = { passive: !0, capture: !0 }, o = Ze(() => _e(e), () => {
      i(), window.addEventListener("click", n, s), i = () => {
        window.removeEventListener("click", n, s), i = Ro;
      };
    }), r = () => {
      o(), i();
    };
    return dr(() => {
      r();
    }), r;
  }
}, pa = (e) => {
  const t = D(() => "Follower"), n = D(() => e.siteUrl ? "a" : "div"), i = D(() => e.linkTitle || `Zur Sammlung ${e.title}`), s = D(() => {
    try {
      return Fc(e.dateString);
    } catch {
      return "";
    }
  }), o = D(() => e.alreadyInCollection ? "Bereits in dieser Sammlung" : `${e.recipeCount} Rezept${e.recipeCount !== 1 ? "e" : ""}`);
  return {
    followerUnit: t,
    linkTag: n,
    linkTitleFormatted: i,
    niceDate: s,
    recipeString: o
  };
}, ua = (e) => {
  const t = J(!1), n = (o) => {
    o.key === "Escape" && e();
  };
  return {
    attachEscapeKeyHandler: () => {
      Lo() && (document.addEventListener("keydown", n), t.value = !0);
    },
    removeEscapeKeyHandler: () => {
      t.value && Lo() && (document.removeEventListener("keydown", n), t.value = !1);
    }
  };
}, ma = (e) => {
  const t = D(() => e.siteUrl ? "a" : "div"), n = D(() => e.linkTitle || `Zum Rezept ${e.title}`), i = D(() => !e.isPlus && !isNaN(e.rating) && !isNaN(e.numVotes));
  return {
    linkTag: t,
    linkTitleFormatted: n,
    showRating: i
  };
}, xp = [160, 240, 320, 480, 640, 960], _p = 960, Cp = 640, Po = {
  cols: {
    breakpoint: 0,
    container: 479,
    gap: 16,
    fullResponsive: !0
  },
  xs: {
    breakpoint: 480,
    container: 599,
    gap: 16,
    fullResponsive: !0
  },
  s: {
    breakpoint: 600,
    container: 568,
    gap: 16,
    fullResponsive: !1
  },
  sm: {
    breakpoint: 768,
    container: 672,
    gap: 16,
    fullResponsive: !1
  },
  m: {
    breakpoint: 1196,
    container: 996,
    gap: 24,
    fullResponsive: !1
  }
};
function Yi(e) {
  if (e.endsWith(".svg"))
    return !1;
  let t = e;
  return t.startsWith("/") && (t = "https://www.chefkoch.de" + t), new URL(t).hostname.match(/\.chefkoch(-cdn)?\.de$/) ? !0 : (console.info(`ImageService: Not processing image via ImageProcessor: ${t}`), !1);
}
function yp(e) {
  const t = [];
  let n = _p;
  return fa(e) < 1 && (n = Cp), xp.forEach((i) => {
    i <= n && t.push(i);
  }), t;
}
function pn(e, t, n) {
  let i = e;
  if (Yi(i) && !i.includes("<format>")) {
    i.startsWith("/") && (i = "https://www.chefkoch.de" + i);
    const r = new URL(i);
    i = `https://${r.host}/images/<format>${r.pathname}${r.search}`;
  }
  const s = n / fa(t), o = `crop-${n}x${s}`;
  return i.replace("<format>", o).replace("<aspectRatio>", t);
}
function jo(e, t, n) {
  const i = Math.ceil(12 / t) + 1;
  return Math.ceil((e - n * i) / (12 / t));
}
function fa(e) {
  return e.split("x").map((t) => parseInt(t)).reduce((t, n) => t / n);
}
function vp(e) {
  const t = D(() => pn(e.imageTemplate, e.aspectRatio, 640)), n = D(() => {
    if (!Yi(e.imageTemplate))
      return "";
    const s = [], o = yp(e.aspectRatio), r = (a) => {
      const l = pn(e.imageTemplate, e.aspectRatio, a);
      s.find((d) => d.width === a) || s.push({ url: l, width: a });
    };
    return Object.entries(Po).forEach(([a, l]) => {
      let d = e[a] || 12;
      const c = jo(l.container, d, l.gap);
      let f = 0;
      o.forEach((y) => {
        y >= c && f === 0 && (f = y);
      }), f > 0 && r(f);
      let h = 0;
      for (const y of [2, 1.5])
        o.includes(f * y) && h === 0 && (h = f * y);
      h > 0 && r(h);
    }), s.sort((a, l) => a.width - l.width).map((a) => `${a.url} ${a.width}w`).join(", ");
  }), i = D(() => {
    if (!Yi(e.imageTemplate))
      return "";
    const s = /* @__PURE__ */ new Set();
    let o = 12;
    return Object.entries(Po).forEach(([r, a]) => {
      typeof e[r] < "u" && (o = e[r]);
      let l;
      if (a.fullResponsive) {
        const d = a.gap * (Math.ceil(12 / o) + 1);
        l = `calc(${o / 12} * (100vw - ${d}px))`;
      } else
        l = `${jo(a.container, o, a.gap)}px`;
      s.add({
        breakpoint: a.breakpoint,
        width: l
      });
    }), [...s].sort((r, a) => (
      // Sort descending by breakpoint
      a.breakpoint - r.breakpoint
    )).filter(
      // Filter out all definitions that are equal to the next step. In other words: Try to not list
      // duplicate definitions that would be valid for the next breakpoint.
      (r, a, l) => r.width !== (l[a + 1] || {}).width
    ).map((r, a, l) => (
      // Prepend min-widths, except for the smallest (=last; default) breakpoint
      a === l.length - 1 ? r.width : `(min-width: ${r.breakpoint}px) ${r.width}`
    )).join(", ");
  });
  return {
    imgSrc: t,
    imgSrcSet: n,
    imgSizes: i
  };
}
const Bn = J([]), wp = () => ({
  addSnackbar: (n) => {
    const i = new Date().getTime().toString();
    return Bn.value.push({ id: i, ...n }), i;
  },
  removeSnackbar: (n) => {
    const i = Bn.value.findIndex((s) => s.id === n);
    i >= 0 && Bn.value.splice(i, 1);
  },
  snackbars: ms(Bn)
}), Ip = () => {
  const e = J(1 / 0), t = J(1 / 0), n = () => {
    e.value = window.innerWidth, t.value = window.innerWidth;
  };
  return $s() && (at(() => {
    n(), window.addEventListener("resize", n);
  }), Qt(() => {
    window.removeEventListener("resize", n);
  })), {
    width: e,
    height: t
  };
};
var gi = Z({
  props: {
    imageTemplate: {
      type: String,
      required: !0
    },
    aspectRatio: {
      type: String,
      enum: [
        "16x9",
        "4x5",
        "4x3",
        "3x2"
      ],
      required: !0
    },
    cols: {
      type: Number,
      default: 12,
      required: !1
    },
    xs: {
      type: Number,
      required: !1
    },
    s: {
      type: Number,
      required: !1
    },
    sm: {
      type: Number,
      required: !1
    },
    m: {
      type: Number,
      required: !1
    }
  },
  setup(e) {
    const { imgSrc: t, imgSrcSet: n, imgSizes: i } = vp(e);
    return {
      imgSrc: t,
      imgSrcSet: n,
      imgSizes: i
    };
  }
});
const kp = ["src", "srcset", "sizes"];
function Ap(e, t, n, i, s, o) {
  return u(), g("img", {
    loading: "lazy",
    src: e.imgSrc,
    srcset: e.imgSrcSet ? e.imgSrcSet : null,
    sizes: e.imgSizes ? e.imgSizes : null
  }, null, 8, kp);
}
gi.render = Ap;
gi.__file = "src/components/DsResponsiveImage/DsResponsiveImage.vue";
var ga = Z({
  name: "DsCollectionCard",
  components: {
    DsAuthor: Xt,
    DsPlusBadge: vt,
    DsResponsiveImage: gi
  },
  props: {
    authorAvatarUrl: {
      type: String,
      required: !1
    },
    authorIsVerified: {
      type: Boolean,
      required: !1
    },
    authorName: {
      type: String,
      required: !1
    },
    followerCount: {
      type: Number,
      required: !1
    },
    dateString: {
      type: String,
      required: !0
    },
    gridCols: {
      type: Number,
      default: 12
    },
    gridM: {
      type: Number,
      default: 4
    },
    gridS: {
      type: Number,
      default: 6
    },
    hasImage: {
      type: Boolean,
      default: !0
    },
    imageTemplate: {
      type: String
    },
    isDeactivated: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isInverted: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPlus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPrivate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    linkTitle: {
      type: String,
      required: !1
    },
    recipeCount: {
      type: Number,
      default: 0,
      required: !0
    },
    siteUrl: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const { followerUnit: n, linkTag: i, linkTitleFormatted: s, niceDate: o, recipeString: r } = pa(e), a = D(() => `ds-collection-card__link${e.siteUrl ? " ds-teaser-link" : ""}`);
    return {
      followerUnit: n,
      linkClasses: a,
      linkTag: i,
      linkTitleFormatted: s,
      niceDate: o,
      onClick: (d) => {
        t("onClick", d);
      },
      recipeString: r
    };
  }
});
const Sp = { class: "ds-collection-card__image-wrap ds-teaser-link__image-wrap" }, Tp = ["alt"], $p = { class: "ds-collection-card__body" }, Dp = { class: "ds-collection-card__headline ds-text-sans ds-trunc ds-trunc-1" }, Np = { class: "ds-collection-card__recipe-count ds-text-caption" }, Ep = { class: "ds-collection-card__infos" }, Op = { class: "ds-collection-card__info-top" }, Mp = { class: "ds-collection-card__date ds-text-caption" }, Bp = {
  key: 0,
  class: "ds-collection-card__info-item ds-text-caption"
}, Rp = /* @__PURE__ */ b(
  "i",
  { class: "ds-collection-card__info-icon chefkoch-icons" },
  "",
  -1
  /* HOISTED */
), Lp = { class: "ds-text-semi-bold" }, Pp = { class: "ds-collection-card__info-bottom" }, jp = {
  key: 0,
  class: "ds-collection-card__info-item ds-text-caption"
}, Fp = {
  key: 0,
  class: "ds-collection-card__info-item ds-text-caption"
}, Up = /* @__PURE__ */ b(
  "i",
  { class: "ds-collection-card__info-icon chefkoch-icons" },
  "",
  -1
  /* HOISTED */
), zp = /* @__PURE__ */ b(
  "span",
  null,
  "Private Sammlung",
  -1
  /* HOISTED */
), Hp = [
  Up,
  zp
], Vp = {
  key: 1,
  class: "ds-collection-card__info-item ds-text-caption"
}, qp = /* @__PURE__ */ b(
  "i",
  { class: "ds-collection-card__info-icon chefkoch-icons" },
  "",
  -1
  /* HOISTED */
), Wp = /* @__PURE__ */ b(
  "span",
  null,
  "Öffentliche Sammlung",
  -1
  /* HOISTED */
), Zp = [
  qp,
  Wp
], Kp = {
  key: 1,
  class: "ds-card-badge ds-card-badge--inverted"
}, Jp = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons ds-card-badge__icon" },
  "",
  -1
  /* HOISTED */
), Yp = [
  Jp
], Gp = {
  key: 0,
  class: "ds-collection-card__action"
};
function Qp(e, t, n, i, s, o) {
  const r = ie("ds-responsive-image"), a = ie("ds-author"), l = ie("ds-plus-badge");
  return u(), g(
    "div",
    {
      class: M(["ds-collection-card", { "ds-collection-card--deactivated": e.isDeactivated, "ds-collection-card--inverted": e.isInverted }])
    },
    [
      (u(), le(di(e.linkTag), {
        class: M(e.linkClasses),
        href: e.siteUrl ? e.siteUrl : null,
        title: e.siteUrl ? e.linkTitleFormatted : null,
        onClick: t[0] || (t[0] = (d) => e.onClick(d))
      }, {
        default: Ae(() => [
          b("div", Sp, [
            !e.hasImage || !e.imageTemplate ? (u(), g("img", {
              key: 0,
              alt: e.title,
              class: M("ds-collection-card__image ds-teaser-link__image"),
              loading: "lazy",
              src: "https://img.chefkoch-cdn.de/assets/v2/img/placeholders/16x9/collection.svg"
            }, null, 8, Tp)) : (u(), le(r, {
              key: 1,
              class: M("ds-collection-card__image ds-teaser-link__image"),
              alt: e.title,
              aspectRatio: "16x9",
              imageTemplate: e.imageTemplate,
              cols: e.gridCols,
              s: e.gridS,
              m: e.gridM
            }, null, 8, ["alt", "imageTemplate", "cols", "s", "m"])),
            b("div", $p, [
              b(
                "h3",
                Dp,
                j(e.title),
                1
                /* TEXT */
              ),
              b(
                "span",
                Np,
                j(e.recipeString),
                1
                /* TEXT */
              )
            ])
          ]),
          b("div", Ep, [
            b("div", Op, [
              b(
                "span",
                Mp,
                j(e.niceDate),
                1
                /* TEXT */
              ),
              !e.isPrivate && !e.isDeactivated && e.followerCount !== void 0 ? (u(), g("span", Bp, [
                Rp,
                b(
                  "strong",
                  Lp,
                  j(e.followerCount),
                  1
                  /* TEXT */
                ),
                ke(
                  " " + j(e.followerUnit),
                  1
                  /* TEXT */
                )
              ])) : A("v-if", !0)
            ]),
            b("div", Pp, [
              e.isDeactivated ? (u(), g("span", jp, "Sammlung wurde deaktiviert")) : (u(), g(
                X,
                { key: 1 },
                [
                  e.isPrivate ? (u(), g("span", Fp, Hp)) : (u(), g(
                    X,
                    { key: 1 },
                    [
                      e.authorName ? (u(), le(a, {
                        key: 0,
                        name: e.authorName,
                        isVerified: e.authorIsVerified,
                        avatarUrl: e.authorAvatarUrl
                      }, null, 8, ["name", "isVerified", "avatarUrl"])) : (u(), g("span", Vp, Zp))
                    ],
                    2112
                    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
                  ))
                ],
                2112
                /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
              ))
            ])
          ]),
          e.isPlus || e.isDeactivated ? (u(), g(
            "div",
            {
              key: 0,
              class: M(["ds-collection-card__action ds-collection-card__action--left", { "ds-collection-card__action--plus": e.isPlus && !e.isDeactivated }])
            },
            [
              e.isPlus && !e.isDeactivated ? (u(), le(l, { key: 0 })) : A("v-if", !0),
              e.isDeactivated ? (u(), g("div", Kp, Yp)) : A("v-if", !0)
            ],
            2
            /* CLASS */
          )) : A("v-if", !0)
        ]),
        _: 1
        /* STABLE */
      }, 8, ["class", "href", "title"])),
      e.$slots.menu ? (u(), g("div", Gp, [
        fe(e.$slots, "menu")
      ])) : A("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
ga.render = Qp;
ga.__file = "src/components/DsCollectionCard/DsCollectionCard.vue";
var wn = Z({
  name: "DsTextToggle",
  props: {
    isTruncated: {
      type: Boolean,
      default: !0,
      required: !1
    },
    maxLines: {
      type: Number,
      default: 3,
      required: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      required: !0
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const n = J(e.isTruncated);
    return {
      onClick: (s) => {
        s.preventDefault(), t("onClick", s), e.readonly || (n.value = !n.value);
      },
      truncated: n
    };
  }
});
const Xp = {
  key: 0,
  class: "ds-text-toggle__icon chefkoch-icons"
}, eu = {
  key: 0,
  class: "ds-text-toggle__icon chefkoch-icons"
}, tu = {
  key: 1,
  class: "ds-text-toggle__icon chefkoch-icons"
};
function nu(e, t, n, i, s, o) {
  return u(), g(
    "div",
    {
      class: M(["ds-text-toggle", { "ds-text-toggle--readonly": e.readonly }]),
      onClick: t[0] || (t[0] = (r) => e.onClick(r))
    },
    [
      e.readonly ? (u(), g("i", Xp, "")) : (u(), g(
        X,
        { key: 1 },
        [
          e.truncated ? (u(), g("i", eu, "")) : (u(), g("i", tu, ""))
        ],
        2112
        /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
      )),
      b(
        "p",
        {
          class: M(["ds-text-toggle__text ds-text-caption", { "ds-trunc": e.truncated, ["ds-trunc-" + e.maxLines]: e.truncated }])
        },
        " „" + j(e.text) + "” ",
        3
        /* TEXT, CLASS */
      )
    ],
    2
    /* CLASS */
  );
}
wn.render = nu;
wn.__file = "src/components/DsTextToggle/DsTextToggle.vue";
const sn = [162, 126, 96];
var Ds = Z({
  name: "DsCollectionListItem",
  components: {
    DsAuthor: Xt,
    DsPlusBadge: vt,
    DsTextToggle: wn
  },
  props: {
    alreadyInCollection: {
      type: Boolean,
      required: !1
    },
    authorIsVerified: {
      type: Boolean,
      required: !1
    },
    authorName: {
      type: String,
      required: !1
    },
    avatarUrl: {
      type: String,
      required: !1
    },
    followerCount: {
      type: Number,
      required: !1
    },
    dateString: {
      type: String,
      required: !0
    },
    hasImage: {
      type: Boolean,
      default: !0
    },
    imageTemplate: {
      type: String
    },
    inOverlay: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isChecked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isDeactivated: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isInverted: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPlus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPrivate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isSelectable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    linkTitle: {
      type: String,
      required: !1
    },
    note: {
      type: String,
      required: !1
    },
    recipeCount: {
      type: Number,
      default: 0,
      required: !0
    },
    siteUrl: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const { followerUnit: n, linkTag: i, linkTitleFormatted: s, niceDate: o, recipeString: r } = pa(e), a = D(() => `${e.isDeactivated ? "ds-list-view-item--deactivated" : ""}
        ${e.inOverlay ? " ds-list-view-item--dialog" : ""}
        ${e.isInverted ? " ds-list-view-item--inverted" : ""}
        ${e.isDisabled ? " ds-list-view-item--disabled" : ""}
        `), l = D(() => `(min-width:1196px) ${sn[0]}px, (min-width: 600px) ${sn[1]}px, ${sn[2]}px`), d = D(() => e.imageTemplate ? pn(e.imageTemplate, "3x2", sn[2]) : ""), c = D(() => e.imageTemplate ? sn.map((_) => `${pn(e.imageTemplate, "3x2", 2 * _)} ${2 * _}w,
          ${pn(e.imageTemplate, "3x2", _)} ${_}w`).join(",") : ""), f = D(() => `ds-list-view-item__link${e.siteUrl ? " ds-teaser-link" : ""}`);
    return {
      classes: a,
      followerUnit: n,
      imgSizes: l,
      imgSrc: d,
      imgSrcSet: c,
      linkClasses: f,
      linkTag: i,
      linkTitleFormatted: s,
      niceDate: o,
      onClick: (_) => {
        t("onClick", _);
      },
      onTextToggleClick: (_) => {
        _.stopPropagation();
      },
      recipeString: r
    };
  }
});
const iu = { class: "ds-list-view-item__media" }, su = { class: "ds-list-view-item__image-wrap" }, ou = ["alt"], ru = ["alt", "src", "srcset", "sizes"], au = {
  key: 2,
  class: "ds-list-view-item__badge"
}, lu = {
  key: 1,
  class: "ds-card-badge ds-card-badge--inverted ds-card-badge--mobile-small"
}, du = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons ds-card-badge__icon" },
  "",
  -1
  /* HOISTED */
), cu = [
  du
], pu = { class: "ds-list-view-item__body" }, uu = { class: "ds-list-view-item__headline ds-teaser-link__headline ds-h4 ds-trunc ds-trunc-1 ds-text-sans" }, mu = { class: "ds-list-view-item__info-top" }, fu = { class: "ds-list-view-item__recipe-count ds-text-caption" }, gu = {
  key: 0,
  class: "ds-list-view-item__info-item ds-text-caption"
}, hu = /* @__PURE__ */ b(
  "i",
  { class: "ds-list-view-item__info-icon chefkoch-icons" },
  "",
  -1
  /* HOISTED */
), bu = { class: "ds-text-semi-bold" }, xu = {
  key: 0,
  class: "ds-list-view-item__info-bottom"
}, _u = {
  key: 0,
  class: "ds-list-view-item__info-item ds-text-caption"
}, Cu = {
  key: 0,
  class: "ds-list-view-item__info-item ds-text-caption"
}, yu = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons ds-list-view-item__info-icon" },
  "",
  -1
  /* HOISTED */
), vu = /* @__PURE__ */ b(
  "span",
  { class: "ds-list-view-item__visibility-text" },
  [
    /* @__PURE__ */ ke("Privat"),
    /* @__PURE__ */ b("span", { class: "ds-from-s" }, "e Sammlung")
  ],
  -1
  /* HOISTED */
), wu = [
  yu,
  vu
], Iu = {
  key: 1,
  class: "ds-list-view-item__info-item ds-text-caption"
}, ku = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons ds-list-view-item__info-icon" },
  "",
  -1
  /* HOISTED */
), Au = /* @__PURE__ */ b(
  "span",
  { class: "ds-list-view-item__visibility-text" },
  [
    /* @__PURE__ */ ke("Öffentlich"),
    /* @__PURE__ */ b("span", { class: "ds-from-s" }, "e Sammlung")
  ],
  -1
  /* HOISTED */
), Su = [
  ku,
  Au
], Tu = {
  key: 0,
  class: "ds-list-view-item__column ds-list-view-item__column--note"
}, $u = { class: "ds-list-view-item__column ds-list-view-item__column--date" }, Du = { class: "ds-text-caption" }, Nu = { class: "ds-list-view-item__action" }, Eu = {
  key: 0,
  class: "chefkoch-icons"
}, Ou = {
  key: 1,
  class: "chefkoch-icons"
};
function Mu(e, t, n, i, s, o) {
  const r = ie("ds-plus-badge"), a = ie("ds-author"), l = ie("ds-text-toggle");
  return u(), g(
    "div",
    {
      class: M(["ds-list-view-item ds-list-view-item--collection", e.classes]),
      onClick: t[0] || (t[0] = (d) => e.onClick(d))
    },
    [
      (u(), le(di(e.linkTag), {
        class: M(e.linkClasses),
        href: e.siteUrl ? e.siteUrl : null,
        title: e.siteUrl ? e.linkTitleFormatted : null
      }, {
        default: Ae(() => [
          b("div", iu, [
            b("div", su, [
              !e.hasImage || !e.imageTemplate ? (u(), g("img", {
                key: 0,
                alt: e.title,
                class: M("ds-list-view-item__image"),
                loading: "lazy",
                src: "https://img.chefkoch-cdn.de/assets/v2/img/placeholders/3x2/collection.svg"
              }, null, 8, ou)) : (u(), g("img", {
                key: 1,
                class: "ds-list-view-item__image",
                width: "162",
                height: "108",
                loading: "lazy",
                alt: e.title,
                src: e.imgSrc,
                srcset: e.imgSrcSet,
                sizes: e.imgSizes
              }, null, 8, ru)),
              e.isPlus || e.isDeactivated ? (u(), g("div", au, [
                e.isPlus && !e.isDeactivated ? (u(), le(r, { key: 0 })) : A("v-if", !0),
                e.isDeactivated && !e.inOverlay ? (u(), g("div", lu, cu)) : A("v-if", !0)
              ])) : A("v-if", !0)
            ])
          ]),
          b("div", pu, [
            b(
              "div",
              {
                class: M(["ds-list-view-item__column ds-list-view-item__column--info", { "ds-list-view-item__column--full": e.inOverlay }])
              },
              [
                b(
                  "h4",
                  uu,
                  j(e.title),
                  1
                  /* TEXT */
                ),
                b("div", mu, [
                  b(
                    "span",
                    fu,
                    j(e.recipeString),
                    1
                    /* TEXT */
                  ),
                  !e.inOverlay && e.followerCount !== void 0 ? (u(), g("span", gu, [
                    hu,
                    b(
                      "strong",
                      bu,
                      j(e.followerCount),
                      1
                      /* TEXT */
                    ),
                    ke(
                      " " + j(e.followerUnit),
                      1
                      /* TEXT */
                    )
                  ])) : A("v-if", !0)
                ]),
                e.inOverlay ? A("v-if", !0) : (u(), g("div", xu, [
                  e.isDeactivated ? (u(), g("span", _u, "Sammlung wurde deaktiviert")) : (u(), g(
                    X,
                    { key: 1 },
                    [
                      e.isPrivate ? (u(), g("div", Cu, wu)) : (u(), g(
                        X,
                        { key: 1 },
                        [
                          e.authorName ? (u(), le(a, {
                            key: 0,
                            name: e.authorName,
                            isVerified: e.authorIsVerified
                          }, null, 8, ["name", "isVerified"])) : (u(), g("div", Iu, Su))
                        ],
                        2112
                        /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
                      ))
                    ],
                    2112
                    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
                  ))
                ]))
              ],
              2
              /* CLASS */
            ),
            e.inOverlay ? A("v-if", !0) : (u(), g(
              X,
              { key: 0 },
              [
                e.note ? (u(), g("div", Tu, [
                  V(l, {
                    text: e.note,
                    readonly: "",
                    onOnClick: e.onTextToggleClick
                  }, null, 8, ["text", "onOnClick"])
                ])) : A("v-if", !0),
                b("div", $u, [
                  b(
                    "span",
                    Du,
                    j(e.niceDate),
                    1
                    /* TEXT */
                  )
                ])
              ],
              64
              /* STABLE_FRAGMENT */
            ))
          ])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["class", "href", "title"])),
      b("div", Nu, [
        e.isSelectable ? (u(), g(
          X,
          { key: 0 },
          [
            e.isChecked ? (u(), g("i", Eu, "")) : (u(), g("i", Ou, ""))
          ],
          2112
          /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
        )) : fe(e.$slots, "menu", { key: 1 })
      ])
    ],
    2
    /* CLASS */
  );
}
Ds.render = Mu;
Ds.__file = "src/components/DsCollectionListItem/DsCollectionListItem.vue";
const Bu = (e, t, n) => {
  let i = t.top - n.bottom;
  return e && (i = n.top - t.bottom), i + n.height + t.height;
};
var ha = Z({
  components: { DsButton: ot },
  name: "DsContextMenu",
  props: {
    attachToBody: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    show: {
      type: Boolean,
      default: !1
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    actionItems: {
      type: Array
    },
    inScroll: {
      type: Boolean,
      default: !1
    },
    alignRight: {
      type: Boolean,
      default: !1
    },
    alignTop: {
      type: Boolean,
      default: !1
    },
    collision: {
      type: String,
      enum: ["flip", "none"],
      default: "none"
    },
    flyoutOffset: String
  },
  setup(e, { emit: t }) {
    const n = J(null), i = J(null), s = J(null), o = J(null), r = J(e.alignTop), a = J(e.alignRight), { width: l } = Ip();
    ca(n, () => {
      e.show && !(e.attachToBody && l.value < 600) && t("onClickOutside", e.id);
    });
    const d = async () => {
      if (r.value = e.alignTop, a.value = e.alignRight, e.show && o.value && s.value && e.collision === "flip" && $s()) {
        await vn();
        const y = o.value.getBoundingClientRect(), _ = s.value.getBoundingClientRect(), k = Bu(e.alignTop, y, _), K = y.width, U = _.top, ae = window.innerHeight - _.bottom, P = _.left, G = window.innerWidth - _.right;
        e.alignTop ? (U < 0 || _.bottom < k && U < ae) && (r.value = !1) : (ae < 0 || y.bottom > window.innerHeight && U > ae) && (r.value = !0), e.alignRight ? (P < 0 || _.right < K && P < G) && (a.value = !1) : (G < 0 || y.right > window.innerWidth && G < P) && (a.value = !0);
      }
    }, c = () => {
      e.attachToBody && (l.value < 600 ? (document.body.appendChild(o.value), document.body.appendChild(i.value)) : (n.value.appendChild(o.value), n.value.appendChild(i.value)));
    };
    Ze(() => [e.show, e.alignRight, e.alignTop, e.collision], async () => {
      d();
    }), Ze(() => [l.value], async () => {
      d(), c();
    }), at(() => {
      c(), d();
    }), Qt(() => {
      e.attachToBody && (document.body.contains(o.value) && document.body.removeChild(o.value), document.body.contains(i.value) && document.body.removeChild(i.value));
    });
    const f = D(() => `${e.show ? "ds-context-menu--active" : ""}${e.scrollable ? " ds-context-menu--scrollable" : ""}${e.inScroll ? " ds-context-menu--in-scroll" : ""}${a.value ? " ds-context-menu--align-right" : ""}${r.value ? " ds-context-menu--align-top" : ""}`), h = D(() => `${e.flyoutOffset ? `--context-menu-flyout-translate-x: ${e.flyoutOffset}` : ""}`);
    return {
      classes: f,
      flyoutStyles: h,
      canAlignRight: a,
      canAlignTop: r,
      contextMenuRef: n,
      contextMenuBackdropRef: i,
      contextMenuTriggerRef: s,
      contextMenuFlyoutRef: o
    };
  },
  emits: ["onClose", "onActionItemClick", "onClickOutside", "onBackdropClick"],
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    onActionItemClick(e, t) {
      e.preventDefault(), this.$emit("onActionItemClick", t);
    },
    onBackdropClick() {
      this.$emit("onBackdropClick");
    }
  }
});
const Ru = ["id"], Lu = {
  class: "ds-context-menu__btn",
  ref: "contextMenuTriggerRef"
}, Pu = { class: "ds-context-menu__close" }, ju = { class: "ds-context-menu__body" }, Fu = {
  key: 0,
  class: "ds-context-menu__actions"
}, Uu = ["data-test"], zu = ["onClick"], Hu = {
  key: 0,
  class: "chefkoch-icons ds-context-menu__action-icon"
}, Vu = {
  key: 0,
  class: "ds-context-menu__footer"
};
function qu(e, t, n, i, s, o) {
  const r = ie("ds-button");
  return u(), g("div", {
    class: M(["ds-context-menu", e.classes]),
    ref: "contextMenuRef",
    id: e.id
  }, [
    b(
      "div",
      {
        class: M(["ds-context-menu__backdrop", { "ds-context-menu__backdrop--active": e.show }]),
        "aria-hidden": "true",
        onClick: t[0] || (t[0] = (...a) => e.onBackdropClick && e.onBackdropClick(...a)),
        ref: "contextMenuBackdropRef"
      },
      null,
      2
      /* CLASS */
    ),
    b(
      "div",
      Lu,
      [
        fe(e.$slots, "trigger")
      ],
      512
      /* NEED_PATCH */
    ),
    b(
      "div",
      {
        class: M(["ds-context-menu__flyout", { "ds-context-menu__flyout--active": e.show }]),
        style: Mt(e.flyoutStyles),
        ref: "contextMenuFlyoutRef"
      },
      [
        b("div", Pu, [
          V(r, {
            icon: "close",
            mode: "monochrome",
            onOnClick: e.onClose,
            "sr-only": "Schließen"
          }, null, 8, ["onOnClick"])
        ]),
        b("div", ju, [
          fe(e.$slots, "default", {}, () => [
            e.actionItems && e.actionItems.length > 0 ? (u(), g("ul", Fu, [
              (u(!0), g(
                X,
                null,
                Bt(e.actionItems, (a, l) => (u(), g("li", {
                  class: M(["ds-context-menu__action-item", [l === e.actionItems.length - 1 ? "ds-context-menu__action-item--last" : "", a.active ? "ds-context-menu__action-item--active" : ""]]),
                  key: l,
                  "data-test": a.testId
                }, [
                  b("a", {
                    href: "#",
                    class: "ds-context-menu__action-link",
                    onClick: (d) => e.onActionItemClick(d, l)
                  }, [
                    a.icon ? (u(), g(
                      "i",
                      Hu,
                      j(a.icon),
                      1
                      /* TEXT */
                    )) : A("v-if", !0),
                    ke(
                      j(a.text),
                      1
                      /* TEXT */
                    )
                  ], 8, zu)
                ], 10, Uu))),
                128
                /* KEYED_FRAGMENT */
              ))
            ])) : A("v-if", !0)
          ])
        ]),
        e.$slots.footer && e.scrollable ? (u(), g("div", Vu, [
          fe(e.$slots, "footer")
        ])) : A("v-if", !0)
      ],
      6
      /* CLASS, STYLE */
    )
  ], 10, Ru);
}
ha.render = qu;
ha.__file = "src/components/DsContextMenu/DsContextMenu.vue";
var Ns = Z({
  name: "DsDivider",
  props: {
    flat: Boolean
  },
  setup(e) {
    return {
      classes: D(() => `${e.flat ? "ds-divider--flat" : ""}`)
    };
  }
});
function Wu(e, t, n, i, s, o) {
  return u(), g(
    "hr",
    {
      class: M(["ds-divider", e.classes])
    },
    null,
    2
    /* CLASS */
  );
}
Ns.render = Wu;
Ns.__file = "src/components/DsDivider/DsDivider.vue";
var Es = Z({
  name: "DsEggTimer",
  props: {
    progress: {
      type: String
    },
    error: {
      type: Boolean,
      default: !1
    },
    paused: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = D(() => `${e.error || e.paused ? "ds-egg-timer__lines--paused" : ""}`), n = D(() => `${e.error ? "#FF8B90" : "#A7C6AC"}`);
    return {
      linesClasses: t,
      backgroundFillColor: n
    };
  }
});
const Zu = { class: "ds-egg-timer" }, Ku = {
  key: 0,
  class: "ds-egg-timer__progress"
}, Ju = {
  width: "800",
  height: "600",
  viewBox: "0 0 800 600",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yu = /* @__PURE__ */ b(
  "mask",
  {
    id: "egg-timer-mask",
    style: { "mask-type": "alpha" },
    maskUnits: "userSpaceOnUse",
    x: "212",
    y: "84",
    width: "374",
    height: "489"
  },
  [
    /* @__PURE__ */ b("path", {
      d: "M289.54 558.66C289.54 558.66 321.9 572.09 396.78 572.09C471.66 572.09 505.6 558.66 505.6 558.66C557.72 519.91 586 452 586 374.68C586 254.19 517.24 84.24 396.75 84.24C276.26 84.24 212.9 254.24 212.9 374.68C212.93 452 239 519.91 289.54 558.66Z",
      fill: "#F3F4F0"
    })
  ],
  -1
  /* HOISTED */
), Gu = ["fill"], Qu = /* @__PURE__ */ b(
  "path",
  {
    d: "M397.24 600C487.997 600 561.57 582.185 561.57 560.21C561.57 538.235 487.997 520.42 397.24 520.42C306.483 520.42 232.91 538.235 232.91 560.21C232.91 582.185 306.483 600 397.24 600Z",
    fill: "#BABAB7"
  },
  null,
  -1
  /* HOISTED */
), Xu = { key: 0 }, em = /* @__PURE__ */ ui('<path d="M630.39 88.09C638.713 88.09 645.46 81.3429 645.46 73.02C645.46 64.6971 638.713 57.95 630.39 57.95C622.067 57.95 615.32 64.6971 615.32 73.02C615.32 81.3429 622.067 88.09 630.39 88.09Z" fill="#FFDA4D"></path><path d="M676.76 208C674.902 208 673.097 207.373 671.64 206.22C662.24 198.79 661.32 189.78 660.64 183.22C660.03 177.22 659.64 174.46 655.85 171.5C652.06 168.54 649.31 168.76 643.35 169.5C636.79 170.36 627.81 171.55 618.42 164.12C609.03 156.69 608.1 147.68 607.42 141.12C606.81 135.12 606.42 132.36 602.63 129.4C598.84 126.44 596.09 126.66 590.12 127.45C583.56 128.31 574.58 129.5 565.19 122.07C555.8 114.64 554.87 105.63 554.19 99.07C553.58 93.07 553.19 90.31 549.4 87.35C547.676 85.9908 546.563 84.0024 546.305 81.8223C546.047 79.6422 546.666 77.4489 548.025 75.725C549.384 74.0011 551.373 72.8877 553.553 72.6299C555.733 72.372 557.926 72.9908 559.65 74.35C569.05 81.77 569.96 90.79 570.65 97.35C571.27 103.35 571.65 106.11 575.45 109.07C579.25 112.03 581.99 111.81 587.96 111.07C594.51 110.2 603.49 109.01 612.89 116.44C622.29 123.87 623.21 132.88 623.89 139.44C624.5 145.44 624.89 148.2 628.67 151.16C632.45 154.12 635.22 153.9 641.18 153.11C647.74 152.25 656.72 151.11 666.11 158.49C675.5 165.87 676.43 174.92 677.11 181.49C677.72 187.49 678.11 190.24 681.89 193.21C683.251 194.272 684.246 195.734 684.735 197.39C685.223 199.046 685.181 200.814 684.614 202.445C684.048 204.076 682.984 205.489 681.574 206.485C680.164 207.481 678.477 208.011 676.75 208H676.76Z" fill="#FF888F"></path><path d="M165.31 414.71C173.633 414.71 180.38 407.963 180.38 399.64C180.38 391.317 173.633 384.57 165.31 384.57C156.987 384.57 150.24 391.317 150.24 399.64C150.24 407.963 156.987 414.71 165.31 414.71Z" fill="#FFCD12"></path><path d="M128.09 508C125.462 507.987 122.906 507.14 120.792 505.58C118.677 504.02 117.112 501.829 116.323 499.322C115.534 496.816 115.562 494.123 116.403 491.634C117.243 489.144 118.853 486.985 121 485.47L164.9 454.61C167.594 452.805 170.888 452.126 174.077 452.719C177.265 453.312 180.095 455.13 181.96 457.783C183.825 460.436 184.577 463.714 184.056 466.915C183.535 470.116 181.781 472.986 179.17 474.91V474.91L135.26 505.76C133.161 507.234 130.655 508.017 128.09 508V508Z" fill="#A7C6AC"></path><path d="M113.41 423.23C110.712 423.234 108.087 422.358 105.934 420.733C103.78 419.109 102.216 416.825 101.48 414.23L86.9 362.55C86.0945 359.412 86.5484 356.083 88.1646 353.275C89.7808 350.466 92.4312 348.402 95.5494 347.521C98.6677 346.641 102.007 347.016 104.852 348.564C107.698 350.113 109.826 352.714 110.78 355.81L125.35 407.46C125.792 409.029 125.92 410.67 125.727 412.289C125.535 413.908 125.025 415.473 124.227 416.895C123.429 418.317 122.359 419.567 121.078 420.575C119.797 421.583 118.33 422.329 116.76 422.77C115.669 423.073 114.542 423.227 113.41 423.23V423.23Z" fill="#FF8B90"></path>', 5), tm = [
  em
], nm = /* @__PURE__ */ b(
  "path",
  {
    d: "M289.54 558.66C289.54 558.66 321.9 572.09 396.78 572.09C471.66 572.09 505.6 558.66 505.6 558.66C557.72 519.91 586 452 586 374.68C586 254.19 517.24 84.24 396.75 84.24C276.26 84.24 212.9 254.24 212.9 374.68C212.93 452 239 519.91 289.54 558.66Z",
    fill: "#F3F4F0"
  },
  null,
  -1
  /* HOISTED */
), im = /* @__PURE__ */ b(
  "path",
  {
    d: "M214.4 405.7H584.45C584.73 402.96 584.977 400.203 585.19 397.43H213.72C213.907 400.203 214.133 402.96 214.4 405.7Z",
    fill: "#9B9A97"
  },
  null,
  -1
  /* HOISTED */
), sm = /* @__PURE__ */ b(
  "path",
  {
    d: "M399.19 420.17L381.74 458.59H416.63L399.19 420.17Z",
    fill: "#FF6067"
  },
  null,
  -1
  /* HOISTED */
), om = { key: 1 }, rm = /* @__PURE__ */ ui('<path d="M484.67 67.91C485.078 66.7016 485.724 65.5867 486.568 64.6304C487.412 63.6742 488.438 62.8958 489.587 62.3406C490.735 61.7855 491.982 61.4648 493.256 61.3972C494.53 61.3297 495.804 61.5167 497.005 61.9472C498.206 62.3778 499.309 63.0433 500.249 63.905C501.19 64.7666 501.949 65.807 502.483 66.9654C503.017 68.1238 503.315 69.377 503.359 70.6518C503.403 71.9266 503.193 73.1974 502.74 74.39C502.74 74.39 502.74 74.46 502.74 74.5C501.767 76.7493 499.97 78.5412 497.719 79.5086C495.467 80.476 492.93 80.5455 490.629 79.7029C488.327 78.8603 486.435 77.1695 485.341 74.9769C484.246 72.7842 484.031 70.2559 484.74 67.91H484.67ZM524.85 12.91C523.31 17.12 518.7 26 510.4 40.2L503.31 52.86L498.16 51L500.91 36.76C503.67 20.53 505.91 10.76 507.48 6.57997C509.69 0.579973 514.09 -1.15003 519.48 0.799973C524.87 2.74997 527.09 6.88997 524.89 12.93L524.85 12.91Z" fill="#FF6067"></path><path d="M217.23 155.14C214.302 152.121 212.674 148.075 212.694 143.87C212.713 139.665 214.38 135.634 217.336 132.643C220.292 129.652 224.302 127.938 228.507 127.868C232.712 127.798 236.776 129.378 239.83 132.27L239.98 132.41C242.96 135.434 244.622 139.514 244.606 143.759C244.589 148.004 242.894 152.07 239.891 155.071C236.888 158.072 232.82 159.763 228.575 159.776C224.33 159.789 220.251 158.122 217.23 155.14V155.14ZM162.08 55.26C167.39 60.57 177.7 73.87 193.33 96.49L207.54 116.19L201.04 122.69L181.35 108.45C158.65 92.79 145.47 82.45 140.16 77.15C132.54 69.53 133.09 61.64 139.83 54.91C146.57 48.18 154.46 47.64 162.08 55.26V55.26Z" fill="#595852"></path><path d="M622.5 74.21C613.6 61.66 601.95 60.7001 594.5 66.0101C590.942 68.4416 588.44 72.1339 587.5 76.34C580.81 73.8 574.57 74.2 569.64 77.7C560.67 84 560.8 93 563.71 106C566.14 116.75 566.87 122.17 561.84 125.73C557.2 129.02 551.49 127.86 546.73 121.14C546.243 120.508 545.805 119.839 545.42 119.14L548.56 113.94C552.06 108.64 552.13 105.18 549.81 101.94C548.27 99.7701 545.72 98.4601 542 99.9401C535.39 104.62 535.23 115.26 542.52 125.54C551 137.54 563.17 138.98 571.26 133.25C574.65 130.957 577.042 127.461 577.95 123.47C584.24 125.85 590.42 125.78 595.54 122.15C604.23 116 604.92 107.79 601.15 92.65C599.08 83.87 598.45 77.34 603.78 73.57C608.02 70.57 613.53 71.86 618.3 78.57C618.811 79.2506 619.269 79.9694 619.67 80.72L616.46 85.81C613.03 91.21 612.96 94.67 615.21 97.81C616.82 100.09 619.38 101.39 623.1 99.95C629.71 95.23 629.79 84.49 622.5 74.21ZM576.43 103.7C574.2 94.3 573.16 87.1801 579.08 82.9801C581.364 81.4829 584.077 80.78 586.8 80.9801C586.716 85.9122 587.315 90.8322 588.58 95.6C591.21 106.21 592.24 112.46 586.58 116.44C584.209 117.997 581.416 118.786 578.58 118.7C578.525 113.627 577.802 108.584 576.43 103.7V103.7Z" fill="#FF888F"></path><path d="M209.12 230.5C207.839 231.389 206.296 231.819 204.74 231.72C194.74 231.09 189.74 225.32 186.19 221.1C182.91 217.27 181.3 215.56 177.3 215.31C173.3 215.06 171.48 216.55 167.75 219.94C163.64 223.66 158.02 228.77 148.01 228.13C138 227.49 133.06 221.73 129.46 217.51C126.18 213.68 124.57 211.97 120.56 211.72C116.55 211.47 114.75 212.96 111.01 216.35C106.91 220.07 101.29 225.17 91.27 224.54C81.25 223.91 76.27 218.14 72.72 213.93C69.44 210.09 67.82 208.39 63.82 208.13C62.0432 207.942 60.4079 207.074 59.2552 205.709C58.1026 204.344 57.5218 202.586 57.634 200.803C57.7463 199.02 58.5429 197.349 59.8577 196.139C61.1724 194.929 62.9036 194.274 64.69 194.31C74.69 194.94 79.69 200.71 83.25 204.92C86.52 208.76 88.14 210.46 92.14 210.72C96.14 210.98 97.96 209.48 101.69 206.09C105.8 202.37 111.42 197.26 121.44 197.9C131.46 198.54 136.39 204.3 139.99 208.51C143.27 212.35 144.88 214.05 148.88 214.31C152.88 214.57 154.7 213.07 158.43 209.68C162.53 205.95 168.15 200.85 178.17 201.49C188.19 202.13 193.17 207.89 196.72 212.1C200 215.94 201.61 217.65 205.61 217.9C207.048 217.987 208.423 218.522 209.543 219.428C210.664 220.335 211.473 221.568 211.858 222.957C212.243 224.345 212.186 225.819 211.693 227.173C211.201 228.527 210.297 229.694 209.11 230.51L209.12 230.5Z" fill="#FFB7BA"></path><path d="M84.46 347.23C89.73 361.15 100.39 364.87 108.7 361.72C112.64 360.303 115.896 357.444 117.81 353.72C123.45 357.72 129.38 358.85 134.81 356.78C144.64 353.05 146.7 344.62 147.17 331.66C147.5 321 148.17 315.75 153.71 313.66C158.85 311.66 163.91 314.18 166.71 321.66C167.009 322.384 167.253 323.13 167.44 323.89L163.24 327.99C158.67 332.11 157.77 335.33 159.14 338.99C160.05 341.4 162.14 343.24 165.95 342.79C173.28 340.01 176.01 330.08 171.7 318.68C166.7 305.42 155.7 301.08 146.7 304.48C142.992 305.819 139.922 308.504 138.1 312C132.81 308.25 127.01 306.81 121.33 309C111.71 312.65 109.06 320.18 108.9 335.28C108.71 344 107.71 350.28 101.8 352.51C97.1 354.29 92.26 351.74 89.44 344.29C89.127 343.531 88.8729 342.748 88.68 341.95L92.92 337.95C97.44 333.72 98.34 330.5 97.02 326.95C96.02 324.43 94.02 322.59 90.16 323.04C82.83 325.79 80.14 335.84 84.46 347.23ZM134.74 330.78C134.53 340.13 133.74 347.06 127.22 349.55C124.719 350.419 122.002 350.436 119.49 349.6C120.772 345 121.408 340.245 121.38 335.47C121.5 324.9 122.07 318.79 128.3 316.47C130.885 315.592 133.678 315.529 136.3 316.29C135.158 321.033 134.633 325.903 134.74 330.78V330.78Z" fill="#FF6067"></path><path d="M599.67 194.7C599.496 194.218 599.359 193.723 599.26 193.22C598.724 190.531 599.279 187.739 600.802 185.458C602.325 183.178 604.691 181.596 607.38 181.06L669 168.81C671.688 168.28 674.477 168.839 676.752 170.364C679.028 171.89 680.605 174.257 681.135 176.945C681.665 179.633 681.106 182.422 679.581 184.697C678.055 186.973 675.688 188.55 673 189.08L611.42 201.34C608.991 201.824 606.469 201.42 604.312 200.201C602.156 198.983 600.509 197.031 599.67 194.7V194.7Z" fill="#BDBDB9"></path><path d="M562.17 241.32C561.583 239.633 560.977 237.967 560.35 236.32L503.57 270.38L482.42 228.76H456.64L428.83 262.12L389.83 237.98L389.57 237.81L347.62 262L328.12 232.75L277.42 289.19L234.16 244.78C233.553 246.667 232.953 248.563 232.36 250.47L277.58 296.9L327.5 241.32L346 269L389.48 243.87L430 269L459.15 234H479.24L501.24 277.29L501.5 277.79L562.18 241.38L562.17 241.32Z" fill="#BABAB7"></path>', 7), am = [
  rm
], lm = { mask: "url(#egg-timer-mask)" }, dm = /* @__PURE__ */ ui('<svg x="-49.5%"><path d="M597.56 304.41C597.017 304.41 596.479 304.517 595.977 304.725C595.475 304.934 595.02 305.239 594.636 305.623C594.252 306.008 593.948 306.464 593.741 306.966C593.535 307.469 593.429 308.007 593.43 308.55V373.66C593.43 374.755 593.865 375.806 594.64 376.58C595.414 377.355 596.465 377.79 597.56 377.79C598.655 377.79 599.706 377.355 600.48 376.58C601.255 375.806 601.69 374.755 601.69 373.66V308.55C601.691 308.007 601.585 307.469 601.379 306.966C601.172 306.464 600.868 306.008 600.484 305.623C600.1 305.239 599.645 304.934 599.143 304.725C598.641 304.517 598.103 304.41 597.56 304.41V304.41Z" fill="#595852"></path><path d="M557.44 341.62C556.344 341.62 555.292 342.055 554.516 342.829C553.74 343.603 553.303 344.654 553.3 345.75V373.66C553.352 374.722 553.811 375.722 554.58 376.455C555.35 377.188 556.372 377.597 557.435 377.597C558.498 377.597 559.52 377.188 560.29 376.455C561.059 375.722 561.518 374.722 561.57 373.66V345.75C561.57 344.655 561.135 343.604 560.36 342.83C559.586 342.055 558.535 341.62 557.44 341.62V341.62Z" fill="#595852"></path><path d="M517.3 341.62C516.205 341.62 515.154 342.055 514.38 342.83C513.605 343.604 513.17 344.655 513.17 345.75V373.66C513.222 374.722 513.681 375.722 514.45 376.455C515.22 377.188 516.242 377.597 517.305 377.597C518.368 377.597 519.39 377.188 520.16 376.455C520.929 375.722 521.388 374.722 521.44 373.66V345.75C521.44 345.207 521.333 344.669 521.125 344.167C520.917 343.665 520.611 343.21 520.227 342.826C519.842 342.442 519.386 342.138 518.884 341.932C518.381 341.725 517.843 341.619 517.3 341.62V341.62Z" fill="#595852"></path><path d="M478.2 341.62C477.105 341.62 476.054 342.055 475.28 342.83C474.505 343.604 474.07 344.655 474.07 345.75V373.66C474.122 374.722 474.581 375.722 475.35 376.455C476.12 377.188 477.142 377.597 478.205 377.597C479.268 377.597 480.29 377.188 481.06 376.455C481.829 375.722 482.288 374.722 482.34 373.66V345.75C482.34 345.207 482.233 344.669 482.025 344.167C481.816 343.665 481.511 343.21 481.127 342.826C480.742 342.442 480.286 342.138 479.784 341.932C479.281 341.725 478.743 341.619 478.2 341.62Z" fill="#595852"></path><path d="M439.1 341.62C438.005 341.62 436.954 342.055 436.18 342.83C435.405 343.604 434.97 344.655 434.97 345.75V373.66C435.022 374.722 435.481 375.722 436.25 376.455C437.02 377.188 438.042 377.597 439.105 377.597C440.168 377.597 441.19 377.188 441.96 376.455C442.729 375.722 443.188 374.722 443.24 373.66V345.75C443.237 344.654 442.8 343.603 442.024 342.829C441.248 342.055 440.196 341.62 439.1 341.62Z" fill="#595852"></path><path d="M400 304.41C399.457 304.41 398.919 304.517 398.417 304.725C397.915 304.934 397.46 305.239 397.076 305.623C396.692 306.008 396.388 306.464 396.182 306.966C395.975 307.469 395.869 308.007 395.87 308.55V373.66C395.87 374.755 396.305 375.806 397.08 376.58C397.854 377.355 398.905 377.79 400 377.79C401.095 377.79 402.146 377.355 402.92 376.58C403.695 375.806 404.13 374.755 404.13 373.66V308.55C404.131 308.007 404.025 307.469 403.819 306.966C403.612 306.464 403.308 306.008 402.924 305.623C402.54 305.239 402.085 304.934 401.583 304.725C401.081 304.517 400.543 304.41 400 304.41V304.41Z" fill="#595852"></path><path d="M360.9 341.62C359.804 341.62 358.752 342.055 357.976 342.829C357.2 343.603 356.763 344.654 356.76 345.75V373.66C356.812 374.722 357.271 375.722 358.04 376.455C358.81 377.188 359.832 377.597 360.895 377.597C361.958 377.597 362.98 377.188 363.75 376.455C364.519 375.722 364.978 374.722 365.03 373.66V345.75C365.03 344.655 364.595 343.604 363.82 342.83C363.046 342.055 361.995 341.62 360.9 341.62V341.62Z" fill="#595852"></path><path d="M320.76 341.62C319.665 341.62 318.614 342.055 317.84 342.83C317.065 343.604 316.63 344.655 316.63 345.75V373.66C316.682 374.722 317.141 375.722 317.91 376.455C318.68 377.188 319.702 377.597 320.765 377.597C321.828 377.597 322.85 377.188 323.62 376.455C324.389 375.722 324.848 374.722 324.9 373.66V345.75C324.9 345.207 324.793 344.669 324.585 344.167C324.376 343.665 324.071 343.21 323.687 342.826C323.302 342.442 322.846 342.138 322.344 341.932C321.841 341.725 321.303 341.619 320.76 341.62Z" fill="#595852"></path><path d="M281.66 341.62C280.565 341.62 279.514 342.055 278.74 342.83C277.965 343.604 277.53 344.655 277.53 345.75V373.66C277.582 374.722 278.041 375.722 278.81 376.455C279.58 377.188 280.602 377.597 281.665 377.597C282.728 377.597 283.75 377.188 284.52 376.455C285.289 375.722 285.748 374.722 285.8 373.66V345.75C285.8 345.207 285.693 344.669 285.485 344.167C285.277 343.665 284.971 343.21 284.587 342.826C284.202 342.442 283.746 342.138 283.244 341.932C282.741 341.725 282.203 341.619 281.66 341.62V341.62Z" fill="#595852"></path><path d="M242.22 341.62C241.677 341.619 241.139 341.725 240.636 341.932C240.134 342.138 239.678 342.442 239.293 342.826C238.909 343.21 238.604 343.665 238.395 344.167C238.187 344.669 238.08 345.207 238.08 345.75V373.66C238.132 374.722 238.591 375.722 239.36 376.455C240.13 377.188 241.152 377.597 242.215 377.597C243.278 377.597 244.3 377.188 245.07 376.455C245.839 375.722 246.298 374.722 246.35 373.66V345.75C246.35 345.208 246.243 344.671 246.036 344.17C245.828 343.668 245.524 343.213 245.14 342.83C244.757 342.446 244.302 342.142 243.8 341.934C243.299 341.727 242.762 341.62 242.22 341.62V341.62Z" fill="#595852"></path></svg><path d="M557.44 341.62C556.344 341.62 555.292 342.055 554.516 342.829C553.74 343.603 553.303 344.654 553.3 345.75V373.66C553.352 374.722 553.811 375.722 554.58 376.455C555.35 377.188 556.372 377.597 557.435 377.597C558.498 377.597 559.52 377.188 560.29 376.455C561.059 375.722 561.518 374.722 561.57 373.66V345.75C561.57 344.655 561.135 343.604 560.36 342.83C559.586 342.055 558.535 341.62 557.44 341.62V341.62Z" fill="#595852"></path><path d="M517.3 341.62C516.205 341.62 515.154 342.055 514.38 342.83C513.605 343.604 513.17 344.655 513.17 345.75V373.66C513.222 374.722 513.681 375.722 514.45 376.455C515.22 377.188 516.242 377.597 517.305 377.597C518.368 377.597 519.39 377.188 520.16 376.455C520.929 375.722 521.388 374.722 521.44 373.66V345.75C521.44 345.207 521.333 344.669 521.125 344.167C520.917 343.665 520.611 343.21 520.227 342.826C519.842 342.442 519.386 342.138 518.884 341.932C518.381 341.725 517.843 341.619 517.3 341.62V341.62Z" fill="#595852"></path><path d="M478.2 341.62C477.105 341.62 476.054 342.055 475.28 342.83C474.505 343.604 474.07 344.655 474.07 345.75V373.66C474.122 374.722 474.581 375.722 475.35 376.455C476.12 377.188 477.142 377.597 478.205 377.597C479.268 377.597 480.29 377.188 481.06 376.455C481.829 375.722 482.288 374.722 482.34 373.66V345.75C482.34 345.207 482.233 344.669 482.025 344.167C481.816 343.665 481.511 343.21 481.127 342.826C480.742 342.442 480.286 342.138 479.784 341.932C479.281 341.725 478.743 341.619 478.2 341.62Z" fill="#595852"></path><path d="M439.1 341.62C438.005 341.62 436.954 342.055 436.18 342.83C435.405 343.604 434.97 344.655 434.97 345.75V373.66C435.022 374.722 435.481 375.722 436.25 376.455C437.02 377.188 438.042 377.597 439.105 377.597C440.168 377.597 441.19 377.188 441.96 376.455C442.729 375.722 443.188 374.722 443.24 373.66V345.75C443.237 344.654 442.8 343.603 442.024 342.829C441.248 342.055 440.196 341.62 439.1 341.62Z" fill="#595852"></path><path d="M400 304.41C399.457 304.41 398.919 304.517 398.417 304.725C397.915 304.934 397.46 305.239 397.076 305.623C396.692 306.008 396.388 306.464 396.182 306.966C395.975 307.469 395.869 308.007 395.87 308.55V373.66C395.87 374.755 396.305 375.806 397.08 376.58C397.854 377.355 398.905 377.79 400 377.79C401.095 377.79 402.146 377.355 402.92 376.58C403.695 375.806 404.13 374.755 404.13 373.66V308.55C404.131 308.007 404.025 307.469 403.819 306.966C403.612 306.464 403.308 306.008 402.924 305.623C402.54 305.239 402.085 304.934 401.583 304.725C401.081 304.517 400.543 304.41 400 304.41V304.41Z" fill="#595852"></path><path d="M360.9 341.62C359.804 341.62 358.752 342.055 357.976 342.829C357.2 343.603 356.763 344.654 356.76 345.75V373.66C356.812 374.722 357.271 375.722 358.04 376.455C358.81 377.188 359.832 377.597 360.895 377.597C361.958 377.597 362.98 377.188 363.75 376.455C364.519 375.722 364.978 374.722 365.03 373.66V345.75C365.03 344.655 364.595 343.604 363.82 342.83C363.046 342.055 361.995 341.62 360.9 341.62V341.62Z" fill="#595852"></path><path d="M320.76 341.62C319.665 341.62 318.614 342.055 317.84 342.83C317.065 343.604 316.63 344.655 316.63 345.75V373.66C316.682 374.722 317.141 375.722 317.91 376.455C318.68 377.188 319.702 377.597 320.765 377.597C321.828 377.597 322.85 377.188 323.62 376.455C324.389 375.722 324.848 374.722 324.9 373.66V345.75C324.9 345.207 324.793 344.669 324.585 344.167C324.376 343.665 324.071 343.21 323.687 342.826C323.302 342.442 322.846 342.138 322.344 341.932C321.841 341.725 321.303 341.619 320.76 341.62Z" fill="#595852"></path><path d="M281.66 341.62C280.565 341.62 279.514 342.055 278.74 342.83C277.965 343.604 277.53 344.655 277.53 345.75V373.66C277.582 374.722 278.041 375.722 278.81 376.455C279.58 377.188 280.602 377.597 281.665 377.597C282.728 377.597 283.75 377.188 284.52 376.455C285.289 375.722 285.748 374.722 285.8 373.66V345.75C285.8 345.207 285.693 344.669 285.485 344.167C285.277 343.665 284.971 343.21 284.587 342.826C284.202 342.442 283.746 342.138 283.244 341.932C282.741 341.725 282.203 341.619 281.66 341.62V341.62Z" fill="#595852"></path><path d="M242.22 341.62C241.677 341.619 241.139 341.725 240.636 341.932C240.134 342.138 239.678 342.442 239.293 342.826C238.909 343.21 238.604 343.665 238.395 344.167C238.187 344.669 238.08 345.207 238.08 345.75V373.66C238.132 374.722 238.591 375.722 239.36 376.455C240.13 377.188 241.152 377.597 242.215 377.597C243.278 377.597 244.3 377.188 245.07 376.455C245.839 375.722 246.298 374.722 246.35 373.66V345.75C246.35 345.208 246.243 344.671 246.036 344.17C245.828 343.668 245.524 343.213 245.14 342.83C244.757 342.446 244.302 342.142 243.8 341.934C243.299 341.727 242.762 341.62 242.22 341.62V341.62Z" fill="#595852"></path>', 10), cm = [
  dm
];
function pm(e, t, n, i, s, o) {
  return u(), g("div", Zu, [
    e.progress && !e.error ? (u(), g(
      "div",
      Ku,
      j(e.progress),
      1
      /* TEXT */
    )) : A("v-if", !0),
    (u(), g("svg", Ju, [
      Yu,
      b("path", {
        d: "M628.75 236.06C472.19 215.8 442.35 180.32 330.34 91.87C218.33 3.42 28.22 130.26 104.76 271.45C181.3 412.64 547.19 500.88 630.59 468.11C764.14 415.63 785.31 256.31 628.75 236.06Z",
        fill: e.backgroundFillColor
      }, null, 8, Gu),
      Qu,
      e.error ? A("v-if", !0) : (u(), g("g", Xu, tm)),
      nm,
      im,
      sm,
      e.error ? (u(), g("g", om, am)) : A("v-if", !0),
      b("g", lm, [
        b(
          "g",
          {
            class: M(["ds-egg-timer__lines", e.linesClasses])
          },
          cm,
          2
          /* CLASS */
        )
      ])
    ]))
  ]);
}
Es.render = pm;
Es.__file = "src/components/DsEggTimer/DsEggTimer.vue";
var Os = Z({
  name: "DsInlineNotification",
  components: {
    DsButton: ot
  },
  emits: ["onButtonClick", "onClose"],
  props: {
    buttonLabel: String,
    closable: Boolean,
    copy: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      enum: [
        "info",
        "success",
        "warning",
        "danger"
      ],
      default: "info"
    },
    title: String
  },
  setup(e, { emit: t }) {
    return {
      classes: D(() => `ds-notification--${e.mode}`),
      onButtonClick: (o) => {
        t("onButtonClick", o);
      },
      onClose: (o) => {
        t("onClose", o);
      }
    };
  }
});
const um = {
  key: 0,
  class: "ds-notification__close"
}, mm = {
  key: 1,
  class: "ds-notification__title ds-text-sans"
}, fm = { class: "ds-notification__body" }, gm = {
  key: 2,
  class: "ds-notification__btn"
};
function hm(e, t, n, i, s, o) {
  const r = ie("DsButton");
  return u(), g(
    "div",
    {
      class: M(["ds-notification", [{ "ds-notification--closable": e.closable }, e.classes]])
    },
    [
      e.closable ? (u(), g("div", um, [
        V(r, {
          icon: "close",
          mode: "monochrome",
          onOnClick: e.onClose,
          "sr-only": "Schließen"
        }, null, 8, ["onOnClick"])
      ])) : A("v-if", !0),
      e.title ? (u(), g(
        "h4",
        mm,
        j(e.title),
        1
        /* TEXT */
      )) : A("v-if", !0),
      b(
        "div",
        fm,
        j(e.copy),
        1
        /* TEXT */
      ),
      e.buttonLabel ? (u(), g("div", gm, [
        V(r, {
          mode: "tertiary",
          flat: "",
          label: e.buttonLabel,
          onOnClick: e.onButtonClick
        }, null, 8, ["label", "onOnClick"])
      ])) : A("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
Os.render = hm;
Os.__file = "src/components/DsInlineNotification/DsInlineNotification.vue";
var Ms = Z({
  name: "DsInputChip",
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      required: !0
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    return {
      onClick: (i) => {
        t("onClick", i);
      }
    };
  }
});
const bm = ["aria-label", "id"], xm = { class: "ds-input-chip__label" }, _m = /* @__PURE__ */ b(
  "i",
  { class: "ds-input-chip__icon ds-input-chip__icon--trailing chefkoch-icons" },
  "",
  -1
  /* HOISTED */
);
function Cm(e, t, n, i, s, o) {
  return u(), g("div", {
    class: "ds-input-chip",
    "aria-label": e.label,
    onClick: t[0] || (t[0] = (r) => e.onClick(r)),
    id: e.id
  }, [
    b(
      "span",
      xm,
      j(e.label),
      1
      /* TEXT */
    ),
    _m
  ], 8, bm);
}
Ms.render = Cm;
Ms.__file = "src/components/DsInputChip/DsInputChip.vue";
var hi = Z({
  name: "DsOverlay",
  components: {
    DsButton: ot,
    DsButtonBox: fi
  },
  props: {
    overlayId: {
      type: String,
      required: !0,
      default: "modal"
    },
    size: {
      type: String,
      enum: ["default", "large", "xlarge"],
      default: "default"
    },
    title: {
      type: String
    },
    show: {
      required: !0,
      type: Boolean,
      default: !1
    },
    closeOnEscape: {
      type: Boolean,
      default: !0
    },
    hideCloseButton: {
      type: Boolean,
      default: !1
    },
    footerShadow: {
      type: Boolean,
      default: !1
    },
    centeredMobile: {
      type: Boolean,
      default: !1
    },
    noHead: {
      type: Boolean,
      default: !1
    },
    noFooter: {
      type: Boolean,
      default: !1
    },
    overlayClasses: String,
    primaryDisabled: Boolean,
    primaryLabel: String,
    secondaryLabel: String,
    tertiaryLabel: String,
    primaryMode: {
      type: String,
      default: "primary",
      enum: ["primary", "danger"]
    }
  },
  setup(e, { emit: t }) {
    const n = J(null);
    ca(n, () => {
      e.show && t("onBackdropClick", e.overlayId);
    });
    const i = () => {
      t("onClose", e.overlayId);
    }, { attachEscapeKeyHandler: s, removeEscapeKeyHandler: o } = ua(i), r = D(() => `${e.overlayClasses || ""}${e.size !== "default" ? ` ds-overlay--${e.size}` : ""}`), a = D(() => `${e.noHead ? "ds-overlay__content--no-head" : ""}${e.centeredMobile ? " ds-text-center-to-xs" : ""}`), l = D(() => `${e.overlayId}-title`), d = D(() => !!e.secondaryLabel), c = D(() => !!e.tertiaryLabel);
    return at(s), Qt(o), Ze(() => [e.show, e.closeOnEscape], async () => {
      e.show && e.closeOnEscape ? s() : o();
    }), {
      classes: r,
      contentClasses: a,
      overlayTitleId: l,
      hasSecondary: d,
      hasTertiary: c,
      onClose: i,
      overlayInnerRef: n
    };
  },
  methods: {
    onPrimaryClick() {
      this.$emit("onPrimaryClick", this.overlayId);
    },
    onSecondaryClick() {
      this.$emit("onSecondaryClick", this.overlayId);
    },
    onTertiaryClick() {
      this.$emit("onTertiaryClick", this.overlayId);
    }
  }
});
const ym = {
  key: 0,
  class: "ds-overlay-backdrop"
}, vm = ["aria-labelledby"], wm = {
  class: "ds-overlay__inner",
  ref: "overlayInnerRef"
}, Im = {
  key: 0,
  class: "ds-overlay__close"
}, km = {
  key: 0,
  class: "ds-overlay__head"
}, Am = ["id"], Sm = { class: "ds-overlay__body" };
function Tm(e, t, n, i, s, o) {
  const r = ie("ds-button"), a = ie("ds-button-box");
  return u(), le(Ts, { name: "ds-overlay-fade" }, {
    default: Ae(() => [
      e.show ? (u(), g("div", ym, [
        b("div", {
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": e.overlayTitleId,
          class: M(["ds-overlay", e.classes])
        }, [
          b(
            "div",
            wm,
            [
              e.hideCloseButton ? A("v-if", !0) : (u(), g("div", Im, [
                V(r, {
                  icon: "close",
                  mode: "monochrome",
                  onOnClick: e.onClose,
                  "sr-only": "Schließen"
                }, null, 8, ["onOnClick"])
              ])),
              b(
                "div",
                {
                  class: M(["ds-overlay__content", e.contentClasses])
                },
                [
                  e.noHead ? A("v-if", !0) : (u(), g("div", km, [
                    fe(e.$slots, "head", {}, () => [
                      b("h4", {
                        class: "ds-overlay__title ds-text-sans",
                        id: e.overlayTitleId
                      }, j(e.title), 9, Am)
                    ])
                  ])),
                  b("div", Sm, [
                    fe(e.$slots, "default")
                  ]),
                  e.noFooter ? A("v-if", !0) : (u(), g(
                    "div",
                    {
                      key: 1,
                      class: M(["ds-overlay__footer", { "ds-overlay__footer--shadow": e.footerShadow }])
                    },
                    [
                      fe(e.$slots, "footer", {}, () => [
                        V(a, { stackedMobile: e.centeredMobile }, kd({
                          second: Ae(() => [
                            V(r, {
                              onOnClick: e.onPrimaryClick,
                              label: e.primaryLabel,
                              mode: e.primaryMode,
                              disabled: e.primaryDisabled
                            }, null, 8, ["onOnClick", "label", "mode", "disabled"])
                          ]),
                          _: 2
                          /* DYNAMIC */
                        }, [
                          e.hasSecondary ? {
                            name: "first",
                            fn: Ae(() => [
                              V(r, {
                                onOnClick: e.onSecondaryClick,
                                label: e.secondaryLabel,
                                mode: "secondary"
                              }, null, 8, ["onOnClick", "label"])
                            ])
                          } : void 0,
                          e.hasTertiary ? {
                            name: "third",
                            fn: Ae(() => [
                              V(r, {
                                onOnClick: e.onTertiaryClick,
                                label: e.tertiaryLabel,
                                mode: "tertiary",
                                flat: ""
                              }, null, 8, ["onOnClick", "label"])
                            ])
                          } : void 0
                        ]), 1032, ["stackedMobile"])
                      ])
                    ],
                    2
                    /* CLASS */
                  ))
                ],
                2
                /* CLASS */
              )
            ],
            512
            /* NEED_PATCH */
          )
        ], 10, vm)
      ])) : A("v-if", !0)
    ]),
    _: 3
    /* FORWARDED */
  });
}
function ba(e, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (!(!e || typeof document > "u")) {
    var i = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.type = "text/css", n === "top" && i.firstChild ? i.insertBefore(s, i.firstChild) : i.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e));
  }
}
var $m = `
.ds-overlay-fade-enter,
  .ds-overlay-fade-enter-from,
  .ds-overlay-fade-leave-to {
    opacity: 0;
}
.ds-overlay-fade-enter-active,
  .ds-overlay-fade-leave-active {
    -webkit-transition: opacity .5s ease;
    -o-transition: opacity .5s ease;
    transition: opacity .5s ease;
}
`;
ba($m);
hi.render = Tm;
hi.__file = "src/components/DsOverlay/DsOverlay.vue";
var xa = Z({
  name: "DsLoadingOverlay",
  components: { DsEggTimer: Es, DsOverlay: hi },
  props: {
    headline: String,
    show: {
      required: !0,
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !1
    },
    progress: {
      type: String
    },
    error: {
      type: Boolean,
      default: !1
    },
    paused: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return {
      classes: D(() => `ds-overlay--loader${e.closable ? " ds-overlay--closable" : ""}`)
    };
  },
  methods: {
    onClose(e) {
      this.$emit("onClose", e);
    },
    onBackdropClick(e) {
      this.$emit("onBackdropClick", e);
    }
  }
});
const Dm = { class: "ds-overlay__loader" }, Nm = {
  key: 0,
  class: "ds-overlay__headline ds-text-sans"
};
function Em(e, t, n, i, s, o) {
  const r = ie("ds-egg-timer"), a = ie("ds-overlay");
  return u(), le(a, {
    "no-head": "",
    "hide-close-button": !e.closable,
    "no-footer": "",
    "overlay-id": "loading-overlay",
    show: e.show,
    "overlay-classes": e.classes,
    onOnClose: e.onClose,
    onOnBackdropClick: e.onBackdropClick
  }, {
    default: Ae(() => [
      b("div", Dm, [
        V(r, {
          progress: e.progress,
          error: e.error,
          paused: e.paused
        }, null, 8, ["progress", "error", "paused"])
      ]),
      e.headline ? (u(), g(
        "h3",
        Nm,
        j(e.headline),
        1
        /* TEXT */
      )) : A("v-if", !0),
      fe(e.$slots, "default")
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["hide-close-button", "show", "overlay-classes", "onOnClose", "onOnBackdropClick"]);
}
xa.render = Em;
xa.__file = "src/components/DsLoadingOverlay/DsLoadingOverlay.vue";
var _a = Z({
  name: "DsPromotionTeaser",
  components: {
    DsPlusBadge: vt
  },
  props: {
    centerContent: {
      type: Boolean,
      default: !1
    },
    claim: {
      type: String
    },
    headline: {
      type: String
    },
    href: {
      type: String,
      default: "#"
    },
    imgSrc: {
      type: String,
      required: !0
    },
    imgSrcHiRes: {
      type: String,
      required: !0
    },
    large: {
      type: Boolean,
      default: !1
    },
    linkTitle: {
      type: String,
      required: !1
    },
    showPlusBadge: {
      type: Boolean
    },
    showPlusLogo: {
      type: Boolean
    },
    type: {
      type: String,
      enum: [
        "card",
        "banner"
      ],
      default: "card"
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const n = (o) => {
      t("onClick", o);
    }, i = D(() => `ds-promotion-teaser--${e.type}`), s = D(() => `${e.imgSrc} 1x, ${e.imgSrcHiRes} 2x`);
    return {
      modifierClass: i,
      onClick: n,
      srcSet: s
    };
  }
});
const Om = ["href", "title"], Mm = { class: "ds-promotion-teaser__image-wrap ds-teaser-link__image-wrap" }, Bm = ["src", "srcset"], Rm = {
  key: 0,
  class: "ds-promotion-teaser__logo"
}, Lm = {
  key: 1,
  src: "https://img.chefkoch-cdn.de/assets/v2/img/ci/CK-Plus-blackberry.svg",
  height: "32",
  alt: "PLUS Logo"
}, Pm = {
  key: 1,
  class: "ds-promotion-teaser__headline"
}, jm = {
  key: 2,
  class: "ds-promotion-teaser__claim"
};
function Fm(e, t, n, i, s, o) {
  const r = ie("DsPlusBadge");
  return u(), g("a", {
    class: "ds-teaser-link",
    href: e.href,
    title: e.linkTitle,
    onClick: t[0] || (t[0] = (a) => e.onClick(a))
  }, [
    b(
      "div",
      {
        class: M(["ds-promotion-teaser", [
          {
            "ds-promotion-teaser--banner": e.type === "banner",
            "ds-promotion-teaser--large": e.type === "banner" && e.large
          },
          e.modifierClass
        ]])
      },
      [
        b("div", Mm, [
          b("img", {
            class: "ds-teaser-link__image",
            src: e.imgSrc,
            srcset: e.srcSet
          }, null, 8, Bm)
        ]),
        b(
          "div",
          {
            class: M(["ds-promotion-teaser__content", {
              "ds-promotion-teaser__content--centered": e.centerContent
            }])
          },
          [
            e.$slots.logo || e.showPlusBadge || e.showPlusLogo ? (u(), g("div", Rm, [
              e.$slots.logo ? fe(e.$slots, "logo", { key: 0 }) : (u(), g(
                X,
                { key: 1 },
                [
                  e.showPlusBadge && !e.showPlusLogo ? (u(), le(r, { key: 0 })) : A("v-if", !0),
                  e.showPlusLogo ? (u(), g("img", Lm)) : A("v-if", !0)
                ],
                64
                /* STABLE_FRAGMENT */
              ))
            ])) : A("v-if", !0),
            e.headline ? (u(), g(
              "h4",
              Pm,
              j(e.headline),
              1
              /* TEXT */
            )) : A("v-if", !0),
            e.claim ? (u(), g(
              "p",
              jm,
              j(e.claim),
              1
              /* TEXT */
            )) : A("v-if", !0)
          ],
          2
          /* CLASS */
        )
      ],
      2
      /* CLASS */
    )
  ], 8, Om);
}
_a.render = Fm;
_a.__file = "src/components/DsPromotionTeaser/DsPromotionTeaser.vue";
var Ca = Z({
  name: "DsQuantityControl",
  components: {
    DsButton: ot
  },
  emits: ["onInput", "onStepDown", "onStepUp"],
  props: {
    ariaLabel: {
      type: String,
      default: "Anzahl"
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      required: !0
    },
    initialValue: {
      type: Number,
      default: 1
    },
    inputReadonly: {
      type: Boolean,
      default: !1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 999
    },
    step: {
      type: Number,
      default: 1
    }
  },
  setup(e, { emit: t }) {
    const n = J(e.initialValue), i = J(), s = D(() => `${e.hasError ? "ds-input--error" : ""}`), o = D(() => isNaN(n.value) ? !1 : n.value <= e.min), r = D(() => isNaN(n.value) ? !1 : n.value >= e.max);
    return {
      downBtnDisabled: o,
      inputClasses: s,
      inputRef: i,
      upBtnDisabled: r,
      value: n,
      onControlClick: (d) => {
        i.value && (d === "up" && (i.value.stepUp(), t("onStepUp", e.id)), d === "down" && (i.value.stepDown(), t("onStepDown", e.id)), i.value.dispatchEvent(new Event("input")));
      },
      onInput: (d) => {
        n.value = parseFloat(d.target.value), t("onInput", e.id, n.value);
      }
    };
  }
});
const Um = { class: "ds-quantity-control" }, zm = { class: "ds-quantity-control__down" }, Hm = { class: "ds-quantity-control__input-wrap" }, Vm = ["aria-label", "id", "min", "max", "name", "step", "value", "readonly"], qm = { class: "ds-quantity-control__up" };
function Wm(e, t, n, i, s, o) {
  const r = ie("DsButton");
  return u(), g("div", Um, [
    b("div", zm, [
      V(r, {
        mode: "control",
        icon: "",
        onOnClick: t[0] || (t[0] = (a) => e.onControlClick("down")),
        disabled: e.downBtnDisabled
      }, null, 8, ["disabled"])
    ]),
    b("div", Hm, [
      b("input", {
        "aria-label": e.ariaLabel,
        ref: "inputRef",
        class: M(["ds-quantity-control__input ds-input", e.inputClasses]),
        type: "number",
        id: e.id,
        min: e.min,
        max: e.max,
        name: e.id,
        step: e.step,
        value: e.value,
        onInput: t[1] || (t[1] = (...a) => e.onInput && e.onInput(...a)),
        readonly: e.inputReadonly
      }, null, 42, Vm)
    ]),
    b("div", qm, [
      V(r, {
        mode: "control",
        icon: "",
        onOnClick: t[2] || (t[2] = (a) => e.onControlClick("up")),
        disabled: e.upBtnDisabled
      }, null, 8, ["disabled"])
    ])
  ]);
}
Ca.render = Wm;
Ca.__file = "src/components/DsQuantityControl/DsQuantityControl.vue";
var ya = Z({
  name: "DsRangeSlider",
  emits: ["onInput"],
  props: {
    fluid: {
      type: Boolean,
      default: !1
    },
    noFill: {
      type: Boolean,
      default: !1
    },
    initialValue: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 5
    },
    step: {
      type: Number,
      default: 1
    },
    scaleItems: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const t = J("range-slider"), n = J(e.initialValue), i = D(() => {
      const l = (n.value - e.min) / (e.max - e.min) * 100;
      return `linear-gradient(to right, transparent 0%, transparent calc(0% + 10px), var(--range-slider-track-fill-color) calc(0% + 10px), var(--range-slider-track-fill-color) ${l}%, var(--range-slider-track-inactive-color) ${l}%, var(--range-slider-track-inactive-color) calc(100% - 10px), transparent calc(100% - 10px), transparent 100%)`;
    }), s = D(() => e.min > 1 ? `calc(${(e.max - e.min) / (e.max - 1) * 100}% + ${24 - 24 * (e.max - e.min) / (e.max - 1)}px)` : e.max < 5 ? `calc(${(e.max - 1) / (e.scaleItems.length - 1) * 100}% + ${24 - 24 * (e.max - 1) / (e.scaleItems.length - 1)}px)` : ""), o = D(() => e.min > 1 ? `calc(${(e.min - 1) / (e.scaleItems.length - 1) * 100}% - ${24 - 24 * (e.scaleItems.length - e.min) / (e.scaleItems.length - 1)}px)` : ""), r = D(() => `${e.fluid ? "ds-range-slider--fluid" : ""}${e.noFill ? " ds-range-slider--no-fill" : ""}`), a = D(() => e.max < e.scaleItems.length || e.min > 1);
    return {
      value: n,
      slider: t,
      trackBackground: i,
      inputWidth: s,
      leftPosition: o,
      classes: r,
      hasDisabledTrack: a
    };
  },
  methods: {
    onInput(e) {
      this.value = parseFloat(e.target.value), this.$emit("onInput", this.value);
    },
    isDisabledScaleItem(e) {
      return this.max < e + 1 || this.min > e + 1;
    }
  }
});
const Zm = { class: "ds-range-slider__input-wrap" }, Km = ["value", "step", "min", "max"], Jm = {
  key: 0,
  class: "ds-range-slider__track"
}, Ym = {
  key: 0,
  class: "ds-range-slider__scale"
}, Gm = { class: "ds-range-slider__scale-label" }, Qm = {
  key: 1,
  class: "ds-range-slider__scale-text"
};
function Xm(e, t, n, i, s, o) {
  return u(), g(
    "div",
    {
      class: M(["ds-range-slider", e.classes])
    },
    [
      b("div", Zm, [
        b("input", {
          style: Mt({ background: e.trackBackground, width: e.inputWidth, left: e.leftPosition }),
          class: "ds-range-slider__input",
          type: "range",
          value: e.value,
          step: e.step,
          min: e.min,
          max: e.max,
          onInput: t[0] || (t[0] = (...r) => e.onInput && e.onInput(...r))
        }, null, 44, Km),
        e.hasDisabledTrack ? (u(), g("div", Jm)) : A("v-if", !0)
      ]),
      e.scaleItems && e.scaleItems.length > 0 ? (u(), g("ul", Ym, [
        (u(!0), g(
          X,
          null,
          Bt(e.scaleItems, (r, a) => (u(), g(
            "li",
            {
              class: M(["ds-range-slider__scale-item", {
                "ds-range-slider__scale-item--active": !e.isDisabledScaleItem(a) && a < e.value,
                "ds-range-slider__scale-item--first": a === 0,
                "ds-range-slider__scale-item--last": a === e.scaleItems.length - 1,
                "ds-range-slider__scale-item--disabled": e.isDisabledScaleItem(a)
              }]),
              key: a
            },
            [
              b("span", Gm, [
                r.icon ? (u(), g(
                  "i",
                  {
                    key: 0,
                    class: M(["chefkoch-icons ds-range-slider__scale-icon", [r.iconColor && !e.isDisabledScaleItem(a) ? "ds-text-" + r.iconColor : ""]])
                  },
                  j(r.icon),
                  3
                  /* TEXT, CLASS */
                )) : A("v-if", !0),
                r.text ? (u(), g(
                  "span",
                  Qm,
                  j(r.text),
                  1
                  /* TEXT */
                )) : A("v-if", !0)
              ])
            ],
            2
            /* CLASS */
          ))),
          128
          /* KEYED_FRAGMENT */
        ))
      ])) : A("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
ya.render = Xm;
ya.__file = "src/components/DsRangeSlider/DsRangeSlider.vue";
var bi = Z({
  name: "DsRecipeMeta",
  props: {
    difficulty: {
      type: Number,
      enum: [0, 1, 2, 3],
      required: !1
    },
    ingredientCount: {
      type: Number,
      required: !1
    },
    preparationTime: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const t = D(() => jc(e.difficulty)), n = D(() => `${e.preparationTime} Min.`), i = D(() => `${e.ingredientCount} Zutat${e.ingredientCount !== 1 ? "en" : ""}`);
    return {
      diffcultyName: t,
      ingredientsTextFormatted: i,
      preparationTimeFormatted: n
    };
  }
});
const ef = { class: "ds-recipe-info" }, tf = /* @__PURE__ */ b(
  "i",
  {
    class: "chefkoch-icons ds-recipe-info__icon",
    "aria-hidden": "true"
  },
  "",
  -1
  /* HOISTED */
), nf = { class: "ds-recipe-info__text" }, sf = /* @__PURE__ */ b(
  "i",
  {
    class: "chefkoch-icons ds-recipe-info__icon ds-recipe-info__icon--ml",
    "aria-hidden": "true"
  },
  "",
  -1
  /* HOISTED */
), of = { class: "ds-recipe-info__text" }, rf = /* @__PURE__ */ b(
  "i",
  {
    class: "chefkoch-icons ds-recipe-info__icon ds-recipe-info__icon--ml",
    "aria-hidden": "true"
  },
  "",
  -1
  /* HOISTED */
), af = { class: "ds-recipe-info__text" };
function lf(e, t, n, i, s, o) {
  return u(), g("div", ef, [
    tf,
    b(
      "span",
      nf,
      j(e.preparationTimeFormatted),
      1
      /* TEXT */
    ),
    typeof e.ingredientCount < "u" && e.ingredientCount > -1 ? (u(), g(
      X,
      { key: 0 },
      [
        sf,
        b(
          "span",
          of,
          j(e.ingredientsTextFormatted),
          1
          /* TEXT */
        )
      ],
      64
      /* STABLE_FRAGMENT */
    )) : (u(), g(
      X,
      { key: 1 },
      [
        rf,
        b(
          "span",
          af,
          j(e.diffcultyName),
          1
          /* TEXT */
        )
      ],
      64
      /* STABLE_FRAGMENT */
    ))
  ]);
}
bi.render = lf;
bi.__file = "src/components/DsRecipeMeta/DsRecipeMeta.vue";
var xi = Z({
  name: "DsRecipeRating",
  props: {
    rating: {
      type: Number,
      required: !0
    },
    numVotes: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const t = D(() => `${e.numVotes === 0 ? "ds-text-pepper" : "ds-text-mirabelle-dark"}`), n = D(() => e.rating < 1.5 || e.numVotes === 0 ? "&#xe93e;" : e.rating < 4 ? "&#xe93d;" : "&#xe93c;"), i = D(() => `${e.numVotes > 0 ? "ds-recipe-info__text--ml" : ""}`), s = D(() => isNaN(e.rating) ? "" : (Math.round(e.rating * 10) / 10).toString().replace(".", ","));
    return {
      icon: n,
      iconClasses: t,
      formattedRating: s,
      countClasses: i
    };
  }
});
const df = { class: "ds-recipe-info" }, cf = ["innerHTML"], pf = {
  key: 0,
  class: "ds-recipe-info__text ds-text-semi-bold"
}, uf = /* @__PURE__ */ b(
  "span",
  { class: "ds-sr-only" },
  "Durchschnittliche Bewertung: ",
  -1
  /* HOISTED */
), mf = /* @__PURE__ */ b(
  "span",
  { "aria-hidden": "true" },
  "/",
  -1
  /* HOISTED */
), ff = /* @__PURE__ */ b(
  "span",
  { class: "ds-sr-only" },
  " von ",
  -1
  /* HOISTED */
), gf = /* @__PURE__ */ ke("5"), hf = /* @__PURE__ */ b(
  "span",
  { class: "ds-sr-only" },
  " Sternen",
  -1
  /* HOISTED */
), bf = /* @__PURE__ */ b(
  "span",
  { class: "ds-sr-only" },
  " Bewertungen",
  -1
  /* HOISTED */
), xf = /* @__PURE__ */ ke(")");
function _f(e, t, n, i, s, o) {
  return u(), g("div", df, [
    b("i", {
      "aria-hidden": "true",
      class: M(["chefkoch-icons ds-recipe-info__icon", e.iconClasses]),
      innerHTML: e.icon
    }, null, 10, cf),
    e.numVotes > 0 ? (u(), g("span", pf, [
      uf,
      ke(
        j(e.formattedRating),
        1
        /* TEXT */
      ),
      mf,
      ff,
      gf,
      hf
    ])) : A("v-if", !0),
    b(
      "span",
      {
        class: M(["ds-recipe-info__text", e.countClasses])
      },
      [
        ke(
          "(" + j(e.numVotes),
          1
          /* TEXT */
        ),
        bf,
        xf
      ],
      2
      /* CLASS */
    )
  ]);
}
xi.render = _f;
xi.__file = "src/components/DsRecipeRating/DsRecipeRating.vue";
var _i = Z({
  name: "DsTextToggle",
  props: {
    isSaved: {
      type: Boolean,
      required: !1,
      default: !1
    },
    animate: {
      type: Boolean,
      default: !0,
      required: !1
    },
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const n = J(!e.isSaved), i = D(() => e.animate && e.isSaved && n.value ? "ds-animate ds-animate--pulse" : ""), s = (o) => {
      o.preventDefault(), t("onClick", o);
    };
    return Ze(() => e.isSaved, (o, r) => {
      r === !1 && (n.value = !0);
    }), {
      animationClasses: i,
      onClick: s
    };
  }
});
const Cf = /* @__PURE__ */ ke(""), yf = /* @__PURE__ */ ke("");
function vf(e, t, n, i, s, o) {
  return u(), g(
    "button",
    {
      class: M(["ds-btn ds-btn--round ds-btn--save", { "ds-btn--disabled": e.disabled }]),
      onClick: t[0] || (t[0] = (r) => e.onClick(r))
    },
    [
      b(
        "i",
        {
          class: M(["chefkoch-icons ds-btn__icon", e.animationClasses])
        },
        [
          e.isSaved ? (u(), g(
            X,
            { key: 0 },
            [
              Cf
            ],
            2112
            /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
          )) : (u(), g(
            X,
            { key: 1 },
            [
              yf
            ],
            2112
            /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
          ))
        ],
        2
        /* CLASS */
      )
    ],
    2
    /* CLASS */
  );
}
_i.render = vf;
_i.__file = "src/components/DsSaveButton/DsSaveButton.vue";
var va = Z({
  name: "DsRecipeCard",
  components: {
    DsAuthor: Xt,
    DsPlusBadge: vt,
    DsRecipeMeta: bi,
    DsRecipeRating: xi,
    DsResponsiveImage: gi,
    DsSaveButton: _i,
    DsTextToggle: wn
  },
  props: {
    authorAvatarUrl: {
      type: String,
      required: !1
    },
    authorIsVerified: {
      type: Boolean,
      required: !1
    },
    authorName: {
      type: String,
      required: !1
    },
    brandImage: {
      type: String,
      required: !1
    },
    category: {
      type: String,
      required: !1
    },
    gridCols: {
      type: Number,
      default: 6
    },
    gridM: {
      type: Number,
      default: 3
    },
    gridS: {
      type: Number,
      default: 4
    },
    description: {
      type: String,
      required: !1
    },
    difficulty: {
      type: Number,
      enum: [0, 1, 2, 3],
      required: !1
    },
    hasImage: {
      type: Boolean,
      required: !0
    },
    hasMultiselect: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasSaveButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    imageTemplate: {
      type: String,
      required: !0
    },
    ingredientCount: {
      type: Number,
      required: !1
    },
    isPlus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPrivate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isSaved: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isSelected: {
      type: Boolean,
      required: !1,
      default: !1
    },
    linkTitle: {
      type: String,
      required: !1
    },
    note: {
      type: String,
      required: !1
    },
    numVotes: {
      type: Number,
      required: !1
    },
    preparationTime: {
      type: Number,
      required: !1
    },
    rating: {
      type: Number,
      required: !1
    },
    siteUrl: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    }
  },
  emits: ["onClick", "onSaveButtonClick", "onSelect"],
  setup(e, { emit: t }) {
    const { linkTag: n, linkTitleFormatted: i, showRating: s } = ma(e);
    return {
      linkClasses: D(() => `ds-recipe-card__link${e.siteUrl ? " ds-teaser-link" : ""}`),
      linkTag: n,
      linkTitleFormatted: i,
      onClick: (d) => {
        t("onClick", d);
      },
      onSaveButtonClick: (d) => {
        t("onSaveButtonClick", d);
      },
      onSelect: (d) => {
        t("onSelect", d);
      },
      showRating: s
    };
  }
});
const wf = { class: "ds-recipe-card" }, If = {
  key: 0,
  class: "ds-recipe-card__logo-wrap"
}, kf = ["src"], Af = {
  key: 1,
  class: "ds-recipe-card__category"
}, Sf = { class: "ds-text-category" }, Tf = {
  key: 2,
  class: "ds-recipe-card__rating"
}, $f = { class: "ds-h4 ds-recipe-card__headline ds-teaser-link__headline ds-trunc ds-trunc-3 ds-text-sans" }, Df = {
  key: 3,
  class: "ds-recipe-card__meta"
}, Nf = {
  key: 4,
  class: "ds-recipe-card__description ds-text-caption ds-trunc ds-trunc-2"
}, Ef = {
  key: 5,
  class: "ds-recipe-card__author"
}, Of = {
  key: 6,
  class: "ds-recipe-card__description ds-text-caption"
}, Mf = {
  key: 1,
  class: "ds-card-badge ds-card-badge--inverted"
}, Bf = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons ds-card-badge__icon" },
  "",
  -1
  /* HOISTED */
), Rf = [
  Bf
], Lf = {
  key: 0,
  class: "ds-recipe-card__action"
}, Pf = {
  key: 1,
  class: "ds-recipe-card__action"
}, jf = {
  key: 0,
  class: "chefkoch-icons ds-btn__icon"
}, Ff = {
  key: 1,
  class: "chefkoch-icons ds-btn__icon"
}, Uf = {
  key: 2,
  class: "ds-recipe-card__note"
};
function zf(e, t, n, i, s, o) {
  const r = ie("ds-responsive-image"), a = ie("ds-recipe-rating"), l = ie("ds-recipe-meta"), d = ie("ds-author"), c = ie("ds-plus-badge"), f = ie("ds-save-button"), h = ie("ds-text-toggle");
  return u(), g("div", wf, [
    (u(), le(di(e.linkTag), {
      class: M(e.linkClasses),
      href: e.siteUrl ? e.siteUrl : null,
      title: e.siteUrl ? e.linkTitleFormatted : null,
      onClick: t[0] || (t[0] = (y) => e.onClick(y))
    }, {
      default: Ae(() => [
        b(
          "div",
          {
            class: M(["ds-recipe-card__image-wrap ds-teaser-link__image-wrap", { "ds-teaser-link__image-wrap": e.hasImage }])
          },
          [
            e.hasImage && e.imageTemplate ? (u(), le(r, {
              key: 0,
              class: M("ds-teaser-link__image"),
              aspectRatio: "4x5",
              imageTemplate: e.imageTemplate,
              cols: e.gridCols,
              s: e.gridS,
              m: e.gridM
            }, null, 8, ["imageTemplate", "cols", "s", "m"])) : A("v-if", !0)
          ],
          2
          /* CLASS */
        ),
        e.brandImage ? (u(), g("div", If, [
          b("img", {
            height: "64",
            class: "ds-recipe-card__logo",
            src: e.brandImage
          }, null, 8, kf)
        ])) : A("v-if", !0),
        e.category ? (u(), g("div", Af, [
          b(
            "span",
            Sf,
            j(e.category),
            1
            /* TEXT */
          )
        ])) : A("v-if", !0),
        e.showRating ? (u(), g("div", Tf, [
          V(a, {
            rating: e.rating,
            numVotes: e.numVotes
          }, null, 8, ["rating", "numVotes"])
        ])) : A("v-if", !0),
        b(
          "h3",
          $f,
          j(e.title),
          1
          /* TEXT */
        ),
        e.difficulty && e.preparationTime !== "undefined" && e.preparationTime !== null ? (u(), g("div", Df, [
          V(l, {
            difficulty: e.difficulty,
            ingredientCount: e.ingredientCount,
            preparationTime: e.preparationTime
          }, null, 8, ["difficulty", "ingredientCount", "preparationTime"])
        ])) : A("v-if", !0),
        e.description ? (u(), g(
          "div",
          Nf,
          j(e.description),
          1
          /* TEXT */
        )) : A("v-if", !0),
        e.authorName ? (u(), g("div", Ef, [
          V(d, {
            name: e.authorName,
            isVerified: e.authorIsVerified,
            avatarUrl: e.authorAvatarUrl
          }, null, 8, ["name", "isVerified", "avatarUrl"])
        ])) : A("v-if", !0),
        e.$slots.descriptionBelow ? (u(), g("div", Of, [
          fe(e.$slots, "descriptionBelow")
        ])) : A("v-if", !0),
        e.isPrivate || e.isPlus ? (u(), g(
          "div",
          {
            key: 7,
            class: M(["ds-recipe-card__action ds-recipe-card__action--left", { "ds-recipe-card__action--plus": e.isPlus }])
          },
          [
            e.isPlus ? (u(), le(c, { key: 0 })) : (u(), g("div", Mf, Rf))
          ],
          2
          /* CLASS */
        )) : A("v-if", !0)
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["class", "href", "title"])),
    e.$slots.menu ? (u(), g("div", Lf, [
      fe(e.$slots, "menu")
    ])) : A("v-if", !0),
    !e.$slots.menu && (e.hasMultiselect || e.hasSaveButton) ? (u(), g("div", Pf, [
      e.hasSaveButton ? (u(), le(f, {
        key: 0,
        isSaved: e.isSaved,
        onOnClick: e.onSaveButtonClick
      }, null, 8, ["isSaved", "onOnClick"])) : (u(), g("button", {
        key: 1,
        class: "ds-recipe-card__button ds-btn ds-btn--round",
        onClick: t[1] || (t[1] = (...y) => e.onSelect && e.onSelect(...y))
      }, [
        e.isSelected ? (u(), g("i", jf, "")) : (u(), g("i", Ff, ""))
      ]))
    ])) : A("v-if", !0),
    e.note ? (u(), g("div", Uf, [
      V(h, { text: e.note }, null, 8, ["text"])
    ])) : A("v-if", !0)
  ]);
}
va.render = zf;
va.__file = "src/components/DsRecipeCard/DsRecipeCard.vue";
const Hf = "crop-288x216", Vf = "crop-144x108";
var Bs = Z({
  name: "DsRecipeListItem",
  components: {
    DsAuthor: Xt,
    DsPlusBadge: vt,
    DsRecipeMeta: bi,
    DsRecipeRating: xi,
    DsSaveButton: _i,
    DsTextToggle: wn
  },
  props: {
    authorIsVerified: {
      type: Boolean,
      required: !1
    },
    authorName: {
      type: String,
      required: !1
    },
    difficulty: {
      type: Number,
      enum: [0, 1, 2, 3],
      required: !0
    },
    hasImage: {
      type: Boolean,
      required: !0
    },
    hasSaveButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    imageTemplate: {
      type: String,
      required: !0
    },
    inOverlay: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPlus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isPrivate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isSaved: {
      type: Boolean,
      required: !1,
      default: !1
    },
    linkTitle: {
      type: String,
      required: !1
    },
    note: {
      type: String,
      required: !1
    },
    numVotes: {
      type: Number,
      required: !1
    },
    preparationTime: {
      type: Number,
      required: !0
    },
    rating: {
      type: Number,
      required: !1
    },
    siteUrl: {
      type: String,
      required: !1
    },
    solid: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    }
  },
  emits: ["onClick", "onSaveButtonClick", "onTextToggleClick"],
  setup(e, { emit: t }) {
    const n = D(() => `${e.solid ? "ds-list-view-item--solid" : ""}
      ${e.inOverlay ? " ds-list-view-item--dialog" : ""}
      ${e.siteUrl && !e.solid ? " ds-list-view-item--hover-bg-from-m" : ""}`), { linkTag: i, linkTitleFormatted: s, showRating: o } = ma(e), r = D(() => e.imageTemplate ? `${e.imageTemplate.replace("<format>", Vf)}` : ""), a = D(() => e.imageTemplate ? `${e.imageTemplate.replace("<format>", Hf)} 2x, ${r.value} 1x` : ""), l = (h) => {
      t("onClick", h);
    }, d = (h) => {
      t("onSaveButtonClick", h);
    }, c = (h) => {
      h.stopPropagation();
    }, f = D(() => `ds-list-view-item__link${e.siteUrl ? " ds-teaser-link" : ""}`);
    return {
      classes: n,
      imgSrcSet: a,
      imgSrc: r,
      linkClasses: f,
      linkTag: i,
      linkTitleFormatted: s,
      showRating: o,
      onClick: l,
      onSaveButtonClick: d,
      onTextToggleClick: c
    };
  }
});
const qf = { class: "ds-list-view-item__media" }, Wf = ["srcset", "src", "alt"], Zf = {
  key: 1,
  class: "ds-card-badge ds-card-badge--inverted ds-card-badge--mobile-small"
}, Kf = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons ds-card-badge__icon" },
  "",
  -1
  /* HOISTED */
), Jf = [
  Kf
], Yf = { class: "ds-list-view-item__body" }, Gf = {
  key: 0,
  class: "ds-list-view-item__rating"
}, Qf = { class: "ds-teaser-link__headline ds-list-view-item__headline ds-h4 ds-text-sans ds-trunc ds-trunc-2" }, Xf = {
  key: 1,
  class: "ds-list-view-item__author"
}, eg = {
  key: 0,
  class: "ds-list-view-item__action"
}, tg = {
  key: 1,
  class: "ds-list-view-item__action"
};
function ng(e, t, n, i, s, o) {
  const r = ie("ds-plus-badge"), a = ie("ds-recipe-rating"), l = ie("ds-recipe-meta"), d = ie("ds-author"), c = ie("ds-text-toggle"), f = ie("ds-save-button");
  return u(), g(
    "div",
    {
      class: M(["ds-list-view-item ds-list-view-item--recipe", e.classes])
    },
    [
      (u(), le(di(e.linkTag), {
        class: M(e.linkClasses),
        href: e.siteUrl ? e.siteUrl : null,
        title: e.siteUrl ? e.linkTitleFormatted : null,
        onClick: t[0] || (t[0] = (h) => e.onClick(h))
      }, {
        default: Ae(() => [
          b("div", qf, [
            b(
              "div",
              {
                class: M(["ds-list-view-item__image-wrap", { "ds-list-view-item__image-wrap--no-image": !e.hasImage || !e.imgSrc }])
              },
              [
                e.hasImage && e.imgSrc ? (u(), g("img", {
                  key: 0,
                  class: "ds-list-view-item__image",
                  width: "144",
                  height: "108",
                  loading: "lazy",
                  srcset: e.imgSrcSet,
                  src: e.imgSrc,
                  alt: e.title
                }, null, 8, Wf)) : A("v-if", !0),
                e.isPrivate || e.isPlus ? (u(), g(
                  "div",
                  {
                    key: 1,
                    class: M(["ds-list-view-item__badge", { "ds-list-view-item__badge--centered": e.isPrivate }])
                  },
                  [
                    e.isPlus ? (u(), le(r, {
                      key: 0,
                      "mobile-small": !0
                    })) : (u(), g("div", Zf, Jf))
                  ],
                  2
                  /* CLASS */
                )) : A("v-if", !0)
              ],
              2
              /* CLASS */
            )
          ]),
          b("div", Yf, [
            b(
              "div",
              {
                class: M(["ds-list-view-item__column ds-list-view-item__column--info", e.inOverlay ? "ds-list-view-item__column--full" : ""])
              },
              [
                e.showRating ? (u(), g("div", Gf, [
                  V(a, {
                    rating: e.rating,
                    numVotes: e.numVotes
                  }, null, 8, ["rating", "numVotes"])
                ])) : A("v-if", !0),
                b(
                  "h4",
                  Qf,
                  j(e.title),
                  1
                  /* TEXT */
                ),
                V(l, {
                  difficulty: e.difficulty,
                  preparationTime: e.preparationTime
                }, null, 8, ["difficulty", "preparationTime"]),
                e.authorName ? (u(), g("div", Xf, [
                  V(d, {
                    name: e.authorName,
                    isVerified: e.authorIsVerified
                  }, null, 8, ["name", "isVerified"])
                ])) : A("v-if", !0)
              ],
              2
              /* CLASS */
            ),
            e.$slots.note ? (u(), g(
              "div",
              {
                key: 0,
                class: M(["ds-list-view-item__column ds-list-view-item__column--note", e.inOverlay ? "ds-list-view-item__column--full" : ""])
              },
              [
                fe(e.$slots, "note")
              ],
              2
              /* CLASS */
            )) : (u(), g(
              X,
              { key: 1 },
              [
                e.note ? (u(), g(
                  "div",
                  {
                    key: 0,
                    class: M(["ds-list-view-item__column ds-list-view-item__column--note", e.inOverlay ? "ds-list-view-item__column--full" : ""])
                  },
                  [
                    V(c, {
                      text: e.note,
                      onOnClick: e.onTextToggleClick
                    }, null, 8, ["text", "onOnClick"])
                  ],
                  2
                  /* CLASS */
                )) : A("v-if", !0)
              ],
              2112
              /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
            ))
          ])
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["class", "href", "title"])),
      e.$slots.menu ? (u(), g("div", eg, [
        fe(e.$slots, "menu")
      ])) : A("v-if", !0),
      !e.$slots.menu && e.hasSaveButton ? (u(), g("div", tg, [
        V(f, {
          isSaved: e.isSaved,
          onOnClick: e.onSaveButtonClick
        }, null, 8, ["isSaved", "onOnClick"])
      ])) : A("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
Bs.render = ng;
Bs.__file = "src/components/DsRecipeListItem/DsRecipeListItem.vue";
var Rs = Z({
  name: "DsSearchBar",
  components: {
    DsInputChip: Ms
  },
  props: {
    autocompleteValue: {
      type: String
    },
    chips: {
      type: Array
    },
    hasFocus: {
      type: Boolean,
      default: !1
    },
    initialValue: {
      type: String
    },
    iconPrepend: {
      type: String
    },
    maxSuggestionItemsVisible: {
      type: Number,
      default: 6
    },
    placeholder: {
      type: String
    },
    showNoResults: {
      type: Boolean,
      default: !1
    },
    suggestions: {
      type: Array,
      required: !1
    },
    noResultsText: {
      type: String,
      required: !1
    }
  },
  emits: ["onArrowDown", "onArrowUp", "onBackdropClick", "onBlur", "onDelete", "onChipClick", "onEnter", "onEscape", "onFocus", "onInput", "onSuggestionClick"],
  setup(e, { emit: t, slots: n }) {
    const i = J(e.initialValue), s = J(""), o = J(-1), r = J(!1), a = J(!1), l = J(), d = J(!1), c = J(), f = D(() => {
      if (e.autocompleteValue && i.value && e.autocompleteValue.toLowerCase().startsWith(i.value.toLowerCase())) {
        const F = new RegExp(i.value, "i");
        return e.autocompleteValue.replace(F, "");
      }
      return "";
    }), h = D(() => !!(d.value && (n.suggestions || e.suggestions))), y = D(() => `${h.value ? "ds-search-bar--suggest-active" : ""}`), _ = D(() => `${e.iconPrepend ? "ds-search-bar__control--icon-prepend" : ""}`), k = D(() => `--search-bar-input-min-width: ${e.placeholder ? 9 * e.placeholder.length : 80}px`), K = D(() => e.maxSuggestionItemsVisible && !e.showNoResults ? `--search-bar-max-items-visible: ${e.maxSuggestionItemsVisible}` : ""), { attachEscapeKeyHandler: U, removeEscapeKeyHandler: ae } = ua(() => {
      d.value === !0 && (o.value = -1, d.value = !1, t("onEscape"));
    }), P = () => {
      c && c.value && c.value.focus();
    };
    at(() => {
      U(), e.hasFocus && vn(() => {
        P();
      });
    }), Qt(ae);
    const G = (F) => {
      o.value = -1, t("onBlur", F);
    }, se = (F) => {
      r.value = !1, t("onDelete", F);
    }, be = (F, me) => {
      t("onChipClick", F, me);
    }, ee = (F) => {
      o.value = -1, d.value === !0 && (d.value = !1), t("onBackdropClick", F);
    }, O = (F) => {
      e.suggestions && e.suggestions.length > 0 && (F.key === "ArrowDown" && (F.preventDefault(), r.value = !0, o.value === e.suggestions.length - 1 ? o.value = 0 : o.value < e.suggestions.length - 1 && o.value++, t("onArrowDown", o.value)), F.key === "ArrowUp" && (r.value = !0, F.preventDefault(), o.value >= 0 && o.value--, o.value === -1 && (o.value = e.suggestions.length - 1), t("onArrowUp", o.value))), n.suggestions && (F.key === "ArrowDown" && t("onArrowDown"), F.key === "ArrowUp" && t("onArrowUp"));
    }, B = (F) => {
      r.value = !1, a.value === !0 && (d.value = !0), i.value = F.target.value, t("onInput", i.value);
    }, N = (F) => {
      a.value = !0, t("onFocus", F);
    }, Q = () => {
      a.value === !0 && (d.value = !0);
    }, R = (F) => {
      F.preventDefault(), t("onEnter", F);
    }, ce = (F, me) => {
      (!(F.target instanceof HTMLAnchorElement) || !F.target.href || F.target.href === "#") && F.preventDefault(), t("onSuggestionClick", me);
    };
    return Ze(() => [e.suggestions], async () => {
      (!e.suggestions || e.suggestions.length === 1) && (o.value = -1);
    }), Ze(o, (F, me) => {
      if (r.value && (me === -1 && F > -1 && (s.value = i.value || ""), me > -1 && F === -1 && (i.value = s.value, t("onInput", i.value)), F > -1 && e.suggestions)) {
        const ve = e.suggestions[F];
        i.value = ve.label, t("onInput", i.value);
      }
    }), {
      autocompleteValueVisible: f,
      controlClasses: _,
      focus: P,
      inputMinWidth: k,
      inputRef: c,
      isAutosuggestVisible: d,
      onBackdropClick: ee,
      onBlur: G,
      onChipClick: be,
      onDelete: se,
      onEnter: R,
      onFocus: N,
      onInput: B,
      onInputClick: Q,
      onKeyDown: O,
      onSuggestionClick: ce,
      searchBarClasses: y,
      selectedSuggestion: o,
      showAutosuggest: h,
      suggestRef: l,
      suggestStyles: K,
      value: i
    };
  }
});
const ig = {
  key: 0,
  class: "ds-search-bar__control-item ds-search-bar__control-item--icon"
}, sg = { class: "chefkoch-icons" }, og = {
  key: 0,
  class: "ds-search-bar__input ds-search-bar__input--autocomplete"
}, rg = ["placeholder", "value"], ag = { class: "ds-search-bar__suggest-inner" }, lg = {
  key: 0,
  class: "ds-search-bar__suggest-empty"
}, dg = ["innerHTML", "onClick"];
function cg(e, t, n, i, s, o) {
  const r = ie("DsInputChip");
  return u(), g(
    "div",
    {
      class: M(["ds-search-bar", e.searchBarClasses])
    },
    [
      b(
        "div",
        {
          class: M(["ds-search-bar__control", e.controlClasses])
        },
        [
          e.iconPrepend ? (u(), g("span", ig, [
            b(
              "i",
              sg,
              j(e.iconPrepend),
              1
              /* TEXT */
            )
          ])) : A("v-if", !0),
          fe(e.$slots, "chips"),
          e.$slots.chips ? A("v-if", !0) : (u(!0), g(
            X,
            { key: 1 },
            Bt(e.chips, (a, l) => (u(), g("span", {
              key: l,
              class: "ds-search-bar__control-item"
            }, [
              V(r, {
                label: a.label,
                onOnClick: (d) => e.onChipClick(a.id),
                id: a.id
              }, null, 8, ["label", "onOnClick", "id"])
            ]))),
            128
            /* KEYED_FRAGMENT */
          )),
          b(
            "span",
            {
              class: "ds-search-bar__control-item ds-search-bar__control-item--input",
              style: Mt(e.placeholder ? e.inputMinWidth : !1)
            },
            [
              e.autocompleteValue && e.value ? (u(), g("div", og, [
                b(
                  "span",
                  null,
                  j(e.value),
                  1
                  /* TEXT */
                ),
                ke(
                  j(e.autocompleteValueVisible),
                  1
                  /* TEXT */
                )
              ])) : A("v-if", !0),
              b("input", {
                class: "ds-search-bar__input",
                type: "text",
                name: "search-bar",
                id: "search-bar",
                placeholder: e.placeholder,
                value: e.value,
                autocomplete: "off",
                onInput: t[0] || (t[0] = (...a) => e.onInput && e.onInput(...a)),
                onFocus: t[1] || (t[1] = (a) => e.onFocus(a)),
                onKeydown: [
                  t[2] || (t[2] = Oo((...a) => e.onEnter && e.onEnter(...a), ["enter"])),
                  t[4] || (t[4] = Oo((...a) => e.onDelete && e.onDelete(...a), ["delete"])),
                  t[6] || (t[6] = (...a) => e.onKeyDown && e.onKeyDown(...a))
                ],
                onBlur: t[3] || (t[3] = (...a) => e.onBlur && e.onBlur(...a)),
                onClick: t[5] || (t[5] = (...a) => e.onInputClick && e.onInputClick(...a)),
                ref: "inputRef"
              }, null, 40, rg)
            ],
            4
            /* STYLE */
          )
        ],
        2
        /* CLASS */
      ),
      b(
        "div",
        {
          class: "ds-search-bar__suggest",
          ref: "suggestRef",
          style: Mt(e.suggestStyles)
        },
        [
          b("div", ag, [
            e.showNoResults && e.noResultsText ? (u(), g(
              "div",
              lg,
              j(e.noResultsText),
              1
              /* TEXT */
            )) : (u(), g(
              X,
              { key: 1 },
              [
                fe(e.$slots, "suggestions"),
                e.$slots.suggestions ? A("v-if", !0) : (u(!0), g(
                  X,
                  { key: 0 },
                  Bt(e.suggestions, (a, l) => (u(), g("div", {
                    key: l,
                    tabindex: "-1",
                    class: M(["ds-search-bar__suggest-item", { "ds-search-bar__suggest-item--active": e.selectedSuggestion === l }]),
                    innerHTML: a.labelHighlighted,
                    onClick: (d) => e.onSuggestionClick(d, a.id)
                  }, null, 10, dg))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              64
              /* STABLE_FRAGMENT */
            ))
          ])
        ],
        4
        /* STYLE */
      ),
      b("div", {
        class: "ds-search-bar__backdrop",
        onClick: t[7] || (t[7] = (a) => e.onBackdropClick(a))
      })
    ],
    2
    /* CLASS */
  );
}
Rs.render = cg;
Rs.__file = "src/components/DsSearchBar/DsSearchBar.vue";
var wa = Z({
  name: "DsSlimFooter"
});
const pg = { class: "ds-slim-footer" }, ug = /* @__PURE__ */ ui('<div class="ds-container"><div class="ds-col-12"><nav aria-label="Footer Links" class="ds-slim-footer__nav"><ul class="ds-slim-footer__nav-links"><li class="ds-slim-footer__nav-item"><a href="https://www.chefkoch.de/magazin/datenschutz.html" class="ds-slim-footer__nav-link"> Datenschutz </a></li><li class="ds-slim-footer__nav-item"><a href="https://www.chefkoch.de/impressum.php" class="ds-slim-footer__nav-link"> Impressum </a></li><li class="ds-slim-footer__nav-item"><a href="https://kundenservice.chefkoch.de/hc/de/requests/new?ticket_form_id=4536290816924" class="ds-slim-footer__nav-link"> Verträge kündigen </a></li></ul></nav></div></div>', 1), mg = [
  ug
];
function fg(e, t, n, i, s, o) {
  return u(), g("footer", pg, mg);
}
wa.render = fg;
wa.__file = "src/components/DsSlimFooter/DsSlimFooter.vue";
var Ls = Z({
  name: "DsSnackbar",
  components: {
    DsInlineNotification: Os
  },
  props: {
    autoClose: {
      type: Boolean,
      default: !0
    },
    buttonLabel: String,
    closable: {
      type: Boolean,
      default: !0
    },
    copy: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      enum: [
        "info",
        "success",
        "warning",
        "danger"
      ],
      default: "info"
    }
  },
  emits: ["onButtonClick", "onClose"],
  setup(e, { emit: t }) {
    const n = () => {
      t("onButtonClick");
    }, i = () => {
      t("onClose");
    }, s = () => {
      i();
    };
    return at(() => {
      (e.autoClose || !e.closable) && setTimeout(i, 8e3);
    }), {
      onButtonClick: n,
      onClose: s
    };
  }
});
function gg(e, t, n, i, s, o) {
  const r = ie("DsInlineNotification");
  return u(), le(r, Is({ class: "ds-notification--snackbar" }, e.$props, {
    onOnClose: e.onClose,
    onOnButtonClick: e.onButtonClick,
    ref: "snackbarRef"
  }), null, 16, ["onOnClose", "onOnButtonClick"]);
}
Ls.render = gg;
Ls.__file = "src/components/DsSnackbar/DsSnackbar.vue";
var Ia = Z({
  name: "DsSnackbarContainer",
  components: {
    DsSnackbar: Ls
  },
  setup() {
    const { removeSnackbar: e, snackbars: t } = wp(), n = D(() => {
      const o = [];
      return t.value.length > 0 && o.push(t.value[t.value.length - 1]), o;
    });
    return {
      onAfterLeave: (o) => {
        e(o.id);
      },
      onBeforeLeave: (o) => {
        t.value.length > 1 && o.classList.add("fast");
      },
      removeSnackbar: e,
      snackbars: t,
      visibleSnackbars: n
    };
  }
});
function hg(e, t, n, i, s, o) {
  const r = ie("DsSnackbar");
  return u(), le($c, {
    name: "ds-snackbar-slide",
    class: "ds-snackbar-container",
    tag: "div",
    onBeforeLeave: e.onBeforeLeave,
    onAfterLeave: e.onAfterLeave
  }, {
    default: Ae(() => [
      (u(!0), g(
        X,
        null,
        Bt(e.visibleSnackbars, (a) => (u(), le(r, Is({
          autoClose: a.autoClose,
          buttonLabel: a.buttonLabel,
          closable: a.closable,
          copy: a.copy,
          id: a.id,
          key: a.id,
          mode: a.mode
        }, Ad(a.onButtonClick ? { onButtonClick: a.onButtonClick } : {}), {
          onOnClose: () => {
            e.removeSnackbar(a.id);
          }
        }), null, 16, ["autoClose", "buttonLabel", "closable", "copy", "id", "mode", "onOnClose"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    _: 1
    /* STABLE */
  }, 8, ["onBeforeLeave", "onAfterLeave"]);
}
var bg = `
.ds-snackbar-slide-enter,
.ds-snackbar-slide-enter-active {
    -webkit-animation: ds-snackbar-slide-in 0.25s;
            animation: ds-snackbar-slide-in 0.25s;
}
.ds-snackbar-slide-leave-active {
    animation: ds-snackbar-slide-in 0.25s reverse;
}
.ds-snackbar-slide-leave-active.fast {
  -webkit-animation-duration: 0.05s;
          animation-duration: 0.05s;
}
@-webkit-keyframes ds-snackbar-slide-in {
from {
        -webkit-transform: scale(0.4);
                transform: scale(0.4);
        visibility: visible;
        opacity: 0;
}
to {
        -webkit-transform: scale(1);
                transform: scale(1);
        opacity: 1;
}
}
@keyframes ds-snackbar-slide-in {
from {
        -webkit-transform: scale(0.4);
                transform: scale(0.4);
        visibility: visible;
        opacity: 0;
}
to {
        -webkit-transform: scale(1);
                transform: scale(1);
        opacity: 1;
}
}
@-webkit-keyframes ds-snackbar-slide-out {
from {
        -webkit-transform: scale(0.4);
                transform: scale(0.4);
        visibility: visible;
        opacity: 0;
}
to {
        -webkit-transform: scale(1);
                transform: scale(1);
        opacity: 1;
}
}
@keyframes ds-snackbar-slide-out {
from {
        -webkit-transform: scale(0.4);
                transform: scale(0.4);
        visibility: visible;
        opacity: 0;
}
to {
        -webkit-transform: scale(1);
                transform: scale(1);
        opacity: 1;
}
}

`;
ba(bg);
Ia.render = hg;
Ia.__file = "src/components/DsSnackbarContainer/DsSnackbarContainer.vue";
const Mi = "https://img.chefkoch-cdn.de/assets/v2/img/ci/", Fo = {
  plus: {
    src: `${Mi}CK-Plus-basmati.svg`,
    alt: "Chefkoch PLUS"
  },
  pur: {
    src: `${Mi}CK-Pur-olive.svg`,
    alt: "Chefkoch PUR"
  },
  ck: {
    src: `${Mi}CK-Logo.svg`,
    alt: "Chefkoch"
  }
};
var ka = Z({
  name: "DsSubscriptionCard",
  props: {
    type: {
      type: String,
      enum: ["plus", "pur", "ck"],
      required: !0,
      default: "plus"
    },
    bodyImageUrl: {
      type: String,
      required: !1
    },
    bodyImagePosition: {
      type: String,
      enum: ["top", "bottom"],
      default: "top"
    }
  },
  setup(e, { slots: t }) {
    const n = D(() => `ds-subscription-card--${e.type}${t.footer ? "" : " ds-subscription-card--no-footer"}`), i = D(() => Fo[e.type].alt), s = D(() => Fo[e.type].src);
    return {
      classes: n,
      imgAlt: i,
      imgSrc: s
    };
  }
});
const xg = { class: "ds-subscription-card__head" }, _g = ["alt", "src"], Cg = ["src"], yg = { class: "ds-subscription-card__body" }, vg = ["src"], wg = {
  key: 2,
  class: "ds-subscription-card__footer"
};
function Ig(e, t, n, i, s, o) {
  return u(), g(
    "div",
    {
      class: M(["ds-subscription-card", e.classes])
    },
    [
      b("div", xg, [
        b("img", {
          height: "32",
          loading: "lazy",
          alt: e.imgAlt,
          src: e.imgSrc
        }, null, 8, _g)
      ]),
      e.bodyImageUrl && e.bodyImagePosition === "top" ? (u(), g("img", {
        key: 0,
        class: "ds-subscription-card__image",
        src: e.bodyImageUrl
      }, null, 8, Cg)) : A("v-if", !0),
      b("div", yg, [
        fe(e.$slots, "default")
      ]),
      e.bodyImageUrl && e.bodyImagePosition === "bottom" ? (u(), g("img", {
        key: 1,
        class: "ds-subscription-card__image",
        src: e.bodyImageUrl
      }, null, 8, vg)) : A("v-if", !0),
      e.$slots.footer ? (u(), g("div", wg, [
        fe(e.$slots, "footer")
      ])) : A("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
ka.render = Ig;
ka.__file = "src/components/DsSubscriptionCard/DsSubscriptionCard.vue";
const Ps = (e) => ({
  computedId: D(() => e.id ? e.id : aa())
});
var Ci = Z({
  name: "DsFormItem",
  props: {
    errorMsg: {
      type: String
    },
    hint: {
      type: String
    },
    id: {
      type: String
    },
    label: {
      type: String
    },
    labelIcon: {
      type: String
    },
    maxLength: {
      type: Number
    },
    value: {
      type: [String, Number]
    }
  },
  setup(e) {
    const { computedId: t } = Ps(e), n = D(() => e.errorMsg || e.maxLength), i = D(() => e.value ? e.value.toString().length : 0);
    return {
      computedId: t,
      showFooter: n,
      valueLength: i
    };
  }
});
const kg = { class: "ds-form-item" }, Ag = ["for"], Sg = {
  key: 0,
  class: "ds-form-item__label-icon chefkoch-icons"
}, Tg = {
  key: 1,
  class: "ds-form-item__text"
}, $g = {
  key: 2,
  class: "ds-form-item__footer"
}, Dg = {
  key: 0,
  class: "ds-form-item__text ds-form-item__text--error"
}, Ng = {
  key: 1,
  class: "ds-form-item__text ds-form-item__text--bottom-right"
};
function Eg(e, t, n, i, s, o) {
  return u(), g("div", kg, [
    e.label ? (u(), g("label", {
      key: 0,
      class: "ds-form-item__label",
      for: e.computedId
    }, [
      e.labelIcon ? (u(), g(
        "i",
        Sg,
        j(e.labelIcon),
        1
        /* TEXT */
      )) : A("v-if", !0),
      ke(
        j(e.label),
        1
        /* TEXT */
      )
    ], 8, Ag)) : A("v-if", !0),
    e.hint ? (u(), g(
      "div",
      Tg,
      j(e.hint),
      1
      /* TEXT */
    )) : A("v-if", !0),
    b(
      "div",
      {
        class: M(["ds-form-item__control", { "ds-form-item__control--mb-0": !e.label && !e.hint }])
      },
      [
        fe(e.$slots, "default")
      ],
      2
      /* CLASS */
    ),
    e.showFooter ? (u(), g("div", $g, [
      e.errorMsg ? (u(), g(
        "div",
        Dg,
        j(e.errorMsg),
        1
        /* TEXT */
      )) : A("v-if", !0),
      e.maxLength ? (u(), g(
        "div",
        Ng,
        j(e.valueLength) + "/" + j(e.maxLength),
        1
        /* TEXT */
      )) : A("v-if", !0)
    ])) : A("v-if", !0)
  ]);
}
Ci.render = Eg;
Ci.__file = "src/components/DsFormItem/DsFormItem.vue";
var js = Z({
  name: "DsTextArea",
  components: { DsFormInput: Ci },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    errorMsg: {
      type: String
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String
    },
    id: {
      type: String
    },
    initialValue: {
      type: String
    },
    label: {
      type: String
    },
    labelIcon: {
      type: String
    },
    maxLength: {
      type: Number
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 4
    }
  },
  emits: ["onBlur", "onFocus", "onInput"],
  setup(e, { emit: t }) {
    const n = J(e.initialValue), i = J(), { computedId: s } = Ps(e);
    return {
      computedId: s,
      inputRef: i,
      onBlur: (l) => {
        t("onBlur", l);
      },
      onFocus: (l) => {
        t("onFocus", l);
      },
      onInput: (l) => {
        n.value = l.target.value, t("onInput", s.value, n.value);
      },
      computedValue: n
    };
  }
});
const Og = ["disabled", "id", "maxlength", "name", "placeholder", "rows", "readonly", "value"];
function Mg(e, t, n, i, s, o) {
  const r = ie("DsFormInput");
  return u(), le(r, {
    errorMsg: e.hasError && e.errorMsg ? e.errorMsg : null,
    hint: e.hint,
    id: e.computedId,
    label: e.label,
    labelIcon: e.labelIcon,
    maxLength: e.maxLength,
    value: e.computedValue
  }, {
    default: Ae(() => [
      b("textarea", {
        class: M(["ds-input ds-input--textarea", { "ds-input--error": e.hasError }]),
        disabled: e.disabled,
        id: e.computedId,
        maxlength: e.maxLength,
        name: e.name || e.computedId,
        placeholder: e.placeholder,
        rows: e.rows,
        readonly: e.readOnly,
        value: e.computedValue,
        ref: "inputRef",
        onBlur: t[0] || (t[0] = (...a) => e.onBlur && e.onBlur(...a)),
        onFocus: t[1] || (t[1] = (...a) => e.onFocus && e.onFocus(...a)),
        onInput: t[2] || (t[2] = (...a) => e.onInput && e.onInput(...a))
      }, null, 42, Og)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["errorMsg", "hint", "id", "label", "labelIcon", "maxLength", "value"]);
}
js.render = Mg;
js.__file = "src/components/DsTextArea/DsTextArea.vue";
var Fs = Z({
  name: "DsTextInput",
  components: { DsFormInput: Ci },
  props: {
    isClearable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    errorMsg: {
      type: String
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String
    },
    id: {
      type: String
    },
    initialValue: {
      type: [String, Number]
    },
    label: {
      type: String
    },
    labelIcon: {
      type: String
    },
    maxLength: {
      type: Number
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "text"
    },
    unit: {
      type: String
    }
  },
  emits: ["onBlur", "onClearClick", "onFocus", "onInput"],
  setup(e, { emit: t }) {
    const n = J(e.initialValue), i = J(), { computedId: s } = Ps(e), o = D(() => e.isClearable ? "ds-input-clearable" : e.unit ? "ds-input-group" : ""), r = () => {
      i && i.value && i.value.focus();
    };
    return {
      computedId: s,
      inputContainerClasses: o,
      inputRef: i,
      onBlur: (f) => {
        t("onBlur", f);
      },
      onClearClick: () => {
        n.value = "", t("onClearClick", s.value), r();
      },
      onFocus: (f) => {
        t("onFocus", f);
      },
      onInput: (f) => {
        n.value = f.target.value, t("onInput", s.value, n.value);
      },
      computedValue: n
    };
  }
});
const Bg = ["name", "id", "type", "disabled", "placeholder", "maxlength", "value", "readonly"], Rg = /* @__PURE__ */ b(
  "i",
  { class: "chefkoch-icons" },
  "",
  -1
  /* HOISTED */
), Lg = [
  Rg
];
function Pg(e, t, n, i, s, o) {
  const r = ie("DsFormInput");
  return u(), le(r, {
    errorMsg: e.hasError && e.errorMsg ? e.errorMsg : null,
    hint: e.hint,
    id: e.computedId,
    label: e.label,
    labelIcon: e.labelIcon,
    maxLength: e.maxLength,
    value: e.computedValue
  }, {
    default: Ae(() => [
      b(
        "div",
        {
          class: M(e.inputContainerClasses)
        },
        [
          b("input", {
            name: e.name,
            id: e.computedId,
            type: e.type,
            class: M(["ds-input", { "ds-input--error": e.hasError, "ds-input-clearable__control": e.isClearable, "ds-input--appended ds-input-group__control": e.unit && !e.isClearable }]),
            disabled: e.disabled,
            placeholder: e.placeholder,
            maxlength: e.maxLength,
            value: e.computedValue,
            readonly: e.readOnly,
            ref: "inputRef",
            onBlur: t[0] || (t[0] = (...a) => e.onBlur && e.onBlur(...a)),
            onFocus: t[1] || (t[1] = (...a) => e.onFocus && e.onFocus(...a)),
            onInput: t[2] || (t[2] = (...a) => e.onInput && e.onInput(...a))
          }, null, 42, Bg),
          e.isClearable && e.computedValue && !e.readOnly && !e.disabled ? (u(), g("button", {
            key: 0,
            class: "ds-input-clearable__btn",
            onClick: t[3] || (t[3] = (...a) => e.onClearClick && e.onClearClick(...a))
          }, Lg)) : A("v-if", !0),
          e.unit && !e.isClearable ? (u(), g(
            "span",
            {
              key: 1,
              class: M(["ds-input-group__append", { "ds-input--error": e.hasError }])
            },
            j(e.unit),
            3
            /* TEXT, CLASS */
          )) : A("v-if", !0)
        ],
        2
        /* CLASS */
      )
    ]),
    _: 1
    /* STABLE */
  }, 8, ["errorMsg", "hint", "id", "label", "labelIcon", "maxLength", "value"]);
}
Fs.render = Pg;
Fs.__file = "src/components/DsTextInput/DsTextInput.vue";
var Aa = Z({
  name: "DsToggleButton",
  props: {
    ariaLabel: String,
    name: {
      type: String,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    }
  },
  emits: ["onChange"],
  setup(e, { emit: t }) {
    return {
      onChange: (i) => {
        t("onChange", i.target.value);
      }
    };
  }
});
const jg = ["aria-labelledby"], Fg = ["id"], Ug = ["name", "id", "value", "checked"], zg = ["for"], Hg = {
  key: 0,
  class: "ds-toggle-btn__icon chefkoch-icons"
}, Vg = {
  key: 1,
  class: "ds-toggle-btn__label-text"
};
function qg(e, t, n, i, s, o) {
  return u(), g("div", {
    class: "ds-toggle-btn",
    role: "group",
    "aria-labelledby": e.ariaLabel ? `${e.name}-title` : null
  }, [
    e.ariaLabel ? (u(), g("span", {
      key: 0,
      id: `${e.name}-title`,
      class: "ds-sr-only"
    }, j(e.ariaLabel), 9, Fg)) : A("v-if", !0),
    (u(!0), g(
      X,
      null,
      Bt(e.options, (r, a) => (u(), g("div", {
        class: "ds-toggle-btn__option",
        key: a
      }, [
        b("input", {
          class: "ds-toggle-btn__input",
          type: "radio",
          name: e.name,
          id: `${e.name}-${a}`,
          value: r.value,
          checked: r.active,
          onChange: t[0] || (t[0] = (...l) => e.onChange && e.onChange(...l))
        }, null, 40, Ug),
        b("label", {
          class: "ds-toggle-btn__label",
          for: `${e.name}-${a}`
        }, [
          r.icon ? (u(), g(
            "i",
            Hg,
            j(r.icon),
            1
            /* TEXT */
          )) : A("v-if", !0),
          r.label ? (u(), g(
            "span",
            Vg,
            j(r.label),
            1
            /* TEXT */
          )) : A("v-if", !0)
        ], 8, zg)
      ]))),
      128
      /* KEYED_FRAGMENT */
    ))
  ], 8, jg);
}
Aa.render = qg;
Aa.__file = "src/components/DsToggleButton/DsToggleButton.vue";
var Wg = !1;
/*!
  * pinia v2.0.30
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
let Sa;
const In = (e) => Sa = e, Ta = (
  /* istanbul ignore next */
  Symbol()
);
function Gi(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var un;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(un || (un = {}));
function Zg() {
  const e = ar(!0), t = e.run(() => J({}));
  let n = [], i = [];
  const s = Zt({
    install(o) {
      In(s), s._a = o, o.provide(Ta, s), o.config.globalProperties.$pinia = s, i.forEach((r) => n.push(r)), i = [];
    },
    use(o) {
      return !this._a && !Wg ? i.push(o) : n.push(o), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return s;
}
const $a = () => {
};
function Uo(e, t, n, i = $a) {
  e.push(t);
  const s = () => {
    const o = e.indexOf(t);
    o > -1 && (e.splice(o, 1), i());
  };
  return !n && lr() && dr(s), s;
}
function Pt(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
function Qi(e, t) {
  e instanceof Map && t instanceof Map && t.forEach((n, i) => e.set(i, n)), e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n))
      continue;
    const i = t[n], s = e[n];
    Gi(s) && Gi(i) && e.hasOwnProperty(n) && !ye(i) && !bt(i) ? e[n] = Qi(s, i) : e[n] = i;
  }
  return e;
}
const Kg = (
  /* istanbul ignore next */
  Symbol()
);
function Jg(e) {
  return !Gi(e) || !e.hasOwnProperty(Kg);
}
const { assign: ft } = Object;
function Yg(e) {
  return !!(ye(e) && e.effect);
}
function Gg(e, t, n, i) {
  const { state: s, actions: o, getters: r } = t, a = n.state.value[e];
  let l;
  function d() {
    a || (n.state.value[e] = s ? s() : {});
    const c = Yl(n.state.value[e]);
    return ft(c, o, Object.keys(r || {}).reduce((f, h) => (f[h] = Zt(D(() => {
      In(n);
      const y = n._s.get(e);
      return r[h].call(y, y);
    })), f), {}));
  }
  return l = Da(e, d, t, n, i, !0), l.$reset = function() {
    const f = s ? s() : {};
    this.$patch((h) => {
      ft(h, f);
    });
  }, l;
}
function Da(e, t, n = {}, i, s, o) {
  let r;
  const a = ft({ actions: {} }, n), l = {
    deep: !0
    // flush: 'post',
  };
  let d, c, f = Zt([]), h = Zt([]), y;
  const _ = i.state.value[e];
  !o && !_ && (i.state.value[e] = {}), J({});
  let k;
  function K(ee) {
    let O;
    d = c = !1, typeof ee == "function" ? (ee(i.state.value[e]), O = {
      type: un.patchFunction,
      storeId: e,
      events: y
    }) : (Qi(i.state.value[e], ee), O = {
      type: un.patchObject,
      payload: ee,
      storeId: e,
      events: y
    });
    const B = k = Symbol();
    vn().then(() => {
      k === B && (d = !0);
    }), c = !0, Pt(f, O, i.state.value[e]);
  }
  const U = $a;
  function ae() {
    r.stop(), f = [], h = [], i._s.delete(e);
  }
  function P(ee, O) {
    return function() {
      In(i);
      const B = Array.from(arguments), N = [], Q = [];
      function R(me) {
        N.push(me);
      }
      function ce(me) {
        Q.push(me);
      }
      Pt(h, {
        args: B,
        name: ee,
        store: se,
        after: R,
        onError: ce
      });
      let F;
      try {
        F = O.apply(this && this.$id === e ? this : se, B);
      } catch (me) {
        throw Pt(Q, me), me;
      }
      return F instanceof Promise ? F.then((me) => (Pt(N, me), me)).catch((me) => (Pt(Q, me), Promise.reject(me))) : (Pt(N, F), F);
    };
  }
  const G = {
    _p: i,
    // _s: scope,
    $id: e,
    $onAction: Uo.bind(null, h),
    $patch: K,
    $reset: U,
    $subscribe(ee, O = {}) {
      const B = Uo(f, ee, O.detached, () => N()), N = r.run(() => Ze(() => i.state.value[e], (Q) => {
        (O.flush === "sync" ? c : d) && ee({
          storeId: e,
          type: un.direct,
          events: y
        }, Q);
      }, ft({}, l, O)));
      return B;
    },
    $dispose: ae
  }, se = si(G);
  i._s.set(e, se);
  const be = i._e.run(() => (r = ar(), r.run(() => t())));
  for (const ee in be) {
    const O = be[ee];
    if (ye(O) && !Yg(O) || bt(O))
      o || (_ && Jg(O) && (ye(O) ? O.value = _[ee] : Qi(O, _[ee])), i.state.value[e][ee] = O);
    else if (typeof O == "function") {
      const B = P(ee, O);
      be[ee] = B, a.actions[ee] = O;
    }
  }
  return ft(se, be), ft(ne(se), be), Object.defineProperty(se, "$state", {
    get: () => i.state.value[e],
    set: (ee) => {
      K((O) => {
        ft(O, ee);
      });
    }
  }), i._p.forEach((ee) => {
    ft(se, r.run(() => ee({
      store: se,
      app: i._a,
      pinia: i,
      options: a
    })));
  }), _ && o && n.hydrate && n.hydrate(se.$state, _), d = !0, c = !0, se;
}
function Us(e, t, n) {
  let i, s;
  const o = typeof t == "function";
  typeof e == "string" ? (i = e, s = o ? n : t) : (s = e, i = e.id);
  function r(a, l) {
    const d = ks();
    return a = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    a || d && an(Ta, null), a && In(a), a = Sa, a._s.has(i) || (o ? Da(i, t, s, a) : Gg(i, s, a)), a._s.get(i);
  }
  return r.$id = i, r;
}
class Na {
  constructor(t) {
    Pe(this, "http");
    Pe(this, "config");
    this.http = t.client, this.config = t.config;
  }
  post(t, n) {
    return this.http.post(this.config.baseURL + this.config.apiPath + t, n, { headers: this.config.headers });
  }
  patch(t, n) {
    return this.http.patch(this.config.baseURL + this.config.apiPath + t, n, { headers: this.config.headers });
  }
  delete(t) {
    return this.http.delete(this.config.baseURL + this.config.apiPath + t, { headers: this.config.headers });
  }
  get(t) {
    return this.http.get(this.config.baseURL + this.config.apiPath + t, { headers: this.config.headers });
  }
}
const Ft = class extends Na {
  static getInstance(t) {
    return Ft.INSTANCE || (Ft.INSTANCE = new Ft(t)), Ft.INSTANCE;
  }
  // eslint-disable-next-line no-useless-constructor
  constructor(t) {
    super(t);
  }
  async getCollectionsFromUser(t, n, i, s, o) {
    const r = `/cookbooks/user-${t}/collections?offset=${i}&limit=${n}&order=${s}&orderBy=${o}`;
    try {
      return await this.get(r).then((a) => a.data);
    } catch (a) {
      throw console.log(a), a;
    }
  }
  async getCollectionsByRecipeId(t, n) {
    const i = `/cookbooks/user-${t}/recipes/${n}/collections`;
    try {
      return await this.get(i).then((s) => s.data);
    } catch (s) {
      throw console.log(s), s;
    }
  }
  async checkForBeingInCookbook(t, n) {
    const i = `/cookbooks/user-${t}/recipes/check`, s = {
      recipeIds: [n]
    };
    try {
      return await this.post(i, s).then((o) => o.data);
    } catch (o) {
      throw console.log(o), o;
    }
  }
  async searchCollections(t, n, i, s = 10) {
    const o = `/cookbooks/user-${t}/categories/search?query=${n}&offset=${i}&limit=${s}`;
    try {
      return await this.get(o).then((r) => r.data);
    } catch (r) {
      throw console.log(r), r;
    }
  }
  async createCollection(t, n, i) {
    try {
      const s = `/cookbooks/user-${t}/collections`;
      let o;
      return i !== "" ? o = {
        name: n,
        descriptionText: i
      } : o = {
        name: n
      }, await this.post(s, o).then((r) => r.data);
    } catch (s) {
      throw console.log(s), s;
    }
  }
  async updateSavedRecipes(t, n, i) {
    try {
      const s = `/cookbooks/user-${t}/saved-recipes`, o = {
        recipeIds: n,
        collectionIds: i
      };
      return await this.patch(s, o).then((r) => r.data);
    } catch (s) {
      throw console.log(s), s;
    }
  }
  async savePrivateRecipe(t, n, i) {
    try {
      const s = `/cookbooks/user-${t}/private-recipes`, o = {
        scrapeId: n.scrapeId,
        title: n.title,
        subtitle: n.subtitle,
        servings: n.servings,
        kCalories: n.kCalories,
        ingredientsText: n.ingredientsText,
        instructions: n.instructions,
        miscellaneousText: n.miscellaneousText,
        difficulty: n.difficulty,
        categoryIds: i,
        preparationTime: n.preparationTime,
        cookingTime: n.cookingTime,
        restingTime: n.restingTime,
        source: {
          name: n.source ? n.source.name : null,
          url: n.source ? n.source.url : null
        },
        subtype: n.subtype,
        previewImage: n.previewImage
      };
      return await this.post(s, o).then((r) => r.data);
    } catch (s) {
      throw console.log(s), s;
    }
  }
};
let Fn = Ft;
Pe(Fn, "INSTANCE");
const Ut = class extends Na {
  static getInstance(t) {
    return Ut.INSTANCE || (Ut.INSTANCE = new Ut(t)), Ut.INSTANCE;
  }
  // eslint-disable-next-line no-useless-constructor
  constructor(t) {
    super(t);
  }
  async getApiTokenFromBenutzerMe() {
    try {
      const t = "/benutzer/me";
      return await this.getBenutzerMe(t).then((n) => n.data);
    } catch (t) {
      throw console.log(t), t;
    }
  }
  async getBenutzerMe(t) {
    return this.http.get(this.config.baseURL + t, {
      headers: {
        Accept: "application/json"
      },
      withCredentials: !0
    });
  }
};
let Un = Ut;
Pe(Un, "INSTANCE");
function Ea(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Oa } = Object.prototype, { getPrototypeOf: zs } = Object, Hs = ((e) => (t) => {
  const n = Oa.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), lt = (e) => (e = e.toLowerCase(), (t) => Hs(t) === e), yi = (e) => (t) => typeof t === e, { isArray: en } = Array, yn = yi("undefined");
function Qg(e) {
  return e !== null && !yn(e) && e.constructor !== null && !yn(e.constructor) && yt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ma = lt("ArrayBuffer");
function Xg(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ma(e.buffer), t;
}
const eh = yi("string"), yt = yi("function"), Ba = yi("number"), Vs = (e) => e !== null && typeof e == "object", th = (e) => e === !0 || e === !1, zn = (e) => {
  if (Hs(e) !== "object")
    return !1;
  const t = zs(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, nh = lt("Date"), ih = lt("File"), sh = lt("Blob"), oh = lt("FileList"), rh = (e) => Vs(e) && yt(e.pipe), ah = (e) => {
  const t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || Oa.call(e) === t || yt(e.toString) && e.toString() === t);
}, lh = lt("URLSearchParams"), dh = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function kn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, s;
  if (typeof e != "object" && (e = [e]), en(e))
    for (i = 0, s = e.length; i < s; i++)
      t.call(null, e[i], i, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), r = o.length;
    let a;
    for (i = 0; i < r; i++)
      a = o[i], t.call(null, e[a], a, e);
  }
}
function Ra(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let i = n.length, s;
  for (; i-- > 0; )
    if (s = n[i], t === s.toLowerCase())
      return s;
  return null;
}
const La = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Pa = (e) => !yn(e) && e !== La;
function Xi() {
  const { caseless: e } = Pa(this) && this || {}, t = {}, n = (i, s) => {
    const o = e && Ra(t, s) || s;
    zn(t[o]) && zn(i) ? t[o] = Xi(t[o], i) : zn(i) ? t[o] = Xi({}, i) : en(i) ? t[o] = i.slice() : t[o] = i;
  };
  for (let i = 0, s = arguments.length; i < s; i++)
    arguments[i] && kn(arguments[i], n);
  return t;
}
const ch = (e, t, n, { allOwnKeys: i } = {}) => (kn(t, (s, o) => {
  n && yt(s) ? e[o] = Ea(s, n) : e[o] = s;
}, { allOwnKeys: i }), e), ph = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), uh = (e, t, n, i) => {
  e.prototype = Object.create(t.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, mh = (e, t, n, i) => {
  let s, o, r;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      r = s[o], (!i || i(r, e, t)) && !a[r] && (t[r] = e[r], a[r] = !0);
    e = n !== !1 && zs(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, fh = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const i = e.indexOf(t, n);
  return i !== -1 && i === n;
}, gh = (e) => {
  if (!e)
    return null;
  if (en(e))
    return e;
  let t = e.length;
  if (!Ba(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, hh = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && zs(Uint8Array)), bh = (e, t) => {
  const i = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = i.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, xh = (e, t) => {
  let n;
  const i = [];
  for (; (n = e.exec(t)) !== null; )
    i.push(n);
  return i;
}, _h = lt("HTMLFormElement"), Ch = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, i, s) {
    return i.toUpperCase() + s;
  }
), zo = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), yh = lt("RegExp"), ja = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), i = {};
  kn(n, (s, o) => {
    t(s, o, e) !== !1 && (i[o] = s);
  }), Object.defineProperties(e, i);
}, vh = (e) => {
  ja(e, (t, n) => {
    if (yt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const i = e[n];
    if (yt(i)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, wh = (e, t) => {
  const n = {}, i = (s) => {
    s.forEach((o) => {
      n[o] = !0;
    });
  };
  return en(e) ? i(e) : i(String(e).split(t)), n;
}, Ih = () => {
}, kh = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Bi = "abcdefghijklmnopqrstuvwxyz", Ho = "0123456789", Fa = {
  DIGIT: Ho,
  ALPHA: Bi,
  ALPHA_DIGIT: Bi + Bi.toUpperCase() + Ho
}, Ah = (e = 16, t = Fa.ALPHA_DIGIT) => {
  let n = "";
  const { length: i } = t;
  for (; e--; )
    n += t[Math.random() * i | 0];
  return n;
};
function Sh(e) {
  return !!(e && yt(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Th = (e) => {
  const t = new Array(10), n = (i, s) => {
    if (Vs(i)) {
      if (t.indexOf(i) >= 0)
        return;
      if (!("toJSON" in i)) {
        t[s] = i;
        const o = en(i) ? [] : {};
        return kn(i, (r, a) => {
          const l = n(r, s + 1);
          !yn(l) && (o[a] = l);
        }), t[s] = void 0, o;
      }
    }
    return i;
  };
  return n(e, 0);
}, C = {
  isArray: en,
  isArrayBuffer: Ma,
  isBuffer: Qg,
  isFormData: ah,
  isArrayBufferView: Xg,
  isString: eh,
  isNumber: Ba,
  isBoolean: th,
  isObject: Vs,
  isPlainObject: zn,
  isUndefined: yn,
  isDate: nh,
  isFile: ih,
  isBlob: sh,
  isRegExp: yh,
  isFunction: yt,
  isStream: rh,
  isURLSearchParams: lh,
  isTypedArray: hh,
  isFileList: oh,
  forEach: kn,
  merge: Xi,
  extend: ch,
  trim: dh,
  stripBOM: ph,
  inherits: uh,
  toFlatObject: mh,
  kindOf: Hs,
  kindOfTest: lt,
  endsWith: fh,
  toArray: gh,
  forEachEntry: bh,
  matchAll: xh,
  isHTMLForm: _h,
  hasOwnProperty: zo,
  hasOwnProp: zo,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ja,
  freezeMethods: vh,
  toObjectSet: wh,
  toCamelCase: Ch,
  noop: Ih,
  toFiniteNumber: kh,
  findKey: Ra,
  global: La,
  isContextDefined: Pa,
  ALPHABET: Fa,
  generateString: Ah,
  isSpecCompliantForm: Sh,
  toJSONObject: Th
};
function re(e, t, n, i, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), i && (this.request = i), s && (this.response = s);
}
C.inherits(re, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: C.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Ua = re.prototype, za = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  za[e] = { value: e };
});
Object.defineProperties(re, za);
Object.defineProperty(Ua, "isAxiosError", { value: !0 });
re.from = (e, t, n, i, s, o) => {
  const r = Object.create(Ua);
  return C.toFlatObject(e, r, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), re.call(r, e.message, t, n, i, s), r.cause = e, r.name = e.name, o && Object.assign(r, o), r;
};
const $h = null;
function es(e) {
  return C.isPlainObject(e) || C.isArray(e);
}
function Ha(e) {
  return C.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Vo(e, t, n) {
  return e ? e.concat(t).map(function(s, o) {
    return s = Ha(s), !n && o ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function Dh(e) {
  return C.isArray(e) && !e.some(es);
}
const Nh = C.toFlatObject(C, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function vi(e, t, n) {
  if (!C.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = C.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(k, K) {
    return !C.isUndefined(K[k]);
  });
  const i = n.metaTokens, s = n.visitor || c, o = n.dots, r = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && C.isSpecCompliantForm(t);
  if (!C.isFunction(s))
    throw new TypeError("visitor must be a function");
  function d(_) {
    if (_ === null)
      return "";
    if (C.isDate(_))
      return _.toISOString();
    if (!l && C.isBlob(_))
      throw new re("Blob is not supported. Use a Buffer instead.");
    return C.isArrayBuffer(_) || C.isTypedArray(_) ? l && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function c(_, k, K) {
    let U = _;
    if (_ && !K && typeof _ == "object") {
      if (C.endsWith(k, "{}"))
        k = i ? k : k.slice(0, -2), _ = JSON.stringify(_);
      else if (C.isArray(_) && Dh(_) || (C.isFileList(_) || C.endsWith(k, "[]")) && (U = C.toArray(_)))
        return k = Ha(k), U.forEach(function(P, G) {
          !(C.isUndefined(P) || P === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            r === !0 ? Vo([k], G, o) : r === null ? k : k + "[]",
            d(P)
          );
        }), !1;
    }
    return es(_) ? !0 : (t.append(Vo(K, k, o), d(_)), !1);
  }
  const f = [], h = Object.assign(Nh, {
    defaultVisitor: c,
    convertValue: d,
    isVisitable: es
  });
  function y(_, k) {
    if (!C.isUndefined(_)) {
      if (f.indexOf(_) !== -1)
        throw Error("Circular reference detected in " + k.join("."));
      f.push(_), C.forEach(_, function(U, ae) {
        (!(C.isUndefined(U) || U === null) && s.call(
          t,
          U,
          C.isString(ae) ? ae.trim() : ae,
          k,
          h
        )) === !0 && y(U, k ? k.concat(ae) : [ae]);
      }), f.pop();
    }
  }
  if (!C.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function qo(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return t[i];
  });
}
function qs(e, t) {
  this._pairs = [], e && vi(e, this, t);
}
const Va = qs.prototype;
Va.append = function(t, n) {
  this._pairs.push([t, n]);
};
Va.toString = function(t) {
  const n = t ? function(i) {
    return t.call(this, i, qo);
  } : qo;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function Eh(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function qa(e, t, n) {
  if (!t)
    return e;
  const i = n && n.encode || Eh, s = n && n.serialize;
  let o;
  if (s ? o = s(t, n) : o = C.isURLSearchParams(t) ? t.toString() : new qs(t, n).toString(i), o) {
    const r = e.indexOf("#");
    r !== -1 && (e = e.slice(0, r)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Oh {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, i) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    C.forEach(this.handlers, function(i) {
      i !== null && t(i);
    });
  }
}
const Wo = Oh, Wa = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Mh = typeof URLSearchParams < "u" ? URLSearchParams : qs, Bh = typeof FormData < "u" ? FormData : null, Rh = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Lh = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Xe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Mh,
    FormData: Bh,
    Blob
  },
  isStandardBrowserEnv: Rh,
  isStandardBrowserWebWorkerEnv: Lh,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Ph(e, t) {
  return vi(e, new Xe.classes.URLSearchParams(), Object.assign({
    visitor: function(n, i, s, o) {
      return Xe.isNode && C.isBuffer(n) ? (this.append(i, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function jh(e) {
  return C.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Fh(e) {
  const t = {}, n = Object.keys(e);
  let i;
  const s = n.length;
  let o;
  for (i = 0; i < s; i++)
    o = n[i], t[o] = e[o];
  return t;
}
function Za(e) {
  function t(n, i, s, o) {
    let r = n[o++];
    const a = Number.isFinite(+r), l = o >= n.length;
    return r = !r && C.isArray(s) ? s.length : r, l ? (C.hasOwnProp(s, r) ? s[r] = [s[r], i] : s[r] = i, !a) : ((!s[r] || !C.isObject(s[r])) && (s[r] = []), t(n, i, s[r], o) && C.isArray(s[r]) && (s[r] = Fh(s[r])), !a);
  }
  if (C.isFormData(e) && C.isFunction(e.entries)) {
    const n = {};
    return C.forEachEntry(e, (i, s) => {
      t(jh(i), s, n, 0);
    }), n;
  }
  return null;
}
const Uh = {
  "Content-Type": void 0
};
function zh(e, t, n) {
  if (C.isString(e))
    try {
      return (t || JSON.parse)(e), C.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (n || JSON.stringify)(e);
}
const wi = {
  transitional: Wa,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const i = n.getContentType() || "", s = i.indexOf("application/json") > -1, o = C.isObject(t);
    if (o && C.isHTMLForm(t) && (t = new FormData(t)), C.isFormData(t))
      return s && s ? JSON.stringify(Za(t)) : t;
    if (C.isArrayBuffer(t) || C.isBuffer(t) || C.isStream(t) || C.isFile(t) || C.isBlob(t))
      return t;
    if (C.isArrayBufferView(t))
      return t.buffer;
    if (C.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return Ph(t, this.formSerializer).toString();
      if ((a = C.isFileList(t)) || i.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return vi(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || s ? (n.setContentType("application/json", !1), zh(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || wi.transitional, i = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (t && C.isString(t) && (i && !this.responseType || s)) {
      const r = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (r)
          throw a.name === "SyntaxError" ? re.from(a, re.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Xe.classes.FormData,
    Blob: Xe.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
C.forEach(["delete", "get", "head"], function(t) {
  wi.headers[t] = {};
});
C.forEach(["post", "put", "patch"], function(t) {
  wi.headers[t] = C.merge(Uh);
});
const Ws = wi, Hh = C.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Vh = (e) => {
  const t = {};
  let n, i, s;
  return e && e.split(`
`).forEach(function(r) {
    s = r.indexOf(":"), n = r.substring(0, s).trim().toLowerCase(), i = r.substring(s + 1).trim(), !(!n || t[n] && Hh[n]) && (n === "set-cookie" ? t[n] ? t[n].push(i) : t[n] = [i] : t[n] = t[n] ? t[n] + ", " + i : i);
  }), t;
}, Zo = Symbol("internals");
function on(e) {
  return e && String(e).trim().toLowerCase();
}
function Hn(e) {
  return e === !1 || e == null ? e : C.isArray(e) ? e.map(Hn) : String(e);
}
function qh(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = n.exec(e); )
    t[i[1]] = i[2];
  return t;
}
function Wh(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function Ri(e, t, n, i, s) {
  if (C.isFunction(i))
    return i.call(this, t, n);
  if (s && (t = n), !!C.isString(t)) {
    if (C.isString(i))
      return t.indexOf(i) !== -1;
    if (C.isRegExp(i))
      return i.test(t);
  }
}
function Zh(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, i) => n.toUpperCase() + i);
}
function Kh(e, t) {
  const n = C.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + n, {
      value: function(s, o, r) {
        return this[i].call(this, t, s, o, r);
      },
      configurable: !0
    });
  });
}
class Ii {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, i) {
    const s = this;
    function o(a, l, d) {
      const c = on(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const f = C.findKey(s, c);
      (!f || s[f] === void 0 || d === !0 || d === void 0 && s[f] !== !1) && (s[f || l] = Hn(a));
    }
    const r = (a, l) => C.forEach(a, (d, c) => o(d, c, l));
    return C.isPlainObject(t) || t instanceof this.constructor ? r(t, n) : C.isString(t) && (t = t.trim()) && !Wh(t) ? r(Vh(t), n) : t != null && o(n, t, i), this;
  }
  get(t, n) {
    if (t = on(t), t) {
      const i = C.findKey(this, t);
      if (i) {
        const s = this[i];
        if (!n)
          return s;
        if (n === !0)
          return qh(s);
        if (C.isFunction(n))
          return n.call(this, s, i);
        if (C.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = on(t), t) {
      const i = C.findKey(this, t);
      return !!(i && this[i] !== void 0 && (!n || Ri(this, this[i], i, n)));
    }
    return !1;
  }
  delete(t, n) {
    const i = this;
    let s = !1;
    function o(r) {
      if (r = on(r), r) {
        const a = C.findKey(i, r);
        a && (!n || Ri(i, i[a], a, n)) && (delete i[a], s = !0);
      }
    }
    return C.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let i = n.length, s = !1;
    for (; i--; ) {
      const o = n[i];
      (!t || Ri(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, i = {};
    return C.forEach(this, (s, o) => {
      const r = C.findKey(i, o);
      if (r) {
        n[r] = Hn(s), delete n[o];
        return;
      }
      const a = t ? Zh(o) : String(o).trim();
      a !== o && delete n[o], n[a] = Hn(s), i[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return C.forEach(this, (i, s) => {
      i != null && i !== !1 && (n[s] = t && C.isArray(i) ? i.join(", ") : i);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const i = new this(t);
    return n.forEach((s) => i.set(s)), i;
  }
  static accessor(t) {
    const i = (this[Zo] = this[Zo] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(r) {
      const a = on(r);
      i[a] || (Kh(s, r), i[a] = !0);
    }
    return C.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
Ii.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
C.freezeMethods(Ii.prototype);
C.freezeMethods(Ii);
const it = Ii;
function Li(e, t) {
  const n = this || Ws, i = t || n, s = it.from(i.headers);
  let o = i.data;
  return C.forEach(e, function(a) {
    o = a.call(n, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function Ka(e) {
  return !!(e && e.__CANCEL__);
}
function An(e, t, n) {
  re.call(this, e ?? "canceled", re.ERR_CANCELED, t, n), this.name = "CanceledError";
}
C.inherits(An, re, {
  __CANCEL__: !0
});
function Jh(e, t, n) {
  const i = n.config.validateStatus;
  !n.status || !i || i(n.status) ? e(n) : t(new re(
    "Request failed with status code " + n.status,
    [re.ERR_BAD_REQUEST, re.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const Yh = Xe.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, i, s, o, r, a) {
        const l = [];
        l.push(n + "=" + encodeURIComponent(i)), C.isNumber(s) && l.push("expires=" + new Date(s).toGMTString()), C.isString(o) && l.push("path=" + o), C.isString(r) && l.push("domain=" + r), a === !0 && l.push("secure"), document.cookie = l.join("; ");
      },
      read: function(n) {
        const i = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return i ? decodeURIComponent(i[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Gh(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Qh(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ja(e, t) {
  return e && !Gh(t) ? Qh(e, t) : t;
}
const Xh = Xe.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let i;
    function s(o) {
      let r = o;
      return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return i = s(window.location.href), function(r) {
      const a = C.isString(r) ? s(r) : r;
      return a.protocol === i.protocol && a.host === i.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function e1(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function t1(e, t) {
  e = e || 10;
  const n = new Array(e), i = new Array(e);
  let s = 0, o = 0, r;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const d = Date.now(), c = i[o];
    r || (r = d), n[s] = l, i[s] = d;
    let f = o, h = 0;
    for (; f !== s; )
      h += n[f++], f = f % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), d - r < t)
      return;
    const y = c && d - c;
    return y ? Math.round(h * 1e3 / y) : void 0;
  };
}
function Ko(e, t) {
  let n = 0;
  const i = t1(50, 250);
  return (s) => {
    const o = s.loaded, r = s.lengthComputable ? s.total : void 0, a = o - n, l = i(a), d = o <= r;
    n = o;
    const c = {
      loaded: o,
      total: r,
      progress: r ? o / r : void 0,
      bytes: a,
      rate: l || void 0,
      estimated: l && r && d ? (r - o) / l : void 0,
      event: s
    };
    c[t ? "download" : "upload"] = !0, e(c);
  };
}
const n1 = typeof XMLHttpRequest < "u", i1 = n1 && function(e) {
  return new Promise(function(n, i) {
    let s = e.data;
    const o = it.from(e.headers).normalize(), r = e.responseType;
    let a;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(a), e.signal && e.signal.removeEventListener("abort", a);
    }
    C.isFormData(s) && (Xe.isStandardBrowserEnv || Xe.isStandardBrowserWebWorkerEnv) && o.setContentType(!1);
    let d = new XMLHttpRequest();
    if (e.auth) {
      const y = e.auth.username || "", _ = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(y + ":" + _));
    }
    const c = Ja(e.baseURL, e.url);
    d.open(e.method.toUpperCase(), qa(c, e.params, e.paramsSerializer), !0), d.timeout = e.timeout;
    function f() {
      if (!d)
        return;
      const y = it.from(
        "getAllResponseHeaders" in d && d.getAllResponseHeaders()
      ), k = {
        data: !r || r === "text" || r === "json" ? d.responseText : d.response,
        status: d.status,
        statusText: d.statusText,
        headers: y,
        config: e,
        request: d
      };
      Jh(function(U) {
        n(U), l();
      }, function(U) {
        i(U), l();
      }, k), d = null;
    }
    if ("onloadend" in d ? d.onloadend = f : d.onreadystatechange = function() {
      !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, d.onabort = function() {
      d && (i(new re("Request aborted", re.ECONNABORTED, e, d)), d = null);
    }, d.onerror = function() {
      i(new re("Network Error", re.ERR_NETWORK, e, d)), d = null;
    }, d.ontimeout = function() {
      let _ = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const k = e.transitional || Wa;
      e.timeoutErrorMessage && (_ = e.timeoutErrorMessage), i(new re(
        _,
        k.clarifyTimeoutError ? re.ETIMEDOUT : re.ECONNABORTED,
        e,
        d
      )), d = null;
    }, Xe.isStandardBrowserEnv) {
      const y = (e.withCredentials || Xh(c)) && e.xsrfCookieName && Yh.read(e.xsrfCookieName);
      y && o.set(e.xsrfHeaderName, y);
    }
    s === void 0 && o.setContentType(null), "setRequestHeader" in d && C.forEach(o.toJSON(), function(_, k) {
      d.setRequestHeader(k, _);
    }), C.isUndefined(e.withCredentials) || (d.withCredentials = !!e.withCredentials), r && r !== "json" && (d.responseType = e.responseType), typeof e.onDownloadProgress == "function" && d.addEventListener("progress", Ko(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && d.upload && d.upload.addEventListener("progress", Ko(e.onUploadProgress)), (e.cancelToken || e.signal) && (a = (y) => {
      d && (i(!y || y.type ? new An(null, e, d) : y), d.abort(), d = null);
    }, e.cancelToken && e.cancelToken.subscribe(a), e.signal && (e.signal.aborted ? a() : e.signal.addEventListener("abort", a)));
    const h = e1(c);
    if (h && Xe.protocols.indexOf(h) === -1) {
      i(new re("Unsupported protocol " + h + ":", re.ERR_BAD_REQUEST, e));
      return;
    }
    d.send(s || null);
  });
}, Vn = {
  http: $h,
  xhr: i1
};
C.forEach(Vn, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const s1 = {
  getAdapter: (e) => {
    e = C.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, i;
    for (let s = 0; s < t && (n = e[s], !(i = C.isString(n) ? Vn[n.toLowerCase()] : n)); s++)
      ;
    if (!i)
      throw i === !1 ? new re(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        C.hasOwnProp(Vn, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!C.isFunction(i))
      throw new TypeError("adapter is not a function");
    return i;
  },
  adapters: Vn
};
function Pi(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new An(null, e);
}
function Jo(e) {
  return Pi(e), e.headers = it.from(e.headers), e.data = Li.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), s1.getAdapter(e.adapter || Ws.adapter)(e).then(function(i) {
    return Pi(e), i.data = Li.call(
      e,
      e.transformResponse,
      i
    ), i.headers = it.from(i.headers), i;
  }, function(i) {
    return Ka(i) || (Pi(e), i && i.response && (i.response.data = Li.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = it.from(i.response.headers))), Promise.reject(i);
  });
}
const Yo = (e) => e instanceof it ? e.toJSON() : e;
function Jt(e, t) {
  t = t || {};
  const n = {};
  function i(d, c, f) {
    return C.isPlainObject(d) && C.isPlainObject(c) ? C.merge.call({ caseless: f }, d, c) : C.isPlainObject(c) ? C.merge({}, c) : C.isArray(c) ? c.slice() : c;
  }
  function s(d, c, f) {
    if (C.isUndefined(c)) {
      if (!C.isUndefined(d))
        return i(void 0, d, f);
    } else
      return i(d, c, f);
  }
  function o(d, c) {
    if (!C.isUndefined(c))
      return i(void 0, c);
  }
  function r(d, c) {
    if (C.isUndefined(c)) {
      if (!C.isUndefined(d))
        return i(void 0, d);
    } else
      return i(void 0, c);
  }
  function a(d, c, f) {
    if (f in t)
      return i(d, c);
    if (f in e)
      return i(void 0, d);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: r,
    transformRequest: r,
    transformResponse: r,
    paramsSerializer: r,
    timeout: r,
    timeoutMessage: r,
    withCredentials: r,
    adapter: r,
    responseType: r,
    xsrfCookieName: r,
    xsrfHeaderName: r,
    onUploadProgress: r,
    onDownloadProgress: r,
    decompress: r,
    maxContentLength: r,
    maxBodyLength: r,
    beforeRedirect: r,
    transport: r,
    httpAgent: r,
    httpsAgent: r,
    cancelToken: r,
    socketPath: r,
    responseEncoding: r,
    validateStatus: a,
    headers: (d, c) => s(Yo(d), Yo(c), !0)
  };
  return C.forEach(Object.keys(e).concat(Object.keys(t)), function(c) {
    const f = l[c] || s, h = f(e[c], t[c], c);
    C.isUndefined(h) && f !== a || (n[c] = h);
  }), n;
}
const Ya = "1.3.3", Zs = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Zs[e] = function(i) {
    return typeof i === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Go = {};
Zs.transitional = function(t, n, i) {
  function s(o, r) {
    return "[Axios v" + Ya + "] Transitional option '" + o + "'" + r + (i ? ". " + i : "");
  }
  return (o, r, a) => {
    if (t === !1)
      throw new re(
        s(r, " has been removed" + (n ? " in " + n : "")),
        re.ERR_DEPRECATED
      );
    return n && !Go[r] && (Go[r] = !0, console.warn(
      s(
        r,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, r, a) : !0;
  };
};
function o1(e, t, n) {
  if (typeof e != "object")
    throw new re("options must be an object", re.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let s = i.length;
  for (; s-- > 0; ) {
    const o = i[s], r = t[o];
    if (r) {
      const a = e[o], l = a === void 0 || r(a, o, e);
      if (l !== !0)
        throw new re("option " + o + " must be " + l, re.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new re("Unknown option " + o, re.ERR_BAD_OPTION);
  }
}
const ts = {
  assertOptions: o1,
  validators: Zs
}, pt = ts.validators;
class Qn {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Wo(),
      response: new Wo()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Jt(this.defaults, n);
    const { transitional: i, paramsSerializer: s, headers: o } = n;
    i !== void 0 && ts.assertOptions(i, {
      silentJSONParsing: pt.transitional(pt.boolean),
      forcedJSONParsing: pt.transitional(pt.boolean),
      clarifyTimeoutError: pt.transitional(pt.boolean)
    }, !1), s !== void 0 && ts.assertOptions(s, {
      encode: pt.function,
      serialize: pt.function
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let r;
    r = o && C.merge(
      o.common,
      o[n.method]
    ), r && C.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (_) => {
        delete o[_];
      }
    ), n.headers = it.concat(r, o);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(k) {
      typeof k.runWhen == "function" && k.runWhen(n) === !1 || (l = l && k.synchronous, a.unshift(k.fulfilled, k.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(k) {
      d.push(k.fulfilled, k.rejected);
    });
    let c, f = 0, h;
    if (!l) {
      const _ = [Jo.bind(this), void 0];
      for (_.unshift.apply(_, a), _.push.apply(_, d), h = _.length, c = Promise.resolve(n); f < h; )
        c = c.then(_[f++], _[f++]);
      return c;
    }
    h = a.length;
    let y = n;
    for (f = 0; f < h; ) {
      const _ = a[f++], k = a[f++];
      try {
        y = _(y);
      } catch (K) {
        k.call(this, K);
        break;
      }
    }
    try {
      c = Jo.call(this, y);
    } catch (_) {
      return Promise.reject(_);
    }
    for (f = 0, h = d.length; f < h; )
      c = c.then(d[f++], d[f++]);
    return c;
  }
  getUri(t) {
    t = Jt(this.defaults, t);
    const n = Ja(t.baseURL, t.url);
    return qa(n, t.params, t.paramsSerializer);
  }
}
C.forEach(["delete", "get", "head", "options"], function(t) {
  Qn.prototype[t] = function(n, i) {
    return this.request(Jt(i || {}, {
      method: t,
      url: n,
      data: (i || {}).data
    }));
  };
});
C.forEach(["post", "put", "patch"], function(t) {
  function n(i) {
    return function(o, r, a) {
      return this.request(Jt(a || {}, {
        method: t,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: r
      }));
    };
  }
  Qn.prototype[t] = n(), Qn.prototype[t + "Form"] = n(!0);
});
const qn = Qn;
class Ks {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const i = this;
    this.promise.then((s) => {
      if (!i._listeners)
        return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](s);
      i._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const r = new Promise((a) => {
        i.subscribe(a), o = a;
      }).then(s);
      return r.cancel = function() {
        i.unsubscribe(o);
      }, r;
    }, t(function(o, r, a) {
      i.reason || (i.reason = new An(o, r, a), n(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ks(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
const r1 = Ks;
function a1(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function l1(e) {
  return C.isObject(e) && e.isAxiosError === !0;
}
const ns = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ns).forEach(([e, t]) => {
  ns[t] = e;
});
const d1 = ns;
function Ga(e) {
  const t = new qn(e), n = Ea(qn.prototype.request, t);
  return C.extend(n, qn.prototype, t, { allOwnKeys: !0 }), C.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return Ga(Jt(e, s));
  }, n;
}
const Te = Ga(Ws);
Te.Axios = qn;
Te.CanceledError = An;
Te.CancelToken = r1;
Te.isCancel = Ka;
Te.VERSION = Ya;
Te.toFormData = vi;
Te.AxiosError = re;
Te.Cancel = Te.CanceledError;
Te.all = function(t) {
  return Promise.all(t);
};
Te.spread = a1;
Te.isAxiosError = l1;
Te.mergeConfig = Jt;
Te.AxiosHeaders = it;
Te.formToJSON = (e) => Za(C.isHTMLForm(e) ? new FormData(e) : e);
Te.HttpStatusCode = d1;
Te.default = Te;
const Qa = Te;
class Qo {
  constructor(t) {
    Pe(this, "config");
    Pe(this, "client");
    this.client = Qa.create({}), this.config = {
      baseURL: "https://api.chefkoch.de",
      apiPath: "/v2",
      headers: {
        "X-Chefkoch-Api-Token": t,
        Accept: "application/json"
      }
    };
  }
}
class c1 {
  constructor(t) {
    Pe(this, "config");
    Pe(this, "client");
    this.client = Qa.create({}), this.config = {
      baseURL: "https://www.chefkoch.de",
      apiPath: "/api/v2",
      headers: {
        "X-Chefkoch-Api-Token": t,
        Accept: "application/json"
      }
    };
  }
}
class Xo {
  constructor() {
    Pe(this, "defaultClient");
    this.defaultClient = new Qo("");
  }
  // TODO: Implement a real anonymous client
  getClient(t = "") {
    return this.defaultClient = new Qo(t), this.defaultClient;
  }
  getBenutzerMeClient(t) {
    return new c1(t);
  }
}
const gt = Us("user", {
  state: () => ({
    isAuthenticated: !1,
    user: {
      username: "",
      id: "",
      cookbookId: "",
      hasPaid: !1,
      isPure: !1,
      apiToken: ""
    },
    userMeLoadingState: ""
  }),
  actions: {
    getCookbookGateway() {
      return new Fn(new Xo().getClient(this.user.apiToken));
    },
    async getBenutzerMe() {
      const e = new Un(new Xo().getBenutzerMeClient(this.user.apiToken));
      try {
        const t = await e.getApiTokenFromBenutzerMe(), n = t.roles.includes("ROLE_REGUSER") || t.roles.includes("ROLE_MODERATOR") || t.roles.includes("ROLE_ADMIN");
        this.isAuthenticated = !0, this.user = {
          username: t.username,
          id: t.id,
          cookbookId: "user-" + t.id,
          hasPaid: t.hasPaid,
          isPure: n || t.hasPaid,
          apiToken: t.api_token
        }, this.userMeLoadingState = "success";
      } catch (t) {
        this.userMeLoadingState = "error", console.log(t);
      }
    }
  }
}), Xa = Us("search", () => {
  const e = J([]), t = J(0), n = J(0), i = J(""), s = 15, o = gt(), r = D(() => e.value.length > 0 && e.value.length >= n.value), a = D(() => i.value !== "");
  function l() {
    e.value = [], n.value = 0, t.value = 0, i.value = "";
  }
  async function d() {
    try {
      const c = await o.getCookbookGateway().searchCollections(o.user.id, i.value, t.value, s);
      e.value.push(
        ...c.results.filter(
          (f) => !e.value.find((h) => h.id === f.id)
        )
      ), n.value = c.count, t.value += s;
    } catch (c) {
      console.log(c);
    }
  }
  return { resultCollections: e, resultCount: n, clear: l, query: i, allResultsLoaded: r, getResults: d, active: a };
}), p1 = Us("collections", {
  state: () => ({
    recipeId: null,
    collectionsFromUser: [],
    collectionsByRecipeId: /* @__PURE__ */ new Set(),
    //NOTICE: Logic is only for one recipe atm, might need some refactoring
    recipeAlreadyInCookbook: !1,
    collectionsFromUserLimit: 15,
    collectionsFromUserOffset: 0,
    collectionsFromUserOrder: 1,
    collectionsFromUserOrderBy: 1,
    collectionsFromUserCount: 0
  }),
  actions: {
    async checkRecipeForBeingInCookbook() {
      const e = gt(), t = e.getCookbookGateway();
      try {
        this.recipeId && (await t.checkForBeingInCookbook(e.user.id, this.recipeId)).results.forEach((i) => {
          i.id === this.recipeId && i.containing && (this.recipeAlreadyInCookbook = !0);
        });
      } catch (n) {
        console.log(n);
      }
    },
    async getCollectionsFromUser() {
      const e = gt(), t = e.getCookbookGateway();
      try {
        this.recipeId && this.collectionsFromUserOffset === 0 && await this.getCollectionsByRecipeId();
        const n = await t.getCollectionsFromUser(
          e.user.id,
          this.collectionsFromUserLimit,
          this.collectionsFromUserOffset,
          this.collectionsFromUserOrder,
          this.collectionsFromUserOrderBy
        );
        n.results.forEach((i) => this.addCollectionToCollectionsFromUser(i)), this.collectionsFromUserCount = n.count, this.collectionsFromUserOffset += this.collectionsFromUserLimit;
      } catch (n) {
        console.log(n);
      }
    },
    addCollectionToCollectionsFromUser(e) {
      this.collectionsFromUser.find((t) => t.id === e.id) || this.collectionsFromUser.push(e);
    },
    async getCollectionsByRecipeId() {
      const e = gt(), t = e.getCookbookGateway();
      try {
        this.recipeId && (await t.getCollectionsByRecipeId(e.user.id, this.recipeId)).collectionIds.forEach((i) => this.collectionsByRecipeId.add(i));
      } catch (n) {
        console.log(n);
      }
    },
    async createCollection(e) {
      var i;
      const t = gt(), n = t.getCookbookGateway();
      try {
        return (i = (await n.createCollection(t.user.id, e.title, e.description ? e.description : "")).notification) == null ? void 0 : i.messages;
      } catch (s) {
        throw console.log(s), s;
      }
    },
    async createRecipe(e) {
      var i, s;
      const t = gt(), n = t.getCookbookGateway();
      try {
        const r = (s = (i = (await n.savePrivateRecipe(t.user.id, e, Array.from(this.collectionsByRecipeId))).notification) == null ? void 0 : i.messages[0]) == null ? void 0 : s.recipe;
        r.id && (this.recipeId = r.id);
      } catch (o) {
        console.log(o);
      }
    },
    async updateSavedRecipe(e, t) {
      const n = gt(), i = n.getCookbookGateway();
      try {
        await i.updateSavedRecipes(n.user.id, e, t);
      } catch (s) {
        console.log(s);
      }
    },
    setRecipeId(e) {
      this.recipeId = e;
    },
    resetCollectionsFromUser() {
      this.collectionsFromUser = [], this.collectionsFromUserCount = 0, this.collectionsFromUserOffset = 0;
    },
    collectionsFullyLoaded() {
      return this.collectionsFromUser.length >= this.collectionsFromUserCount || this.collectionsFromUserOffset >= this.collectionsFromUserCount;
    },
    resetCollectionsStore() {
      this.recipeId = null, this.collectionsFromUser = [], this.collectionsByRecipeId = /* @__PURE__ */ new Set(), this.recipeAlreadyInCookbook = !1, this.collectionsFromUserLimit = 15, this.collectionsFromUserOffset = 0, this.collectionsFromUserOrder = 1, this.collectionsFromUserOrderBy = 1, this.collectionsFromUserCount = 0;
    }
  }
}), u1 = { class: "ds-btn__label" }, m1 = /* @__PURE__ */ b("i", { class: "ds-btn__icon ds-btn__icon--trailing chefkoch-icons" }, "add", -1), f1 = /* @__PURE__ */ Z({
  __name: "TileActionButton",
  emits: ["addCollection"],
  setup(e, { emit: t }) {
    function n() {
      t("addCollection");
    }
    return (i, s) => (u(), g("button", {
      class: "ds-text-sans ds-mt-6 ds-btn ds-btn--fluid ds-btn--tile ds-btn--tile-action",
      onClick: n
    }, [
      b("span", u1, [
        fe(i.$slots, "default")
      ]),
      m1
    ]));
  }
}), g1 = /* @__PURE__ */ b("i", { class: "chefkoch-icons chefkoch-icons--squared" }, "chevron_right", -1), h1 = /* @__PURE__ */ b("span", {
  id: "scrollingEnd",
  style: { display: "block" }
}, null, -1), b1 = /* @__PURE__ */ Z({
  __name: "CollectionListItems",
  props: {
    items: null,
    loading: { type: Boolean, default: !1 }
  },
  emits: ["endReached", "checkboxToggled"],
  setup(e, { emit: t }) {
    const n = e;
    let i, s;
    at(() => {
      var l, d, c, f;
      if (i = ((d = (l = document.querySelector("save-dialog")) == null ? void 0 : l.shadowRoot) == null ? void 0 : d.querySelector(".ds-overlay__body")) ?? null, i) {
        const h = {
          root: i,
          threshold: 1
        };
        s = new IntersectionObserver(r, h);
        const y = ((f = (c = document.querySelector("save-dialog")) == null ? void 0 : c.shadowRoot) == null ? void 0 : f.querySelector("#scrollingEnd")) ?? null;
        y && s.observe(y);
      }
    }), _s(() => {
      !n.loading && !o() && t("endReached");
    });
    function o() {
      return i ? i.scrollHeight > i.clientHeight : !1;
    }
    function r(l) {
      var d;
      n.loading || !((d = l[0]) != null && d.isIntersecting) || t("endReached");
    }
    function a(l) {
      t("checkboxToggled", l.collection.id);
    }
    return (l, d) => (u(), g("div", null, [
      (u(!0), g(X, null, Bt(n.items, (c) => (u(), le(_e(Ds), {
        key: c.collection.id,
        class: "ds-mv-4",
        "is-checked": c.isContaining,
        "has-image": "",
        "image-template": c.collection.previewImageUrlTemplate,
        "recipe-count": c.collection.recipeCount,
        title: c.collection.name,
        "in-overlay": "",
        "date-string": "11",
        "is-selectable": "",
        onOnClick: (f) => a(c)
      }, {
        menu: Ae(() => [
          g1
        ]),
        _: 2
      }, 1032, ["is-checked", "image-template", "recipe-count", "title", "onOnClick"]))), 128)),
      h1,
      e.loading ? (u(), le(_e(mi), { key: 0 })) : A("", !0)
    ]));
  }
}), x1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MTYiIGhlaWdodD0iNDQ1IiB2aWV3Qm94PSIwIDAgNjE2IDQ0NSI+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgICAgICAgIDxwYXRoIGlkPSJtYXNrIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3MDcwNzAiIGQ9Ik0wIDBINjE2VjQ0NUgweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxIDUyNSkiLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoLTIiPgogICAgICAgICAgICA8cGF0aCBpZD0iUmVjaHRlY2tfMTI0MiIgZD0iTTAgMEg0MTAuMzgxVjQwOS40MjdIMHoiIGNsYXNzPSJjbHMtMiIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgtMyI+CiAgICAgICAgICAgIDxwYXRoIGlkPSJSZWNodGVja18xMjQzIiBkPSJNMCAwSDE5OC43OFYzMDQuMzZIMHoiIGNsYXNzPSJjbHMtMiIgdHJhbnNmb3JtPSJyb3RhdGUoLTc1IDEyNS4xMTQgOTYuMDAzKSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTEyLC5jbHMtMntmaWxsOm5vbmV9LmNscy0xMntzdHJva2U6I2E3MDAwMDtzdHJva2Utd2lkdGg6MjBweDtzdHJva2UtbGluZWNhcDpyb3VuZH0KICAgICAgICA8L3N0eWxlPgogICAgPC9kZWZzPgogICAgPGcgaWQ9ImVtcHR5c3RhdGUtc2VhcmNocmVzdWx0LW5vbmUiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcxIC01MjUpIj4KICAgICAgICA8ZyBpZD0iR3J1cHBlXzE1NjI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjMuNDQ2IC0xMzkuMzQpIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwXzMtMiIgdHJhbnNmb3JtPSJyb3RhdGUoMTI2LjAyIDE3MC4yNjQgNjEzLjE4NSkiPgogICAgICAgICAgICAgICAgPHBhdGggaWQ9IkNsaXBfMi00IiBkPSJNODAuMTQ5IDU5Ljg3OGg0MTAuMzgyVjQ2OS4zSDgwLjE0OXoiIGNsYXNzPSJjbHMtMiIKICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MC4xNDkgLTU5Ljg3OCkiLz4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcnVwcGVfODU1OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjAwMSkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcnVwcGVfODU1OCIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtcGF0aC0yKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cF8zLTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMDAxKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBpZD0iRmlsbF8xIiBmaWxsPSIjZjJmM2VmIgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZD0iTTQ5MC41MzEgMjY0LjkyMmMwIDExMi42NzEtNjEuNjQxIDE5NC43NjYtMjA1LjE5MyAyMDQuMDEyQzE3Mi4yNTYgNDc2LjIgODAuMTQ5IDM3Ny41OTMgODAuMTQ5IDI2NC45MjJTMTQyLjY0IDc2Ljg2NiAyODUuMzQyIDYwLjkxNmMxMTIuNjE3LTEyLjU4OCAyMDUuMTkzIDkxLjMzOCAyMDUuMTkzIDIwNC4wMTIiCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuMTQ5IC01OS44NzgpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPGcgaWQ9IkdydXBwZV8xNTYyOCIgdHJhbnNmb3JtPSJyb3RhdGUoLTI2IDQ2NC4xNjUgODMyLjc1NCkiPgogICAgICAgICAgICAgICAgPHBhdGggaWQ9IkZpbGxfNF9Db3B5LTIiIGZpbGw9IiNmZjVlNjMiCiAgICAgICAgICAgICAgICAgICAgICBkPSJNOTAuODYgMTk5LjM3OWEyLjM4MSAyLjM4MSAwIDAgMSAzLjMwOC42MzFjLjAzOS4wNTguMDc2LjExNS4xMS4xNzVsMy4yIDUuNyAyLjk3IDUuMjg2YTEuMTkyIDEuMTkyIDAgMCAwIDIuMi0uMzExbDktMzguMzIyLTI0LjAzMi01LjcyLTguOTkxIDM4LjMyNWExLjE5MSAxLjE5MSAwIDAgMCAxLjgyNCAxLjI1OWw1LjAxNC0zLjM4NnoiCiAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTguMTE3IDc0OS42MDcpIi8+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXBfMTAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE1LjUxIDczMC43NTgpIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXBfMy00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDQuOTQ0KSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJDbGlwXzItNSIgZD0iTTEyMiA5Ny43NTdsMjkzLjk4NiA3OC43NzctNTEuNTA3IDE5MS45ODhMNzAuNDkgMjg5Ljc0OXoiIGNsYXNzPSJjbHMtMiIKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcwLjQ5IC05Ny43NDkpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcnVwcGVfODU2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjAyOSkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkdydXBwZV84NTYwIiBjbGlwLXBhdGg9InVybCgjY2xpcC1wYXRoLTMpIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXBfMy01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjE0OCA2LjI3KSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJGaWxsXzEtMiIgZmlsbD0iI2E3YzZhYyIKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZD0iTTQwOS43ODggMTc2Ljc1MWwtMjQtMTEuOGMtMS4xODgtLjU4MS0xNTEuNzYgOTQuOTQtMTUxLjc2IDk0Ljk0UzE1Mi4zODEgMTAxLjggMTUwLjIyIDEwMS45MTZsLTI2LjI2MS0xLjc1M2E1LjIzMiA1LjIzMiAwIDAgMC01LjQwNiAzLjg1N0w3MS4xMTkgMjgwLjgyOWE1LjE5MyA1LjE5MyAwIDAgMCAuNjQ2IDQuMTYxIDUuMzg4IDUuMzg4IDAgMCAwIDMuNTA2IDIuMzUybDExNS4wNjggMjAuMzg3IDU4LjA3MyAxNS41NTkgMTA5Ljg0IDM5Ljg3OWMuMTM5LjAzNy4yODMuMS40MjkuMTM2YTUuMjQ2IDUuMjQ2IDAgMCAwIDYuNDI0LTMuNjkyTDQxMi41NDEgMTgyLjhhNS4yMzIgNS4yMzIgMCAwIDAtMi43NTMtNi4wNDUiCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MC45NCAtMTAwLjE1KSIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBpZD0iRmlsbF80LTIiIGZpbGw9IiM2Y2EwNzUiCiAgICAgICAgICAgICAgICAgICAgICAgICAgZD0iTTEyOS4wNTUgMTYwLjQ4N2wtMTMuNDE2IDUwLjEzOWMyIDcuMDg2IDExLjgxMiAxMy40NzEgMjcuNyAxNy43MzlzMjcuNSAzLjY0MiAzMi43NzItMS40OTJsMTQuNDI2LTQ5Ljg2N3oiCiAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi41MDQgOC42MTIpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggaWQ9IkZpbGxfNi0zIiBmaWxsPSIjZTJlY2U0IgogICAgICAgICAgICAgICAgICAgICAgICAgIGQ9Ik0zNjIuNDI3IDE2Mi4yNDRjLTIzLjQxNy0yNS4zLTc1LjM0My00Mi41NDgtMTE0LjQzNy0zMy45MjktMjguNDE4LTIyLjM4My03Ny4zNzEtNDEuNS0xMTUuNjUxLTI3LjktNC42MjEgMS4yNDgtNDUuMzQzIDE2OS4zLTQ3LjU5MyAxNzIuMjktMS4zIDQuMzcyIDMuOTQzIDguMzUgNy44IDUuODI3IDkuNTgtNS44NTkgMzUuMjY4LTIuNzk1IDU1LjA4NSAyLjUzIDE1LjQ4MSA0LjE0NyA0NS4wMSAxNy40MjcgNDguOTYxIDI1LjQyMSAyLjM2MyA0Ljc4MyA0LjMzMSA0LjA4NyA3LjMzNSAxLjk0OSAxMC43MjktNy42MjUgMzUuMjY4LTIuNzkyIDU1LjA4NSAyLjUzIDE1LjQ3OCA0LjE0OCA0NC45MTkgMTguMDExIDQ4Ljk1OSAyNS40MjFhNS4yMzQgNS4yMzQgMCAwIDAgOS42NjQtMS4xMTdjLS40NzQtMy43NTIgNDguMTk1LTE2OS42MDYgNDQuNzkzLTE3My4wMjgiCiAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3Ljc2OCAtOTUuODY1KSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJQZmFkXzQzODciIGZpbGw9IiNmZmYiCiAgICAgICAgICAgICAgICAgICAgICAgICAgZD0iTTEzMS42IDI3NS44YTIuNjU3IDIuNjU3IDAgMCAxLS42OC0uMDg5IDIuNjE0IDIuNjE0IDAgMCAxLTEuODUtMy4ybDQyLjk2MS0xNjAuNTYyYTIuNjE1IDIuNjE1IDAgMSAxIDUuMDUzIDEuMzVsLTQyLjk1NyAxNjAuNTY0YTIuNjEyIDIuNjEyIDAgMCAxLTIuNTI3IDEuOTM3eiIKICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC4wOCAtNzIuOTk1KSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDxwYXRoIGlkPSJQZmFkXzM4MjAiIGQ9Ik0wIDBoMjI2djIyNkgweiIgY2xhc3M9ImNscy0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NjkgNzI2KSIvPgogICAgICAgICAgICA8ZyBpZD0iR3J1cHBlXzE1NjI3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MS4wNTIgNjYpIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcnVwcGVfMTU2MjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU0NS41MTEgNzk0LjgwOSkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJMaW5pZV8xMjkiIGQ9Ik0wIDBMNjkuOTc0IDcwLjU3MiIgY2xhc3M9ImNscy0xMiIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJMaW5pZV8xMzAiIGQ9Ik02OS45NzQgMEwwIDcwLjU3MiIgY2xhc3M9ImNscy0xMiIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPGcgaWQ9IkdydXBwZV8xNTYyNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNTk1ODUyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMjJweCIKICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ3NiA3MjYpIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iRWxsaXBzZV8yMDUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSIxMDMuOTciIGN5PSIxMDMuOTciIHI9IjEwMy45NyIgc3Ryb2tlPSJub25lIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEwMy45NyIgY3k9IjEwMy45NyIgcj0iOTIuOTciIGNsYXNzPSJjbHMtMiIvPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBpZD0iTGluaWVfMTMxIiBkPSJNNzEuNzY4IDcxLjc2OEwwIDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3Ny42MjYgMTc0LjAzOCkiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==", _1 = { class: "ds-flex ds-flex-column ds-items-center ds-justify-center emptyStateSearch__margin" }, C1 = /* @__PURE__ */ b("img", {
  class: "ds-mb-8 emptyStateSearch",
  src: x1,
  alt: "Keine Treffer"
}, null, -1), y1 = { class: "ds-text-sans ds-mb-2" }, v1 = /* @__PURE__ */ Z({
  __name: "EmptyStateSearch",
  props: {
    search: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Xa();
    function i() {
      n.clear();
    }
    return (s, o) => (u(), g("div", _1, [
      C1,
      b("h4", y1, "Keine Treffer für “" + j(t.search) + "” in Sammlungen", 1),
      V(_e(ot), {
        mode: "tertiary",
        label: "Suche zurücksetzen",
        onOnClick: i
      })
    ]));
  }
}), w1 = /* @__PURE__ */ b("h3", { class: "ds-text-sans ds-mb-6" }, "Neue Sammlung erstellen", -1), I1 = /* @__PURE__ */ Z({
  __name: "AddCollectionArea",
  emits: ["updateCollectionTitle", "updateCollectionDescription"],
  setup(e, { emit: t }) {
    const n = J(!1);
    function i(o) {
      n.value = o === "", t("updateCollectionTitle", o);
    }
    function s(o) {
      t("updateCollectionDescription", o);
    }
    return (o, r) => (u(), g(X, null, [
      w1,
      V(_e(Fs), {
        class: "ds-mb-6",
        label: "Name der Sammlung*",
        placeholder: "z.B. Grillparty",
        "has-error": n.value,
        "error-msg": "Eine Sammlung braucht einen Namen.",
        "is-clearable": "",
        onOnInput: r[0] || (r[0] = (a, l) => {
          i(l);
        })
      }, null, 8, ["has-error"]),
      V(_e(js), {
        label: "Beschreibung (optional)",
        placeholder: "Detaillierte Beschreibung hinzufügen...",
        rows: "4",
        onOnInput: r[1] || (r[1] = (a, l) => {
          s(l);
        })
      })
    ], 64));
  }
});
class k1 {
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }
  push(t, n) {
    window.dataLayer.push({ event: t, data: n });
  }
}
const zt = class {
  constructor() {
    Pe(this, "dataLayerService");
    this.dataLayerService = new k1();
  }
  static getInstance() {
    return zt.INSTANCE || (zt.INSTANCE = new zt()), zt.INSTANCE;
  }
  trackAddToCollection(t, n, i, s) {
    const o = {
      content_id: n,
      content_type: i,
      event_interaction_type: t,
      event_content_id: s ? "recipe_" + s : "recipe_new"
    };
    this.trackEvent("save_dialog", o);
  }
  trackSearchForCollection(t, n, i) {
    const s = {
      content_id: t,
      content_type: n,
      event_interaction_type: "search",
      event_content_id: i ? "recipe_" + i : "recipe_new"
    };
    this.trackEvent("save_dialog", s);
  }
  trackInitNewCollection(t, n, i) {
    const s = {
      content_id: t,
      content_type: n,
      event_interaction_type: "create_new_collection",
      event_content_id: i ? "recipe_" + i : "recipe_new"
    };
    this.trackEvent("save_dialog", s);
  }
  trackCreateNewCollection(t, n, i) {
    const s = {
      content_id: t,
      content_type: n,
      event_interaction_type: "save_new_collection",
      event_content_id: i ? "recipe_" + i : "recipe_new"
    };
    this.trackEvent("save_dialog", s);
  }
  trackCancel(t, n, i, s) {
    const o = {
      content_id: n,
      content_type: i,
      event_interaction_type: t,
      event_content_id: s ? "recipe_" + s : "recipe_new"
    };
    this.trackEvent("save_dialog", o);
  }
  trackSaveDialog(t, n, i) {
    const s = {
      content_id: n,
      content_type: i,
      event_interaction_type: t
    };
    this.trackEvent("save_dialog", s);
  }
  trackRecipeSave(t, n, i, s, o, r) {
    const a = {
      content_id: n,
      content_type: i,
      event_step: t,
      event_content_id: r ? "recipe_" + r : "recipe_new",
      event_type: s,
      event_context: "bottom",
      payed_content_type: o ? "plus_recipe" : void 0
    };
    this.trackEvent("recipe_save", a);
  }
  trackEvent(t, n) {
    this.dataLayerService.push(t, n);
  }
  log(t, n) {
    console.log(t, n);
  }
};
let Oe = zt;
Pe(Oe, "INSTANCE");
const A1 = { key: 1 }, S1 = {
  key: 2,
  class: "ds-flex ds-justify-center"
}, T1 = /* @__PURE__ */ b("h4", { class: "ds-text-sans ds-mb-4" }, "Du hast noch keine Sammlungen angelegt", -1), $1 = /* @__PURE__ */ b("p", { class: "ds-text-sans" }, "Speichere deine Rezepte in einer Sammlung für eine bessere Übersicht.", -1), D1 = [
  T1,
  $1
], N1 = /* @__PURE__ */ Z({
  __name: "SaveDialogComponent.ce",
  props: {
    id: {
      type: String,
      default: void 0
    },
    scrapeId: {
      type: String,
      default: void 0
    },
    title: {
      type: String,
      required: !0
    },
    contentId: {
      type: String,
      required: !0
    },
    contentType: {
      type: String,
      required: !0
    },
    preparationTime: {
      type: Number,
      default: void 0
    },
    subtitle: {
      type: String,
      default: void 0
    },
    servings: {
      type: Number,
      default: void 0
    },
    kCalories: {
      type: Number,
      default: void 0
    },
    ingredientsText: {
      type: String,
      default: void 0
    },
    instructions: {
      type: String,
      default: void 0
    },
    miscellaneousText: {
      type: String,
      default: void 0
    },
    cookingTime: {
      type: Number,
      default: void 0
    },
    restingTime: {
      type: Number,
      default: void 0
    },
    sourceName: {
      type: String,
      default: void 0
    },
    sourceUrl: {
      type: String,
      default: void 0
    },
    imageUrl: {
      type: String,
      default: void 0
    },
    imageEncoded: {
      type: String,
      default: void 0
    },
    difficulty: {
      type: Number,
      default: 2
    },
    isPlus: {
      type: Boolean,
      default: !1
    },
    subtype: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    const t = e, n = gt(), i = p1(), s = Xa(), o = J(""), r = J(!1), a = J(""), l = "", d = D(() => t.imageEncoded ? t.imageEncoded : t.imageUrl ? t.imageUrl : l), c = async () => {
      if (r.value) {
        const B = await ee();
        i.resetCollectionsFromUser(), i.getCollectionsFromUser(), B.forEach((N) => {
          i.addCollectionToCollectionsFromUser(N), i.collectionsByRecipeId.add(N.id);
        }), r.value = !1, Oe.getInstance().trackCreateNewCollection(t.contentId, t.contentType, i.recipeId);
      } else {
        await O();
        const B = [];
        for (const R of i.collectionsByRecipeId)
          B.push(R);
        const N = Array.from(i.collectionsByRecipeId).length > 0 ? "default" : "quick-save", Q = new CustomEvent("saveRecipe", {
          detail: {
            recipeId: i.recipeId ? i.recipeId : void 0,
            inCollections: Array.from(i.collectionsByRecipeId).length > 0,
            collectionIds: B
          }
        });
        be(), Oe.getInstance().trackSaveDialog("success", t.contentId, t.contentType), i.recipeAlreadyInCookbook || Oe.getInstance().trackRecipeSave("success", t.contentId, t.contentType, N, t.isPlus, i.recipeId), document.dispatchEvent(Q);
      }
    }, f = () => {
      r.value ? (Oe.getInstance().trackCancel("cancel_new_collection", t.contentId, t.contentType, i.recipeId), r.value = !1, o.value = "", a.value = "") : (Oe.getInstance().trackCancel("cancel", t.contentId, t.contentType, i.recipeId), U(!1));
    }, h = J(!1), y = D(() => (s.active ? s.resultCollections : i.collectionsFromUser).map((N) => ({
      collection: N,
      isContaining: i.collectionsByRecipeId.has(N.id)
    }))), _ = () => {
      Oe.getInstance().trackInitNewCollection(t.contentId, t.contentType, i.recipeId), r.value = !0;
    };
    function k(B) {
      if (i.collectionsByRecipeId.has(B)) {
        i.collectionsByRecipeId.delete(B), Oe.getInstance().trackAddToCollection("deselect_collection", t.contentId, t.contentType, i.recipeId);
        return;
      }
      s.active && !i.collectionsFromUser.find((N) => N.id === B) && K(B), i.collectionsByRecipeId.add(B), Oe.getInstance().trackAddToCollection("select_collection", t.contentId, t.contentType, i.recipeId);
    }
    function K(B) {
      const N = s.resultCollections.find((Q) => Q.id === B);
      N && i.addCollectionToCollectionsFromUser(N);
    }
    const U = (B = !0) => {
      B && Oe.getInstance().trackCancel("close_dialog", t.contentId, t.contentType, i.recipeId);
      const N = new Event("closeOverlay");
      be(), document.dispatchEvent(N);
    };
    at(async () => {
      i.resetCollectionsStore(), await n.getBenutzerMe(), i.setRecipeId(t.id ?? null), Oe.getInstance().trackSaveDialog("init", t.contentId, t.contentType), await i.checkRecipeForBeingInCookbook(), await P();
    });
    async function ae() {
      h.value || (s.active ? await G() : await P());
    }
    async function P() {
      i.collectionsFromUser.length !== 0 && i.collectionsFullyLoaded() || (h.value = !0, await i.getCollectionsFromUser(), h.value = !1);
    }
    async function G(B) {
      if (B && B !== s.query && (be(), s.query = B), !s.allResultsLoaded) {
        if (!s.active) {
          be();
          return;
        }
        h.value = !0, await s.getResults(), h.value = !1;
      }
    }
    async function se(B) {
      var N;
      Oe.getInstance().trackSearchForCollection(t.contentId, t.contentType, i.recipeId), await G(((N = B.target) == null ? void 0 : N.value) ?? "");
    }
    function be() {
      s.clear();
    }
    async function ee() {
      return (await i.createCollection({ title: o.value, description: a.value })).filter((N) => N.type === "success").map((N) => N.collection);
    }
    async function O() {
      const B = [];
      t.id !== void 0 && B.push(t.id);
      try {
        if (t.id !== void 0)
          await i.updateSavedRecipe(B, Array.from(i.collectionsByRecipeId));
        else {
          let N = null;
          t.imageUrl && t.imageEncoded && (N = {
            image: t.imageEncoded,
            sourceUrl: t.imageUrl
          });
          const Q = {
            scrapeId: t.scrapeId ? t.scrapeId : void 0,
            title: t.title,
            preparationTime: t.preparationTime ? t.preparationTime : void 0,
            subtitle: t.subtitle ? t.subtitle : void 0,
            servings: t.servings ? t.servings : void 0,
            kCalories: t.kCalories ? t.kCalories : void 0,
            ingredientsText: t.ingredientsText ? t.ingredientsText : void 0,
            instructions: t.instructions ? t.instructions : void 0,
            miscellaneousText: t.miscellaneousText ? t.miscellaneousText : void 0,
            cookingTime: t.cookingTime ? t.cookingTime : void 0,
            restingTime: t.restingTime ? t.restingTime : void 0,
            source: {
              name: t.sourceName ? t.sourceName : void 0,
              url: t.sourceUrl ? t.sourceUrl : void 0
            },
            previewImage: N,
            difficulty: t.difficulty ? t.difficulty : void 0,
            subtype: t.subtype ? t.subtype : void 0
          };
          await i.createRecipe(Q);
        }
      } catch {
      }
    }
    return (B, N) => (u(), le(_e(hi), {
      "footer-shadow": "",
      "overlay-id": "shareCollection",
      size: "large",
      "close-on-escape": !0,
      show: "",
      title: "Zu einer Sammlung hinzufügen",
      class: "ds-text-sans",
      onOnClose: N[4] || (N[4] = (Q) => U()),
      onOnBackdropClick: N[5] || (N[5] = (Q) => U())
    }, {
      default: Ae(() => [
        V(_e(Bs), {
          title: t.title,
          "has-image": !!t.imageEncoded || !!t.imageUrl,
          "image-template": _e(d),
          difficulty: t.difficulty ? t.difficulty : 2,
          "preparation-time": t.preparationTime ? t.preparationTime : 0
        }, null, 8, ["title", "has-image", "image-template", "difficulty", "preparation-time"]),
        V(_e(Ns), { class: "ds-mv-2" }),
        r.value ? (u(), le(I1, {
          key: 0,
          onUpdateCollectionTitle: N[0] || (N[0] = (Q) => {
            o.value = Q;
          }),
          onUpdateCollectionDescription: N[1] || (N[1] = (Q) => {
            a.value = Q;
          })
        })) : (u(), g("div", A1, [
          V(_e(Rs), {
            "icon-prepend": "search",
            placeholder: "Sammlung suchen",
            onOnEnter: se,
            onOnDelete: be
          }),
          V(f1, { onAddCollection: _ }, {
            default: Ae(() => [
              ke("Neue Sammlung erstellen")
            ]),
            _: 1
          }),
          h.value || _e(y).length > 0 ? (u(), le(b1, {
            key: 0,
            loading: h.value,
            items: _e(y),
            onCheckboxToggled: k,
            onEndReached: ae
          }, null, 8, ["loading", "items"])) : _e(s).active && _e(s).resultCollections.length === 0 ? (u(), le(v1, {
            key: 1,
            search: _e(s).query
          }, null, 8, ["search"])) : (u(), g("div", S1, D1))
        ]))
      ]),
      footer: Ae(() => [
        V(_e(fi), { class: "ds-text-sans" }, {
          first: Ae(() => [
            V(_e(ot), {
              mode: "secondary",
              label: "Abbrechen",
              onOnClick: N[2] || (N[2] = (Q) => f())
            })
          ]),
          second: Ae(() => [
            V(_e(ot), {
              mode: "primary",
              label: r.value ? "Sammlung erstellen" : "Speichern",
              onOnClick: N[3] || (N[3] = (Q) => c())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), E1 = `@charset "UTF-8";/*!
 * Bootstrap v4.0.0 (https://getbootstrap.com)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */.ds-container{box-sizing:border-box;margin-right:auto;margin-left:auto;padding:0 4px;width:100%}@media (min-width: 360px){.ds-container{padding:0 8px}}@media (min-width: 600px){.ds-container{max-width:600px}}@media (min-width: 1196px){.ds-container{padding:0 12px;max-width:1196px}}.ds-container--fixed-width{max-width:996px}.ds-bg-container{margin-left:-4px;margin-right:-4px;padding-left:4px;padding-right:4px}@media (min-width: 360px){.ds-bg-container{margin-left:-8px;margin-right:-8px;padding-left:8px;padding-right:8px}}@media (min-width: 1196px){.ds-bg-container{margin-left:-12px;margin-right:-12px;padding-left:12px;padding-right:12px}}.ds-grid{box-sizing:border-box;display:flex;flex:0 1 auto;flex-direction:row;flex-wrap:wrap}@media (min-width: 1196px){.ds-grid-float{float:left}}.ds-row{margin-right:-4px;margin-left:-4px}@media (min-width: 360px){.ds-row{margin-right:-8px;margin-left:-8px}}@media (min-width: 1196px){.ds-row{margin-right:-12px;margin-left:-12px}}.ds-clear{clear:both}[class*=ds-col-]{box-sizing:border-box;flex:0 1 auto;padding-right:4px;padding-left:4px;width:100%}@media (min-width: 360px){[class*=ds-col-]{padding-right:8px;padding-left:8px}}@media (min-width: 600px){[class*=ds-col-]{flex:0 0 auto}}@media (min-width: 1196px){[class*=ds-col-]{padding-right:12px;padding-left:12px}}[class*=ds-col-] img{max-width:100%}.ds-col-1{flex-basis:8.33333333%;max-width:8.33333333%}.ds-col-2{flex-basis:16.66666667%;max-width:16.66666667%}.ds-col-3{flex-basis:25%;max-width:25%}.ds-col-4{flex-basis:33.33333333%;max-width:33.33333333%}.ds-col-5{flex-basis:41.66666667%;max-width:41.66666667%}.ds-col-6{flex-basis:50%;max-width:50%}.ds-col-7{flex-basis:58.33333333%;max-width:58.33333333%}.ds-col-8{flex-basis:66.66666667%;max-width:66.66666667%}.ds-col-9{flex-basis:75%;max-width:75%}.ds-col-10{flex-basis:83.33333333%;max-width:83.33333333%}.ds-col-11{flex-basis:91.66666667%;max-width:91.66666667%}.ds-col-12{flex-basis:100%;max-width:100%}@media (min-width: 480px){.ds-col-xs-1{flex-basis:8.33333333%;max-width:8.33333333%}.ds-col-xs-2{flex-basis:16.66666667%;max-width:16.66666667%}.ds-col-xs-3{flex-basis:25%;max-width:25%}.ds-col-xs-4{flex-basis:33.33333333%;max-width:33.33333333%}.ds-col-xs-5{flex-basis:41.66666667%;max-width:41.66666667%}.ds-col-xs-6{flex-basis:50%;max-width:50%}.ds-col-xs-7{flex-basis:58.33333333%;max-width:58.33333333%}.ds-col-xs-8{flex-basis:66.66666667%;max-width:66.66666667%}.ds-col-xs-9{flex-basis:75%;max-width:75%}.ds-col-xs-10{flex-basis:83.33333333%;max-width:83.33333333%}.ds-col-xs-11{flex-basis:91.66666667%;max-width:91.66666667%}.ds-col-xs-12{flex-basis:100%;max-width:100%}}@media (min-width: 600px){.ds-col-s-1{flex-basis:8.33333333%;max-width:8.33333333%}.ds-col-s-2{flex-basis:16.66666667%;max-width:16.66666667%}.ds-col-s-3{flex-basis:25%;max-width:25%}.ds-col-s-4{flex-basis:33.33333333%;max-width:33.33333333%}.ds-col-s-5{flex-basis:41.66666667%;max-width:41.66666667%}.ds-col-s-6{flex-basis:50%;max-width:50%}.ds-col-s-7{flex-basis:58.33333333%;max-width:58.33333333%}.ds-col-s-8{flex-basis:66.66666667%;max-width:66.66666667%}.ds-col-s-9{flex-basis:75%;max-width:75%}.ds-col-s-10{flex-basis:83.33333333%;max-width:83.33333333%}.ds-col-s-11{flex-basis:91.66666667%;max-width:91.66666667%}.ds-col-s-12{flex-basis:100%;max-width:100%}}@media (min-width: 768px){.ds-col-sm-1{flex-basis:8.33333333%;max-width:8.33333333%}.ds-col-sm-2{flex-basis:16.66666667%;max-width:16.66666667%}.ds-col-sm-3{flex-basis:25%;max-width:25%}.ds-col-sm-4{flex-basis:33.33333333%;max-width:33.33333333%}.ds-col-sm-5{flex-basis:41.66666667%;max-width:41.66666667%}.ds-col-sm-6{flex-basis:50%;max-width:50%}.ds-col-sm-7{flex-basis:58.33333333%;max-width:58.33333333%}.ds-col-sm-8{flex-basis:66.66666667%;max-width:66.66666667%}.ds-col-sm-9{flex-basis:75%;max-width:75%}.ds-col-sm-10{flex-basis:83.33333333%;max-width:83.33333333%}.ds-col-sm-11{flex-basis:91.66666667%;max-width:91.66666667%}.ds-col-sm-12{flex-basis:100%;max-width:100%}}@media (min-width: 1196px){.ds-col-m-1{flex-basis:8.33333333%;max-width:8.33333333%}.ds-col-m-2{flex-basis:16.66666667%;max-width:16.66666667%}.ds-col-m-3{flex-basis:25%;max-width:25%}.ds-col-m-4{flex-basis:33.33333333%;max-width:33.33333333%}.ds-col-m-5{flex-basis:41.66666667%;max-width:41.66666667%}.ds-col-m-6{flex-basis:50%;max-width:50%}.ds-col-m-7{flex-basis:58.33333333%;max-width:58.33333333%}.ds-col-m-8{flex-basis:66.66666667%;max-width:66.66666667%}.ds-col-m-9{flex-basis:75%;max-width:75%}.ds-col-m-10{flex-basis:83.33333333%;max-width:83.33333333%}.ds-col-m-11{flex-basis:91.66666667%;max-width:91.66666667%}.ds-col-m-12{flex-basis:100%;max-width:100%}}body{background:#fff}main.ds-container{background:#fff;padding-top:32px;width:auto;max-width:672px}@media (min-width: 1196px){main.ds-container{max-width:996px}}body[data-ads-site-type=tablet] main.ds-container{margin-right:calc((100vw - 872px)/2 + 200px)}@media (max-width: 872px){body[data-ads-site-type=tablet] main.ds-container{margin-right:200px}}body[data-ads-site-type=desktop] main.ds-container{margin-right:calc((100vw - 1196px)/2 + 200px)}.ds-box{margin-bottom:32px;position:relative}.ds-hr{border:0;border-bottom:1px solid #a7a7a2;margin:0;padding-top:32px;width:100%}.ad .ds-hr{padding-top:16px}figure{margin:0}@font-face{font-family:Source Sans Pro;font-style:normal;font-weight:400;font-display:swap;src:local(""),url(https://img.chefkoch-cdn.de/assets/v2/source-sans-pro-v14-latin-regular.woff2) format("woff2"),url(https://img.chefkoch-cdn.de/assets/v2/source-sans-pro-v14-latin-regular.woff) format("woff")}@font-face{font-family:Source Sans Pro;font-style:normal;font-weight:600;font-display:swap;src:local(""),url(https://img.chefkoch-cdn.de/assets/v2/source-sans-pro-v14-latin-600.woff2) format("woff2"),url(https://img.chefkoch-cdn.de/assets/v2/source-sans-pro-v14-latin-600.woff) format("woff")}@font-face{font-family:Source Sans Pro;font-style:normal;font-weight:700;font-display:swap;src:local(""),url(https://img.chefkoch-cdn.de/assets/v2/source-sans-pro-v14-latin-700.woff2) format("woff2"),url(https://img.chefkoch-cdn.de/assets/v2/source-sans-pro-v14-latin-700.woff) format("woff")}@font-face{font-family:"Source Serif Pro";font-style:normal;font-weight:400;font-display:swap;src:local(""),url(https://img.chefkoch-cdn.de/assets/v2/source-serif-pro-v11-latin-regular.woff2) format("woff2"),url(https://img.chefkoch-cdn.de/assets/v2/source-serif-pro-v11-latin-regular.woff) format("woff")}@font-face{font-family:"Source Serif Pro";font-style:normal;font-weight:600;font-display:swap;src:local(""),url(https://img.chefkoch-cdn.de/assets/v2/source-serif-pro-v11-latin-600.woff2) format("woff2"),url(https://img.chefkoch-cdn.de/assets/v2/source-serif-pro-v11-latin-600.woff) format("woff")}@font-face{font-family:Caveat;font-style:normal;font-weight:400;src:local(""),url(https://img.chefkoch-cdn.de/assets/v2/caveat-v17-latin-regular.woff2) format("woff2"),url(https://img.chefkoch-cdn.de/assets/v2/caveat-v17-latin-regular.woff) format("woff")}body{font: 18px/27px Source Sans Pro,Arial,sans-serif;color:#212018}aside{font: 14px/19px Source Sans Pro,Arial,sans-serif}h1,.ds-h1,h2,.ds-h2,h3,.ds-h3,h4,.ds-h4{margin-bottom:0;margin-top:0}p,ul{margin-bottom:16px;margin-top:0}h1,.ds-h1{font:600 40px/44px "Source Serif Pro",serif;letter-spacing:.008em}@media (min-width: 600px) and (max-width: 1195.98px){h1,.ds-h1{font:600 36px/40px "Source Serif Pro",serif;letter-spacing:.008em}}@media (max-width: 599.98px){h1,.ds-h1{font:600 32px/36px "Source Serif Pro",serif;letter-spacing:.008em}}h2,.ds-h2{font:600 32px/36px "Source Serif Pro",serif;letter-spacing:.008em}@media (min-width: 600px) and (max-width: 1195.98px){h2,.ds-h2{font:600 28px/32px "Source Serif Pro",serif;letter-spacing:.008em}}@media (max-width: 599.98px){h2,.ds-h2{font:600 24px/28px "Source Serif Pro",serif;letter-spacing:.008em}}h3,.ds-h3{font:600 24px/28px "Source Serif Pro",serif;letter-spacing:.008em}@media (min-width: 600px) and (max-width: 1195.98px){h3,.ds-h3{font:600 20px/24px "Source Serif Pro",serif;letter-spacing:.004em}}@media (max-width: 599.98px){h3,.ds-h3{font:600 20px/24px "Source Serif Pro",serif;letter-spacing:.004em}}h4,.ds-h4{font:600 18px/22px "Source Serif Pro",serif;letter-spacing:normal}@media (min-width: 1196px){h4,.ds-h4{font:600 18px/22px "Source Serif Pro",serif;letter-spacing:normal}}@media (max-width: 599.98px){h4,.ds-h4{font:600 18px/22px "Source Serif Pro",serif;letter-spacing:normal}}.ds-text-category{display:block;color:#212018;font: 16px/20px Source Sans Pro,Arial,sans-serif;letter-spacing:1.66px;text-transform:uppercase}.ds-text-caption{display:block;color:#595852;letter-spacing:.06px;font: 14px/19px Source Sans Pro,Arial,sans-serif}p:last-child{margin-bottom:0}aside.ds-box p:not(:last-of-type){margin-bottom:8px}.ds-text-link{color:#3b8047;text-decoration:underline;text-underline-offset:.2em}.ds-text-link:hover,.ds-text-link:focus{text-decoration:none}.ds-copy-link{color:#3b8047;text-decoration:underline;text-underline-offset:.2em}.ds-copy-link:hover,.ds-copy-link:focus{text-decoration:none}a.ds-heading-link{color:inherit;text-decoration:none}a.ds-heading-link:hover,a.ds-heading-link:focus{color:#37713f;text-decoration:underline}a:hover .ds-heading-link,a:focus .ds-heading-link{color:#37713f;text-decoration:underline}.ds-target-link{color:inherit;text-decoration:none;display:block}a.ds-mb{color:inherit;text-decoration:none}small,.ds-text-small{display:block;font-size:14px;line-height:19px}.ds-text-center{text-align:center}@media (max-width: 599.98px){.ds-text-center-to-xs{text-align:center}}.ds-text-right{text-align:right}.ds-text-regular{font-weight:400}.ds-text-bold{font-weight:700}.ds-text-semi-bold{font-weight:600}.ds-text-sans{font-family:Source Sans Pro,Arial,sans-serif}.ds-text-serif{font-family:"Source Serif Pro",serif}.ds-text-line-through{text-decoration:line-through}.ds-flex{display:flex}.ds-inline-flex{display:inline-flex}@media (min-width: 600px){.ds-flex-s{display:flex}.ds-inline-flex-s{display:inline-flex}}@media (min-width: 1196px){.ds-flex-m{display:flex}.ds-inline-flex-m{display:inline-flex}}.ds-flex-column{flex-direction:column}.ds-flex-row{flex-direction:row}@media (min-width: 600px){.ds-flex-s-column{flex-direction:column}}@media (min-width: 1196px){.ds-flex-m-column{flex-direction:column}}@media (min-width: 600px){.ds-flex-s-row{flex-direction:row}}@media (min-width: 1196px){.ds-flex-m-row{flex-direction:row}}.ds-items-center{align-items:center}.ds-items-start{align-items:flex-start}.ds-items-end{align-items:flex-end}@media (min-width: 600px){.ds-items-s-center{align-items:center}}@media (min-width: 1196px){.ds-items-m-center{align-items:center}}@media (min-width: 600px){.ds-items-s-start{align-items:flex-start}}@media (min-width: 1196px){.ds-items-m-start{align-items:flex-start}}@media (min-width: 600px){.ds-items-s-end{align-items:flex-end}}@media (min-width: 1196px){.ds-items-m-end{align-items:flex-end}}.ds-justify-center{justify-content:center}.ds-justify-start{justify-content:flex-start}.ds-justify-end{justify-content:flex-end}.ds-justify-between{justify-content:space-between}.ds-justify-around{justify-content:space-around}@media (min-width: 600px){.ds-justify-s-center{justify-content:center}}@media (min-width: 1196px){.ds-justify-m-center{justify-content:center}}@media (min-width: 600px){.ds-justify-s-start{justify-content:flex-start}}@media (min-width: 1196px){.ds-justify-m-start{justify-content:flex-start}}@media (min-width: 600px){.ds-justify-s-end{justify-content:flex-end}}@media (min-width: 1196px){.ds-justify-m-end{justify-content:flex-end}}@media (min-width: 600px){.ds-justify-s-between{justify-content:space-between}}@media (min-width: 1196px){.ds-justify-m-between{justify-content:space-between}}@media (min-width: 600px){.ds-justify-s-around{justify-content:space-around}}@media (min-width: 1196px){.ds-justify-m-around{justify-content:space-around}}.ds-flex-nowrap{flex-wrap:nowrap}.ds-flex-wrap{flex-wrap:wrap}.ds-flex-wrap-reverse{flex-wrap:wrap-reverse}@media (min-width: 600px){.ds-flex-s-nowrap{flex-wrap:nowrap}}@media (min-width: 1196px){.ds-flex-m-nowrap{flex-wrap:nowrap}}@media (min-width: 600px){.ds-flex-s-wrap{flex-wrap:wrap}}@media (min-width: 1196px){.ds-flex-m-wrap{flex-wrap:wrap}}@media (min-width: 600px){.ds-flex-s-wrap-reverse{flex-wrap:wrap-reverse}}@media (min-width: 1196px){.ds-flex-m-wrap-reverse{flex-wrap:wrap-reverse}}.ds-sr-only{border:0;clip:rect(0 0 0 0);height:0;margin:-1px;overflow:hidden;padding:0;position:absolute;width:0}@font-face{font-family:ck-icons;src:url(https://img.chefkoch-cdn.de/assets/v2/ck-icons.woff?kz1gid) format("woff"),url(https://img.chefkoch-cdn.de/assets/v2/ck-icons.ttf?kz1gid) format("truetype"),url(https://img.chefkoch-cdn.de/assets/v2/ck-icons.svg?kz1gid#ck-icons) format("svg");font-weight:400;font-style:normal}.chefkoch-icons{font-family:ck-icons!important;speak:never;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;font-size:24px;letter-spacing:0;-webkit-font-feature-settings:"liga";-moz-font-feature-settings:"liga=1";-moz-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;font-feature-settings:"liga";-webkit-font-variant-ligatures:discretionary-ligatures;font-variant-ligatures:discretionary-ligatures;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr}.chefkoch-icons--squared{width:1em;text-align:center}.chefkoch-icons--small{font-size:18px}.ds-btn{background:transparent;border:0;box-sizing:border-box;cursor:pointer;font-family:inherit;font-size:inherit;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;margin:0;transition-duration:.15s;transition-timing-function:ease-in-out;transition-property:color,border-color,background-color;border-radius:22px;white-space:nowrap;font-size:18px;font-weight:600;height:44px;line-height:44px;min-width:44px;padding:0 14px;border:2px solid transparent}.ds-btn::-moz-focus-inner{padding:0;border:0}.ds-btn:focus{outline:none}.ds-btn:hover{cursor:pointer}.ds-btn--disabled,.ds-btn:disabled,.ds-btn[disabled]{cursor:not-allowed}.ds-btn--disabled:hover,.ds-btn:disabled:hover,.ds-btn[disabled]:hover{cursor:not-allowed}.ds-btn__icon{color:inherit;line-height:1;font-size:24px;width:1em;text-align:center}.ds-btn__icon--leading{margin-right:8px}.ds-btn__icon--trailing{margin-left:8px}.ds-btn__icon--loading{position:absolute;left:auto;right:auto}.ds-btn--fluid{width:100%}.ds-btn--size-s{height:40px}.ds-btn--size-s.ds-btn--round{width:40px}.ds-btn--size-xs{height:36px;line-height:36px}.ds-btn--size-xs.ds-btn--round{width:36px}.ds-btn--flat{height:auto;line-height:27px}.ds-btn--flat .ds-btn__icon{line-height:inherit}.ds-btn .ds-btn__label--thin{font-weight:400}.ds-btn--round{border-radius:50%;padding-left:0;padding-right:0;min-width:0;width:44px}.ds-btn--loading{position:relative}.ds-btn--loading .ds-btn__label{color:transparent}.ds-btn--primary{background-color:#3b8047;color:#fff}.ds-btn--primary:hover,.ds-btn--primary:focus{background-color:#6ca075}.ds-btn--primary:active{background-color:#37713f}.ds-btn--primary.ds-btn--disabled,.ds-btn--primary:disabled,.ds-btn--primary[disabled]{background-color:#a7a7a2}.ds-btn--secondary{background:#fff;border-color:#3b8047;color:#3b8047}.ds-btn--secondary:hover,.ds-btn--secondary:focus{border-color:#6ca075;color:#6ca075}.ds-btn--secondary:active{border-color:#37713f;color:#37713f}.ds-btn--secondary.ds-btn--disabled,.ds-btn--secondary:disabled,.ds-btn--secondary[disabled]{border-color:#a7a7a2;color:#a7a7a2}.ds-btn--tertiary{color:#3b8047;padding-left:0;padding-right:0;border-width:0}.ds-btn--tertiary:hover,.ds-btn--tertiary:focus{color:#6ca075}.ds-btn--tertiary:active{color:#37713f}.ds-btn--tertiary.ds-btn--disabled,.ds-btn--tertiary:disabled,.ds-btn--tertiary[disabled]{color:#a7a7a2}.ds-btn--danger{background-color:#a70000;color:#fff}.ds-btn--danger:hover,.ds-btn--danger:focus{background-color:#bd4040}.ds-btn--danger:active{background-color:#930403}.ds-btn--danger.ds-btn--disabled,.ds-btn--danger:disabled,.ds-btn--danger[disabled]{background-color:#a7a7a2}.ds-btn--monochrome{background-color:transparent;color:#595852;padding-left:0;padding-right:0;border-width:0}.ds-btn--monochrome:hover,.ds-btn--monochrome:focus{color:#6ca075}.ds-btn--monochrome:active{color:#37713f}.ds-btn--monochrome.ds-btn--disabled,.ds-btn--monochrome:disabled,.ds-btn--monochrome[disabled]{color:#a7a7a2}.ds-btn-box{display:flex;justify-content:flex-end;flex-wrap:wrap}.ds-btn-box__item{margin-left:16px}.ds-btn-box__item--first{margin-left:0}.ds-btn-box__item--line-break{margin-top:16px;flex:0 0 100%;justify-content:flex-end;display:inline-flex}.ds-btn-box__inner{display:flex;justify-content:flex-end;flex-wrap:wrap}.ds-btn-box--space-between{justify-content:space-between}@media (max-width: 599.98px){.ds-btn-box--stack-to-xs{flex-direction:column;justify-content:center;align-items:center}.ds-btn-box--stack-to-xs .ds-btn-box__inner{display:flex;flex-direction:column}.ds-btn-box--stack-to-xs .ds-btn-box__item{margin-left:0;margin-bottom:16px}.ds-btn-box--stack-to-xs .ds-btn-box__item--last{margin-bottom:0}.ds-btn-box--stack-to-xs .ds-btn-box__item--line-break{margin-top:0;justify-content:center}}.ds-overlay-backdrop{background-color:#21201873;width:100%;height:100%;position:fixed;z-index:1000010;top:0;left:0}.ds-overlay{width:100%;height:100%;display:flex;position:relative;top:0;bottom:0;justify-content:center;align-items:center}.ds-overlay__inner{position:relative;max-width:calc(100vw - 32px);width:480px;border-radius:24px 0 24px 24px;background-color:#fff}@media (max-width: 599.98px){.ds-overlay--large .ds-overlay__inner{width:100%;max-width:100%;border-radius:0}}@media (min-width: 600px){.ds-overlay--large .ds-overlay__inner{width:580px;height:auto}}@media (max-width: 599.98px){.ds-overlay--xlarge .ds-overlay__inner{width:100%;max-width:100%;border-radius:0;height:100%}}@media (min-width: 600px){.ds-overlay--xlarge .ds-overlay__inner{min-height:270px;width:calc(100vw - 96px);height:calc(100vh - 96px);max-width:1824px}}.ds-overlay__content{box-sizing:border-box;overflow:hidden;display:flex;flex-direction:column;min-height:270px;max-height:calc(100vh - 32px)}.ds-overlay__content--no-head{padding-top:48px}@media (max-width: 599.98px){.ds-overlay--large .ds-overlay__content{height:100vh;max-height:100vh;max-height:-webkit-fill-available}}.ds-overlay--xlarge .ds-overlay__content{height:100%;max-height:100vh;max-height:-webkit-fill-available}.ds-overlay__close{z-index:1;position:absolute;top:0;right:0}.ds-overlay__title{font:600 24px/28px Source Sans Pro,Arial,sans-serif}.ds-overlay__head{position:relative;padding:32px 16px 16px}@media (min-width: 600px){.ds-overlay__head{padding-left:32px;padding-right:32px}}.ds-overlay__body{flex-grow:1;overflow:auto;padding:0 16px 16px}@media (min-width: 600px){.ds-overlay__body{padding-left:32px;padding-right:32px}}.ds-overlay__body--no-overflow{overflow:hidden}.ds-overlay__footer{margin-top:auto;padding:32px 16px}@media (min-width: 600px){.ds-overlay__footer{padding-left:32px;padding-right:32px}}.ds-overlay__footer--shadow{z-index:1;box-shadow:0 4px 16px #21201826}.ds-overlay-active{overflow:hidden}.ds-overlay-active body{position:fixed}.ds-mb-0{margin-bottom:0!important}.ds-mt-0{margin-top:0!important}.ds-mv-0{margin-bottom:0!important;margin-top:0!important}.ds-pb-0{padding-bottom:0!important}.ds-pt-0{padding-top:0!important}.ds-pv-0{padding-bottom:0!important;padding-top:0!important}.ds-mb-1{margin-bottom:4px!important}.ds-mt-1{margin-top:4px!important}.ds-mv-1{margin-bottom:4px!important;margin-top:4px!important}.ds-pb-1{padding-bottom:4px!important}.ds-pt-1{padding-top:4px!important}.ds-pv-1{padding-bottom:4px!important;padding-top:4px!important}.ds-mb-2{margin-bottom:8px!important}.ds-mt-2{margin-top:8px!important}.ds-mv-2{margin-bottom:8px!important;margin-top:8px!important}.ds-pb-2{padding-bottom:8px!important}.ds-pt-2{padding-top:8px!important}.ds-pv-2{padding-bottom:8px!important;padding-top:8px!important}.ds-mb-3{margin-bottom:12px!important}.ds-mt-3{margin-top:12px!important}.ds-mv-3{margin-bottom:12px!important;margin-top:12px!important}.ds-pb-3{padding-bottom:12px!important}.ds-pt-3{padding-top:12px!important}.ds-pv-3{padding-bottom:12px!important;padding-top:12px!important}.ds-mb-4{margin-bottom:16px!important}.ds-mt-4{margin-top:16px!important}.ds-mv-4{margin-bottom:16px!important;margin-top:16px!important}.ds-pb-4{padding-bottom:16px!important}.ds-pt-4{padding-top:16px!important}.ds-pv-4{padding-bottom:16px!important;padding-top:16px!important}.ds-mb-6{margin-bottom:24px!important}.ds-mt-6{margin-top:24px!important}.ds-mv-6{margin-bottom:24px!important;margin-top:24px!important}.ds-pb-6{padding-bottom:24px!important}.ds-pt-6{padding-top:24px!important}.ds-pv-6{padding-bottom:24px!important;padding-top:24px!important}.ds-mb-8{margin-bottom:32px!important}.ds-mt-8{margin-top:32px!important}.ds-mv-8{margin-bottom:32px!important;margin-top:32px!important}.ds-pb-8{padding-bottom:32px!important}.ds-pt-8{padding-top:32px!important}.ds-pv-8{padding-bottom:32px!important;padding-top:32px!important}.ds-mb-12{margin-bottom:48px!important}.ds-mt-12{margin-top:48px!important}.ds-mv-12{margin-bottom:48px!important;margin-top:48px!important}.ds-pb-12{padding-bottom:48px!important}.ds-pt-12{padding-top:48px!important}.ds-pv-12{padding-bottom:48px!important;padding-top:48px!important}.ds-mb-16{margin-bottom:64px!important}.ds-mt-16{margin-top:64px!important}.ds-mv-16{margin-bottom:64px!important;margin-top:64px!important}.ds-pb-16{padding-bottom:64px!important}.ds-pt-16{padding-top:64px!important}.ds-pv-16{padding-bottom:64px!important;padding-top:64px!important}.ds-mb-auto{margin-bottom:auto!important}.ds-mt-auto{margin-top:auto!important}.ds-mv-auto{margin-bottom:auto!important;margin-top:auto!important}@media (min-width: 480px){.ds-mb-xs-0{margin-bottom:0!important}.ds-mt-xs-0{margin-top:0!important}.ds-mv-xs-0{margin-bottom:0!important;margin-top:0!important}.ds-pb-xs-0{padding-bottom:0!important}.ds-pt-xs-0{padding-top:0!important}.ds-pv-xs-0{padding-bottom:0!important;padding-top:0!important}}@media (min-width: 480px){.ds-mb-xs-1{margin-bottom:4px!important}.ds-mt-xs-1{margin-top:4px!important}.ds-mv-xs-1{margin-bottom:4px!important;margin-top:4px!important}.ds-pb-xs-1{padding-bottom:4px!important}.ds-pt-xs-1{padding-top:4px!important}.ds-pv-xs-1{padding-bottom:4px!important;padding-top:4px!important}}@media (min-width: 480px){.ds-mb-xs-2{margin-bottom:8px!important}.ds-mt-xs-2{margin-top:8px!important}.ds-mv-xs-2{margin-bottom:8px!important;margin-top:8px!important}.ds-pb-xs-2{padding-bottom:8px!important}.ds-pt-xs-2{padding-top:8px!important}.ds-pv-xs-2{padding-bottom:8px!important;padding-top:8px!important}}@media (min-width: 480px){.ds-mb-xs-3{margin-bottom:12px!important}.ds-mt-xs-3{margin-top:12px!important}.ds-mv-xs-3{margin-bottom:12px!important;margin-top:12px!important}.ds-pb-xs-3{padding-bottom:12px!important}.ds-pt-xs-3{padding-top:12px!important}.ds-pv-xs-3{padding-bottom:12px!important;padding-top:12px!important}}@media (min-width: 480px){.ds-mb-xs-4{margin-bottom:16px!important}.ds-mt-xs-4{margin-top:16px!important}.ds-mv-xs-4{margin-bottom:16px!important;margin-top:16px!important}.ds-pb-xs-4{padding-bottom:16px!important}.ds-pt-xs-4{padding-top:16px!important}.ds-pv-xs-4{padding-bottom:16px!important;padding-top:16px!important}}@media (min-width: 480px){.ds-mb-xs-6{margin-bottom:24px!important}.ds-mt-xs-6{margin-top:24px!important}.ds-mv-xs-6{margin-bottom:24px!important;margin-top:24px!important}.ds-pb-xs-6{padding-bottom:24px!important}.ds-pt-xs-6{padding-top:24px!important}.ds-pv-xs-6{padding-bottom:24px!important;padding-top:24px!important}}@media (min-width: 480px){.ds-mb-xs-8{margin-bottom:32px!important}.ds-mt-xs-8{margin-top:32px!important}.ds-mv-xs-8{margin-bottom:32px!important;margin-top:32px!important}.ds-pb-xs-8{padding-bottom:32px!important}.ds-pt-xs-8{padding-top:32px!important}.ds-pv-xs-8{padding-bottom:32px!important;padding-top:32px!important}}@media (min-width: 480px){.ds-mb-xs-12{margin-bottom:48px!important}.ds-mt-xs-12{margin-top:48px!important}.ds-mv-xs-12{margin-bottom:48px!important;margin-top:48px!important}.ds-pb-xs-12{padding-bottom:48px!important}.ds-pt-xs-12{padding-top:48px!important}.ds-pv-xs-12{padding-bottom:48px!important;padding-top:48px!important}}@media (min-width: 480px){.ds-mb-xs-16{margin-bottom:64px!important}.ds-mt-xs-16{margin-top:64px!important}.ds-mv-xs-16{margin-bottom:64px!important;margin-top:64px!important}.ds-pb-xs-16{padding-bottom:64px!important}.ds-pt-xs-16{padding-top:64px!important}.ds-pv-xs-16{padding-bottom:64px!important;padding-top:64px!important}}@media (min-width: 480px){.ds-mb-xs-auto{margin-bottom:auto!important}.ds-mt-xs-auto{margin-top:auto!important}.ds-mv-xs-auto{margin-bottom:auto!important;margin-top:auto!important}}@media (min-width: 600px){.ds-mb-s-0{margin-bottom:0!important}.ds-mt-s-0{margin-top:0!important}.ds-mv-s-0{margin-bottom:0!important;margin-top:0!important}.ds-pb-s-0{padding-bottom:0!important}.ds-pt-s-0{padding-top:0!important}.ds-pv-s-0{padding-bottom:0!important;padding-top:0!important}}@media (min-width: 600px){.ds-mb-s-1{margin-bottom:4px!important}.ds-mt-s-1{margin-top:4px!important}.ds-mv-s-1{margin-bottom:4px!important;margin-top:4px!important}.ds-pb-s-1{padding-bottom:4px!important}.ds-pt-s-1{padding-top:4px!important}.ds-pv-s-1{padding-bottom:4px!important;padding-top:4px!important}}@media (min-width: 600px){.ds-mb-s-2{margin-bottom:8px!important}.ds-mt-s-2{margin-top:8px!important}.ds-mv-s-2{margin-bottom:8px!important;margin-top:8px!important}.ds-pb-s-2{padding-bottom:8px!important}.ds-pt-s-2{padding-top:8px!important}.ds-pv-s-2{padding-bottom:8px!important;padding-top:8px!important}}@media (min-width: 600px){.ds-mb-s-3{margin-bottom:12px!important}.ds-mt-s-3{margin-top:12px!important}.ds-mv-s-3{margin-bottom:12px!important;margin-top:12px!important}.ds-pb-s-3{padding-bottom:12px!important}.ds-pt-s-3{padding-top:12px!important}.ds-pv-s-3{padding-bottom:12px!important;padding-top:12px!important}}@media (min-width: 600px){.ds-mb-s-4{margin-bottom:16px!important}.ds-mt-s-4{margin-top:16px!important}.ds-mv-s-4{margin-bottom:16px!important;margin-top:16px!important}.ds-pb-s-4{padding-bottom:16px!important}.ds-pt-s-4{padding-top:16px!important}.ds-pv-s-4{padding-bottom:16px!important;padding-top:16px!important}}@media (min-width: 600px){.ds-mb-s-6{margin-bottom:24px!important}.ds-mt-s-6{margin-top:24px!important}.ds-mv-s-6{margin-bottom:24px!important;margin-top:24px!important}.ds-pb-s-6{padding-bottom:24px!important}.ds-pt-s-6{padding-top:24px!important}.ds-pv-s-6{padding-bottom:24px!important;padding-top:24px!important}}@media (min-width: 600px){.ds-mb-s-8{margin-bottom:32px!important}.ds-mt-s-8{margin-top:32px!important}.ds-mv-s-8{margin-bottom:32px!important;margin-top:32px!important}.ds-pb-s-8{padding-bottom:32px!important}.ds-pt-s-8{padding-top:32px!important}.ds-pv-s-8{padding-bottom:32px!important;padding-top:32px!important}}@media (min-width: 600px){.ds-mb-s-12{margin-bottom:48px!important}.ds-mt-s-12{margin-top:48px!important}.ds-mv-s-12{margin-bottom:48px!important;margin-top:48px!important}.ds-pb-s-12{padding-bottom:48px!important}.ds-pt-s-12{padding-top:48px!important}.ds-pv-s-12{padding-bottom:48px!important;padding-top:48px!important}}@media (min-width: 600px){.ds-mb-s-16{margin-bottom:64px!important}.ds-mt-s-16{margin-top:64px!important}.ds-mv-s-16{margin-bottom:64px!important;margin-top:64px!important}.ds-pb-s-16{padding-bottom:64px!important}.ds-pt-s-16{padding-top:64px!important}.ds-pv-s-16{padding-bottom:64px!important;padding-top:64px!important}}@media (min-width: 600px){.ds-mb-s-auto{margin-bottom:auto!important}.ds-mt-s-auto{margin-top:auto!important}.ds-mv-s-auto{margin-bottom:auto!important;margin-top:auto!important}}@media (min-width: 1196px){.ds-mb-m-0{margin-bottom:0!important}.ds-mt-m-0{margin-top:0!important}.ds-mv-m-0{margin-bottom:0!important;margin-top:0!important}.ds-pb-m-0{padding-bottom:0!important}.ds-pt-m-0{padding-top:0!important}.ds-pv-m-0{padding-bottom:0!important;padding-top:0!important}}@media (min-width: 1196px){.ds-mb-m-1{margin-bottom:4px!important}.ds-mt-m-1{margin-top:4px!important}.ds-mv-m-1{margin-bottom:4px!important;margin-top:4px!important}.ds-pb-m-1{padding-bottom:4px!important}.ds-pt-m-1{padding-top:4px!important}.ds-pv-m-1{padding-bottom:4px!important;padding-top:4px!important}}@media (min-width: 1196px){.ds-mb-m-2{margin-bottom:8px!important}.ds-mt-m-2{margin-top:8px!important}.ds-mv-m-2{margin-bottom:8px!important;margin-top:8px!important}.ds-pb-m-2{padding-bottom:8px!important}.ds-pt-m-2{padding-top:8px!important}.ds-pv-m-2{padding-bottom:8px!important;padding-top:8px!important}}@media (min-width: 1196px){.ds-mb-m-3{margin-bottom:12px!important}.ds-mt-m-3{margin-top:12px!important}.ds-mv-m-3{margin-bottom:12px!important;margin-top:12px!important}.ds-pb-m-3{padding-bottom:12px!important}.ds-pt-m-3{padding-top:12px!important}.ds-pv-m-3{padding-bottom:12px!important;padding-top:12px!important}}@media (min-width: 1196px){.ds-mb-m-4{margin-bottom:16px!important}.ds-mt-m-4{margin-top:16px!important}.ds-mv-m-4{margin-bottom:16px!important;margin-top:16px!important}.ds-pb-m-4{padding-bottom:16px!important}.ds-pt-m-4{padding-top:16px!important}.ds-pv-m-4{padding-bottom:16px!important;padding-top:16px!important}}@media (min-width: 1196px){.ds-mb-m-6{margin-bottom:24px!important}.ds-mt-m-6{margin-top:24px!important}.ds-mv-m-6{margin-bottom:24px!important;margin-top:24px!important}.ds-pb-m-6{padding-bottom:24px!important}.ds-pt-m-6{padding-top:24px!important}.ds-pv-m-6{padding-bottom:24px!important;padding-top:24px!important}}@media (min-width: 1196px){.ds-mb-m-8{margin-bottom:32px!important}.ds-mt-m-8{margin-top:32px!important}.ds-mv-m-8{margin-bottom:32px!important;margin-top:32px!important}.ds-pb-m-8{padding-bottom:32px!important}.ds-pt-m-8{padding-top:32px!important}.ds-pv-m-8{padding-bottom:32px!important;padding-top:32px!important}}@media (min-width: 1196px){.ds-mb-m-12{margin-bottom:48px!important}.ds-mt-m-12{margin-top:48px!important}.ds-mv-m-12{margin-bottom:48px!important;margin-top:48px!important}.ds-pb-m-12{padding-bottom:48px!important}.ds-pt-m-12{padding-top:48px!important}.ds-pv-m-12{padding-bottom:48px!important;padding-top:48px!important}}@media (min-width: 1196px){.ds-mb-m-16{margin-bottom:64px!important}.ds-mt-m-16{margin-top:64px!important}.ds-mv-m-16{margin-bottom:64px!important;margin-top:64px!important}.ds-pb-m-16{padding-bottom:64px!important}.ds-pt-m-16{padding-top:64px!important}.ds-pv-m-16{padding-bottom:64px!important;padding-top:64px!important}}@media (min-width: 1196px){.ds-mb-m-auto{margin-bottom:auto!important}.ds-mt-m-auto{margin-top:auto!important}.ds-mv-m-auto{margin-bottom:auto!important;margin-top:auto!important}}.ds-mr-0{margin-right:0!important}.ds-ml-0{margin-left:0!important}.ds-mh-0{margin-right:0!important;margin-left:0!important}.ds-pr-0{padding-right:0!important}.ds-pl-0{padding-left:0!important}.ds-ph-0{padding-right:0!important;padding-left:0!important}.ds-mr-1{margin-right:4px!important}.ds-ml-1{margin-left:4px!important}.ds-mh-1{margin-right:4px!important;margin-left:4px!important}.ds-pr-1{padding-right:4px!important}.ds-pl-1{padding-left:4px!important}.ds-ph-1{padding-right:4px!important;padding-left:4px!important}.ds-mr-2{margin-right:8px!important}.ds-ml-2{margin-left:8px!important}.ds-mh-2{margin-right:8px!important;margin-left:8px!important}.ds-pr-2{padding-right:8px!important}.ds-pl-2{padding-left:8px!important}.ds-ph-2{padding-right:8px!important;padding-left:8px!important}.ds-mr-3{margin-right:12px!important}.ds-ml-3{margin-left:12px!important}.ds-mh-3{margin-right:12px!important;margin-left:12px!important}.ds-pr-3{padding-right:12px!important}.ds-pl-3{padding-left:12px!important}.ds-ph-3{padding-right:12px!important;padding-left:12px!important}.ds-mr-4{margin-right:16px!important}.ds-ml-4{margin-left:16px!important}.ds-mh-4{margin-right:16px!important;margin-left:16px!important}.ds-pr-4{padding-right:16px!important}.ds-pl-4{padding-left:16px!important}.ds-ph-4{padding-right:16px!important;padding-left:16px!important}.ds-mr-6{margin-right:24px!important}.ds-ml-6{margin-left:24px!important}.ds-mh-6{margin-right:24px!important;margin-left:24px!important}.ds-pr-6{padding-right:24px!important}.ds-pl-6{padding-left:24px!important}.ds-ph-6{padding-right:24px!important;padding-left:24px!important}.ds-mr-8{margin-right:32px!important}.ds-ml-8{margin-left:32px!important}.ds-mh-8{margin-right:32px!important;margin-left:32px!important}.ds-pr-8{padding-right:32px!important}.ds-pl-8{padding-left:32px!important}.ds-ph-8{padding-right:32px!important;padding-left:32px!important}.ds-mr-auto{margin-right:auto!important}.ds-ml-auto{margin-left:auto!important}.ds-mh-auto{margin-right:auto!important;margin-left:auto!important}@media (min-width: 480px){.ds-mr-xs-0{margin-right:0!important}.ds-ml-xs-0{margin-left:0!important}.ds-mh-xs-0{margin-right:0!important;margin-left:0!important}.ds-pr-xs-0{padding-right:0!important}.ds-pl-xs-0{padding-left:0!important}.ds-ph-xs-0{padding-right:0!important;padding-left:0!important}}@media (min-width: 480px){.ds-mr-xs-1{margin-right:4px!important}.ds-ml-xs-1{margin-left:4px!important}.ds-mh-xs-1{margin-right:4px!important;margin-left:4px!important}.ds-pr-xs-1{padding-right:4px!important}.ds-pl-xs-1{padding-left:4px!important}.ds-ph-xs-1{padding-right:4px!important;padding-left:4px!important}}@media (min-width: 480px){.ds-mr-xs-2{margin-right:8px!important}.ds-ml-xs-2{margin-left:8px!important}.ds-mh-xs-2{margin-right:8px!important;margin-left:8px!important}.ds-pr-xs-2{padding-right:8px!important}.ds-pl-xs-2{padding-left:8px!important}.ds-ph-xs-2{padding-right:8px!important;padding-left:8px!important}}@media (min-width: 480px){.ds-mr-xs-3{margin-right:12px!important}.ds-ml-xs-3{margin-left:12px!important}.ds-mh-xs-3{margin-right:12px!important;margin-left:12px!important}.ds-pr-xs-3{padding-right:12px!important}.ds-pl-xs-3{padding-left:12px!important}.ds-ph-xs-3{padding-right:12px!important;padding-left:12px!important}}@media (min-width: 480px){.ds-mr-xs-4{margin-right:16px!important}.ds-ml-xs-4{margin-left:16px!important}.ds-mh-xs-4{margin-right:16px!important;margin-left:16px!important}.ds-pr-xs-4{padding-right:16px!important}.ds-pl-xs-4{padding-left:16px!important}.ds-ph-xs-4{padding-right:16px!important;padding-left:16px!important}}@media (min-width: 480px){.ds-mr-xs-6{margin-right:24px!important}.ds-ml-xs-6{margin-left:24px!important}.ds-mh-xs-6{margin-right:24px!important;margin-left:24px!important}.ds-pr-xs-6{padding-right:24px!important}.ds-pl-xs-6{padding-left:24px!important}.ds-ph-xs-6{padding-right:24px!important;padding-left:24px!important}}@media (min-width: 480px){.ds-mr-xs-8{margin-right:32px!important}.ds-ml-xs-8{margin-left:32px!important}.ds-mh-xs-8{margin-right:32px!important;margin-left:32px!important}.ds-pr-xs-8{padding-right:32px!important}.ds-pl-xs-8{padding-left:32px!important}.ds-ph-xs-8{padding-right:32px!important;padding-left:32px!important}}@media (min-width: 480px){.ds-mr-xs-auto{margin-right:auto!important}.ds-ml-xs-auto{margin-left:auto!important}.ds-mh-xs-auto{margin-right:auto!important;margin-left:auto!important}}@media (min-width: 600px){.ds-mr-s-0{margin-right:0!important}.ds-ml-s-0{margin-left:0!important}.ds-mh-s-0{margin-right:0!important;margin-left:0!important}.ds-pr-s-0{padding-right:0!important}.ds-pl-s-0{padding-left:0!important}.ds-ph-s-0{padding-right:0!important;padding-left:0!important}}@media (min-width: 600px){.ds-mr-s-1{margin-right:4px!important}.ds-ml-s-1{margin-left:4px!important}.ds-mh-s-1{margin-right:4px!important;margin-left:4px!important}.ds-pr-s-1{padding-right:4px!important}.ds-pl-s-1{padding-left:4px!important}.ds-ph-s-1{padding-right:4px!important;padding-left:4px!important}}@media (min-width: 600px){.ds-mr-s-2{margin-right:8px!important}.ds-ml-s-2{margin-left:8px!important}.ds-mh-s-2{margin-right:8px!important;margin-left:8px!important}.ds-pr-s-2{padding-right:8px!important}.ds-pl-s-2{padding-left:8px!important}.ds-ph-s-2{padding-right:8px!important;padding-left:8px!important}}@media (min-width: 600px){.ds-mr-s-3{margin-right:12px!important}.ds-ml-s-3{margin-left:12px!important}.ds-mh-s-3{margin-right:12px!important;margin-left:12px!important}.ds-pr-s-3{padding-right:12px!important}.ds-pl-s-3{padding-left:12px!important}.ds-ph-s-3{padding-right:12px!important;padding-left:12px!important}}@media (min-width: 600px){.ds-mr-s-4{margin-right:16px!important}.ds-ml-s-4{margin-left:16px!important}.ds-mh-s-4{margin-right:16px!important;margin-left:16px!important}.ds-pr-s-4{padding-right:16px!important}.ds-pl-s-4{padding-left:16px!important}.ds-ph-s-4{padding-right:16px!important;padding-left:16px!important}}@media (min-width: 600px){.ds-mr-s-6{margin-right:24px!important}.ds-ml-s-6{margin-left:24px!important}.ds-mh-s-6{margin-right:24px!important;margin-left:24px!important}.ds-pr-s-6{padding-right:24px!important}.ds-pl-s-6{padding-left:24px!important}.ds-ph-s-6{padding-right:24px!important;padding-left:24px!important}}@media (min-width: 600px){.ds-mr-s-8{margin-right:32px!important}.ds-ml-s-8{margin-left:32px!important}.ds-mh-s-8{margin-right:32px!important;margin-left:32px!important}.ds-pr-s-8{padding-right:32px!important}.ds-pl-s-8{padding-left:32px!important}.ds-ph-s-8{padding-right:32px!important;padding-left:32px!important}}@media (min-width: 600px){.ds-mr-s-auto{margin-right:auto!important}.ds-ml-s-auto{margin-left:auto!important}.ds-mh-s-auto{margin-right:auto!important;margin-left:auto!important}}@media (min-width: 1196px){.ds-mr-m-0{margin-right:0!important}.ds-ml-m-0{margin-left:0!important}.ds-mh-m-0{margin-right:0!important;margin-left:0!important}.ds-pr-m-0{padding-right:0!important}.ds-pl-m-0{padding-left:0!important}.ds-ph-m-0{padding-right:0!important;padding-left:0!important}}@media (min-width: 1196px){.ds-mr-m-1{margin-right:4px!important}.ds-ml-m-1{margin-left:4px!important}.ds-mh-m-1{margin-right:4px!important;margin-left:4px!important}.ds-pr-m-1{padding-right:4px!important}.ds-pl-m-1{padding-left:4px!important}.ds-ph-m-1{padding-right:4px!important;padding-left:4px!important}}@media (min-width: 1196px){.ds-mr-m-2{margin-right:8px!important}.ds-ml-m-2{margin-left:8px!important}.ds-mh-m-2{margin-right:8px!important;margin-left:8px!important}.ds-pr-m-2{padding-right:8px!important}.ds-pl-m-2{padding-left:8px!important}.ds-ph-m-2{padding-right:8px!important;padding-left:8px!important}}@media (min-width: 1196px){.ds-mr-m-3{margin-right:12px!important}.ds-ml-m-3{margin-left:12px!important}.ds-mh-m-3{margin-right:12px!important;margin-left:12px!important}.ds-pr-m-3{padding-right:12px!important}.ds-pl-m-3{padding-left:12px!important}.ds-ph-m-3{padding-right:12px!important;padding-left:12px!important}}@media (min-width: 1196px){.ds-mr-m-4{margin-right:16px!important}.ds-ml-m-4{margin-left:16px!important}.ds-mh-m-4{margin-right:16px!important;margin-left:16px!important}.ds-pr-m-4{padding-right:16px!important}.ds-pl-m-4{padding-left:16px!important}.ds-ph-m-4{padding-right:16px!important;padding-left:16px!important}}@media (min-width: 1196px){.ds-mr-m-6{margin-right:24px!important}.ds-ml-m-6{margin-left:24px!important}.ds-mh-m-6{margin-right:24px!important;margin-left:24px!important}.ds-pr-m-6{padding-right:24px!important}.ds-pl-m-6{padding-left:24px!important}.ds-ph-m-6{padding-right:24px!important;padding-left:24px!important}}@media (min-width: 1196px){.ds-mr-m-8{margin-right:32px!important}.ds-ml-m-8{margin-left:32px!important}.ds-mh-m-8{margin-right:32px!important;margin-left:32px!important}.ds-pr-m-8{padding-right:32px!important}.ds-pl-m-8{padding-left:32px!important}.ds-ph-m-8{padding-right:32px!important;padding-left:32px!important}}@media (min-width: 1196px){.ds-mr-m-auto{margin-right:auto!important}.ds-ml-m-auto{margin-left:auto!important}.ds-mh-m-auto{margin-right:auto!important;margin-left:auto!important}}.ds-trunc{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;visibility:visible;word-wrap:break-word}.ds-trunc-1{-webkit-line-clamp:1}.ds-trunc-2{-webkit-line-clamp:2}.ds-trunc-3{-webkit-line-clamp:3}.ds-list-view-item{position:relative;background-color:#fff;display:flex;border-radius:8px;transition:background-color .15s ease-in-out}@media (min-width: 1196px){.ds-list-view-item{border-radius:16px}}.ds-list-view-item--hover-bg:hover{background-color:#f6f7f4}@media (min-width: 1196px){.ds-list-view-item--hover-bg-from-m:hover{background-color:#f6f7f4}}.ds-list-view-item--deactivated,.ds-list-view-item--disabled{cursor:not-allowed}.ds-list-view-item--deactivated .ds-list-view-item__link,.ds-list-view-item--disabled .ds-list-view-item__link{cursor:not-allowed;pointer-events:none}.ds-list-view-item--solid{margin-left:-8px;margin-right:-8px;padding:8px;background-color:#f6f7f4}@media (max-width: 599.98px){.ds-list-view-item--solid{border-radius:0}}@media (min-width: 360px){.ds-list-view-item--solid{margin-left:-16px;margin-right:-16px;padding:16px}}@media (min-width: 600px){.ds-list-view-item--solid{margin-left:0;margin-right:0}}.ds-list-view-item__link{display:flex;flex:0 1 auto;width:100%;flex-wrap:nowrap}.ds-list-view-item__media{overflow:hidden}.ds-list-view-item__image-wrap{background-color:#f3f4f0;width:100%;height:0;position:relative;overflow:hidden;line-height:19px;font-size:14px;border-radius:8px}.ds-list-view-item__image-wrap--no-image{background-color:#e2ece3}@media (min-width: 1196px){.ds-list-view-item__image-wrap{border-radius:16px}}.ds-list-view-item__image{border-radius:inherit;width:100%;height:auto;overflow:hidden}.ds-list-view-item--deactivated .ds-list-view-item__image{filter:saturate(0)}.ds-list-view-item__badge{display:flex;position:absolute;top:8px;left:8px;right:auto;bottom:auto}.ds-list-view-item__badge--centered{align-items:center;justify-content:center;top:0;right:0;bottom:0;left:0}.ds-list-view-item__body{display:flex;height:100%;flex-direction:row;flex-wrap:wrap;flex:1;overflow:hidden}.ds-list-view-item__column{box-sizing:border-box;flex-basis:100%;max-width:100%;padding-left:12px;display:inline-flex;flex-direction:column}@media (min-width: 480px){.ds-list-view-item__column{max-width:100%}}@media (min-width: 480px){.ds-list-view-item__column{padding-left:16px}}@media (min-width: 1196px){.ds-list-view-item__column{justify-content:center;padding-left:24px;flex-basis:50%;max-width:50%}}@media (min-width: 1196px){.ds-list-view-item__column--full{flex-basis:100%;max-width:100%}}.ds-list-view-item__headline{margin-bottom:0}.ds-list-view-item__action{display:flex;justify-content:flex-end;align-items:center;min-width:48px;flex-basis:48px;max-width:48px;box-sizing:border-box}@media (min-width: 600px){.ds-list-view-item__action{min-width:56px;flex-basis:56px;max-width:56px}}@media (min-width: 1196px){.ds-list-view-item__action{padding-right:8px;flex-basis:80px;max-width:80px}.ds-list-view-item--solid .ds-list-view-item__action{padding-right:0}}.ds-list-view-item--selectable .ds-list-view-item__action:not(.ds-list-view-item__action--select){display:none}@media (max-width: 1195.98px){.ds-list-view-item__column--note{padding-top:4px}.ds-list-view-item__column--note .ds-trunc{-webkit-line-clamp:1}}@media (min-width: 1196px){.ds-list-view-item__column--note{padding-bottom:8px;padding-top:8px}}.ds-list-view-item__action--select{box-sizing:border-box;justify-content:flex-start;min-width:36px;max-width:36px;align-items:center}.ds-list-view-item__action--select>i{width:1em;text-align:center}@media (min-width: 600px){.ds-list-view-item__action--select{max-width:40px}}@media (min-width: 1196px){.ds-list-view-item__action--select{padding-left:8px;max-width:56px}}.ds-list-view-item--collection{min-height:64px;border-radius:16px;background-color:#f6f7f4}.ds-list-view-item--collection.ds-list-view-item--inverted{background-color:#fff}.ds-list-view-item--collection .ds-list-view-item__media{flex:0 0 96px}@media (min-width: 600px){.ds-list-view-item--collection .ds-list-view-item__media{flex-basis:126px}}@media (min-width: 1196px){.ds-list-view-item--collection .ds-list-view-item__media{flex-basis:162px}}.ds-list-view-item--collection .ds-list-view-item__image{aspect-ratio:3/2}.ds-list-view-item--collection .ds-list-view-item__image-wrap{border-radius:16px 0 0 16px;padding-bottom:66.6666666667%}.ds-list-view-item--collection .ds-list-view-item__action{flex-basis:48px;min-width:48px;max-width:0;padding-right:8px}.ds-list-view-item--collection .ds-list-view-item__body{padding-left:12px;padding-right:8px;flex-wrap:nowrap;column-gap:16px}@media (min-width: 600px){.ds-list-view-item--collection .ds-list-view-item__body{padding-left:16px;padding-right:16px}}@media (min-width: 1196px){.ds-list-view-item--collection .ds-list-view-item__body{padding-left:24px}}.ds-list-view-item--collection .ds-list-view-item__column{padding-left:0;justify-content:center}@media (min-width: 600px){.ds-list-view-item--collection .ds-list-view-item__column--info{flex-basis:50%;max-width:50%}}.ds-list-view-item--collection .ds-list-view-item__column--note{flex-grow:1;flex-basis:0;overflow:hidden}@media (max-width: 599.98px){.ds-list-view-item--collection .ds-list-view-item__column--note{display:none}}@media (min-width: 600px) and (max-width: 1195.98px){.ds-list-view-item--collection .ds-list-view-item__column--note .ds-trunc{-webkit-line-clamp:3}}.ds-list-view-item--collection .ds-list-view-item__column--date{display:none}@media (min-width: 1196px){.ds-list-view-item--collection .ds-list-view-item__column--date{display:inline-flex;margin-left:auto;flex-basis:96px;max-width:96px}}.ds-list-view-item--collection .ds-list-view-item__badge{top:8px;left:8px;right:auto;bottom:auto}.ds-list-view-item{line-height:18px}.ds-list-view-item__info-top{display:none;line-height:19px;margin-bottom:4px}@media (min-width: 600px){.ds-list-view-item__info-top{display:flex}}.ds-list-view-item__info-bottom{display:flex}@media (min-width: 1196px){.ds-list-view-item__info-bottom{flex-direction:column}}.ds-list-view-item__recipe-count{margin-right:8px}.ds-list-view-item__info-item{display:inline-flex;white-space:pre;align-items:center}.ds-list-view-item__info-icon{font-size:18px;line-height:19px;margin-right:4px}.ds-list-view-item--recipe{min-height:68px}.ds-list-view-item--recipe .ds-list-view-item__media{flex:0 0 60px}@media (min-width: 480px){.ds-list-view-item--recipe .ds-list-view-item__media{flex-basis:84px}}@media (min-width: 600px){.ds-list-view-item--recipe .ds-list-view-item__media{flex-basis:108px}}@media (min-width: 1196px){.ds-list-view-item--recipe .ds-list-view-item__media{flex-basis:144px}}.ds-list-view-item--recipe .ds-list-view-item__image-wrap{padding-bottom:75%}.ds-list-view-item--recipe .ds-list-view-item__rating{margin-bottom:4px}@media (min-width: 1196px){.ds-list-view-item--recipe .ds-list-view-item__rating{margin-bottom:8px}}.ds-list-view-item--recipe .ds-list-view-item__headline{margin-bottom:4px}@media (min-width: 1196px){.ds-list-view-item--recipe .ds-list-view-item__headline{margin-bottom:8px}}.ds-list-view-item--recipe .ds-list-view-item__action{max-height:45px}@media (min-width: 480px){.ds-list-view-item--recipe .ds-list-view-item__action{max-height:63px}}@media (min-width: 600px){.ds-list-view-item--recipe .ds-list-view-item__action{max-height:81px}}@media (min-width: 1196px){.ds-list-view-item--recipe .ds-list-view-item__action{max-height:108px}}@media (min-width: 1196px){.ds-list-view-item--recipe .ds-list-view-item__column--info{max-height:108px}}.ds-list-view-item--recipe.ds-list-view-item--selectable .ds-list-view-item__link{padding-right:12px}@media (min-width: 600px){.ds-list-view-item--recipe.ds-list-view-item--selectable .ds-list-view-item__link{padding-right:16px}}@media (min-width: 1196px){.ds-list-view-item--recipe.ds-list-view-item--selectable .ds-list-view-item__link{padding-right:24px}}.ds-list-view-item__author{margin-top:4px}.ds-list-view-item--dialog .ds-list-view-item__action{color:#595852;transition:color .8s ease-out}.ds-list-view-item--dialog:hover .ds-list-view-item__action{color:#6ca075;transition:color .4s ease-in-out}.ds-list-view-item--dialog:hover .ds-list-view-item__headline{color:#6ca075}.ds-list-view-item--dialog:hover .ds-list-view-item__action--checked{color:#37713f}.ds-list-view-item--dialog:not(.ds-list-view-item--disabled){cursor:pointer}.ds-list-view-item--dialog.ds-list-view-item--collection{border-radius:8px}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__media{max-width:96px}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__image-wrap{border-radius:8px 0 0 8px}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__link{border-radius:16px;background:#f6f7f4}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__body{padding-left:12px;padding-right:8px}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__info-top{display:block}@media (min-width: 600px){.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__column--info{flex-basis:100%;max-width:100%}}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__action{padding-left:0;min-width:40px;padding-right:16px;flex-basis:40px;max-width:40px}.ds-list-view-item--dialog.ds-list-view-item--collection .ds-list-view-item__action--checked{color:#3b8047}.ds-list-view-item--dialog.ds-list-view-item--collection.ds-list-view-item--disabled .ds-list-view-item__action{color:#a7a7a2}.ds-list-view-item--dialog.ds-list-view-item--collection.ds-list-view-item--inverted .ds-list-view-item__link{background:#fff}@media (min-width: 1196px){.ds-list-view-item--dialog.ds-list-view-item--recipe{border-radius:8px}}.ds-list-view-item--dialog.ds-list-view-item--recipe .ds-list-view-item__column{justify-content:flex-start;padding-left:8px;padding-right:8px}@media (min-width: 480px){.ds-list-view-item--dialog.ds-list-view-item--recipe .ds-list-view-item__column{padding-left:16px;padding-right:16px}}.ds-list-view-item--dialog.ds-list-view-item--recipe.ds-list-view-item--solid .ds-list-view-item__media{max-width:84px}.ds-list-view-item--dialog.ds-list-view-item--recipe .ds-list-view-item__media{max-width:108px}.ds-list-view-item--dialog.ds-list-view-item--recipe .ds-list-view-item__action{padding-right:0;flex-basis:40px;max-width:40px}.ds-list-view-item--dialog.ds-list-view-item--recipe .ds-list-view-item__headline,.ds-list-view-item--dialog.ds-list-view-item--recipe .ds-list-view-item__rating{margin-bottom:4px}.ds-text-basmati{color:#fff!important}.ds-bg-basmati{background-color:#fff!important}.ds-text-corporate-green{color:#3b8047!important}.ds-bg-corporate-green{background-color:#3b8047!important}.ds-text-corporate-green-dark{color:#37713f!important}.ds-bg-corporate-green-dark{background-color:#37713f!important}.ds-text-corporate-green-medium{color:#6ca075!important}.ds-bg-corporate-green-medium{background-color:#6ca075!important}.ds-text-corporate-green-light{color:#a7c6ac!important}.ds-bg-corporate-green-light{background-color:#a7c6ac!important}.ds-text-corporate-green-xlight{color:#e2ece3!important}.ds-bg-corporate-green-xlight{background-color:#e2ece3!important}.ds-text-watermelon{color:#ff6067!important}.ds-bg-watermelon{background-color:#ff6067!important}.ds-text-watermelon-dark{color:#de565f!important}.ds-bg-watermelon-dark{background-color:#de565f!important}.ds-text-watermelon-medium{color:#ff888d!important}.ds-bg-watermelon-medium{background-color:#ff888d!important}.ds-text-watermelon-light{color:#ffb7ba!important}.ds-bg-watermelon-light{background-color:#ffb7ba!important}.ds-text-watermelon-xlight{color:#ffe7e8!important}.ds-bg-watermelon-xlight{background-color:#ffe7e8!important}.ds-text-olive{color:#212018!important}.ds-bg-olive{background-color:#212018!important}.ds-text-olive-medium{color:#595852!important}.ds-bg-olive-medium{background-color:#595852!important}.ds-text-olive-light{color:#9f9a97!important}.ds-bg-olive-light{background-color:#9f9a97!important}.ds-text-olive-xlight{color:#dededd!important}.ds-bg-olive-xlight{background-color:#dededd!important}.ds-text-pepper{color:#a7a7a2!important}.ds-bg-pepper{background-color:#a7a7a2!important}.ds-text-pepper-medium{color:#bdbdb9!important}.ds-bg-pepper-medium{background-color:#bdbdb9!important}.ds-text-pepper-light{color:#d7d7d5!important}.ds-bg-pepper-light{background-color:#d7d7d5!important}.ds-text-pepper-xlight{color:#f2f2f1!important}.ds-bg-pepper-xlight{background-color:#f2f2f1!important}.ds-text-garlic{color:#f3f4f0!important}.ds-bg-garlic{background-color:#f3f4f0!important}.ds-text-garlic-medium{color:#f6f7f4!important}.ds-bg-garlic-medium{background-color:#f6f7f4!important}.ds-text-garlic-light{color:#fafaf8!important}.ds-bg-garlic-light{background-color:#fafaf8!important}.ds-text-garlic-xlight{color:#fdfdfd!important}.ds-bg-garlic-xlight{background-color:#fdfdfd!important}.ds-text-mirabelle{color:#ffcd12!important}.ds-bg-mirabelle{background-color:#ffcd12!important}.ds-text-mirabelle-dark{color:#ffbd1e!important}.ds-bg-mirabelle-dark{background-color:#ffbd1e!important}.ds-text-mirabelle-medium{color:#ffda4d!important}.ds-bg-mirabelle-medium{background-color:#ffda4d!important}.ds-text-mirabelle-light{color:#ffe894!important}.ds-bg-mirabelle-light{background-color:#ffe894!important}.ds-text-mirabelle-xlight{color:#fff8dc!important}.ds-bg-mirabelle-xlight{background-color:#fff8dc!important}.ds-text-chili{color:#a70000!important}.ds-bg-chili{background-color:#a70000!important}.ds-text-chili-dark{color:#930403!important}.ds-bg-chili-dark{background-color:#930403!important}.ds-text-chili-medium{color:#bd4040!important}.ds-bg-chili-medium{background-color:#bd4040!important}.ds-text-chili-light{color:#d78c8c!important}.ds-bg-chili-light{background-color:#d78c8c!important}.ds-text-chili-xlight{color:#f2d9d9!important}.ds-bg-chili-xlight{background-color:#f2d9d9!important}.ds-text-blackberry{color:#734b6d!important}.ds-bg-blackberry{background-color:#734b6d!important}.ds-text-blackberry-dark{color:#674560!important}.ds-bg-blackberry-dark{background-color:#674560!important}.ds-text-blackberry-medium{color:#967891!important}.ds-bg-blackberry-medium{background-color:#967891!important}.ds-text-blackberry-light{color:#c0aebd!important}.ds-bg-blackberry-light{background-color:#c0aebd!important}.ds-text-blackberry-xlight{color:#eae4e9!important}.ds-bg-blackberry-xlight{background-color:#eae4e9!important}.ds-text-blackberry-xxlight{color:#f4f1f4!important}.ds-bg-blackberry-xxlight{background-color:#f4f1f4!important}.ds-text-blueberry{color:#006090!important}.ds-bg-blueberry{background-color:#006090!important}.ds-text-blueberry-dark{color:#05567e!important}.ds-bg-blueberry-dark{background-color:#05567e!important}.ds-text-blueberry-medium{color:#4088ac!important}.ds-bg-blueberry-medium{background-color:#4088ac!important}.ds-text-blueberry-light{color:#8cb7cd!important}.ds-bg-blueberry-light{background-color:#8cb7cd!important}.ds-text-blueberry-xlight{color:#d9e7ee!important}.ds-bg-blueberry-xlight{background-color:#d9e7ee!important}.ds-recipe-info{display:flex;color:#595852;letter-spacing:.06px;font: 14px/19px Source Sans Pro,Arial,sans-serif;line-height:18px}.ds-recipe-info__icon{color:#6ca075}.ds-recipe-info__icon.chefkoch-icons{font-size:18px;width:1em;text-align:center}.ds-recipe-info__icon--ml{margin-left:8px}.ds-recipe-info__text{margin-left:2px}.ds-recipe-info__text--ml{margin-left:4px}.ds-teaser-link{color:inherit;text-decoration:none}.ds-teaser-link__headline{transition:color .4s ease-out}.ds-teaser-link:hover .ds-teaser-link__headline{color:#6ca075;transition:color .4s ease-in-out}.ds-teaser-link__image-wrap{position:relative;overflow:hidden;will-change:transform}.ds-teaser-link__image{position:absolute;width:100%;height:100%;transition:transform .4s ease-out;transform:translateZ(0);backface-visibility:hidden}.ds-teaser-link:hover .ds-teaser-link__image{transition:transform .4s ease-in-out;transform:scale(1.1)}.ds-text-toggle{text-align:left;display:flex}.ds-text-toggle:not(.ds-text-toggle--readonly) .ds-text-toggle__icon{cursor:pointer}.ds-text-toggle:not(.ds-text-toggle--readonly):hover{cursor:pointer}.ds-text-toggle:not(.ds-text-toggle--readonly):hover .ds-text-toggle__icon{color:#3b8047}.ds-text-toggle__icon{color:#595852;font-size:18px;line-height:18px;flex-shrink:0;width:1em;text-align:center}.ds-text-toggle__text{margin:0 0 0 4px}.ds-divider{background-repeat:repeat-x;background-image:url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"><circle cx="1" cy="4" r="1" fill="%23a7a7a2"/></svg>');background-position-y:center;width:100%;border:0;height:32px;margin:0}.ds-divider--flat{height:2px}.ds-input-chip{background:transparent;border:0;box-sizing:border-box;cursor:pointer;font-family:inherit;font-size:inherit;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;margin:0;transition-duration:.15s;transition-timing-function:ease-in-out;transition-property:color,border-color,background-color;white-space:nowrap;font-size:18px;font-weight:600;height:32px;line-height:32px;padding:0 6px;color:#3b8047;background-color:#e2ece3;border-radius:8px;border-width:2px;border-style:solid;border-color:#a7c6ac}.ds-input-chip::-moz-focus-inner{padding:0;border:0}.ds-input-chip:focus{outline:none}.ds-input-chip:hover{cursor:pointer}.ds-input-chip--disabled,.ds-input-chip:disabled,.ds-input-chip[disabled]{cursor:not-allowed}.ds-input-chip--disabled:hover,.ds-input-chip:disabled:hover,.ds-input-chip[disabled]:hover{cursor:not-allowed}.ds-input-chip__label{letter-spacing:.06px}.ds-input-chip__icon{font-size:18px}.ds-input-chip__icon--trailing{margin-left:4px}.ds-input-chip:hover,.ds-input-chip:focus{border-color:#3b8047}input,textarea{font-family:inherit;font-size:inherit}.ds-input{appearance:none;border:1px solid #9f9a97;color:#212018;border-radius:8px;box-sizing:border-box;height:40px;padding:8px 12px;width:100%;background-color:#fff}.ds-input:hover,.ds-input:focus{border-color:#6ca075;outline:0}.ds-input::placeholder{color:#595852}.ds-input--textarea{display:block;height:auto;resize:none}.ds-input--error{border-color:#a70000}.ds-input:disabled{color:#a7a7a2;cursor:not-allowed;border-color:#a7a7a2;background-color:#fff}.ds-input:disabled::placeholder{color:#a7a7a2}.ds-input-clearable{position:relative}.ds-input-clearable__control:not(:placeholder-shown){padding-right:48px}.ds-input-clearable__control:not(:placeholder-shown)+.ds-input-clearable__btn{display:block}.ds-input-clearable__control:placeholder-shown+.ds-input-clearable__btn{display:none}.ds-input-clearable__btn{background:transparent;border:0;box-sizing:border-box;cursor:pointer;font-family:inherit;font-size:inherit;text-decoration:none;position:absolute;display:none;right:0;top:0;bottom:0;height:40px;width:40px;color:#595852}.ds-input-clearable__btn::-moz-focus-inner{padding:0;border:0}.ds-input-clearable__btn:focus{outline:none}.ds-form-item{margin-bottom:16px}.ds-form-item--mb-0{margin-bottom:0}.ds-form-item__label{display:flex;align-items:center;line-height:27px;font-weight:600}.ds-form-item__label-icon{width:1em;text-align:center;color:#6ca075}.ds-form-item__control{margin-top:4px}.ds-form-item__control--mb-0{margin-top:0}.ds-form-item__text{line-height:19px;font-size:14px;color:#595852;letter-spacing:.06px}.ds-form-item__text--bottom-right{margin-left:auto;padding-left:16px}.ds-form-item__text--error{color:#a70000}.ds-form-item__footer{margin-top:4px;display:flex;justify-content:space-between}.ds-search-bar{width:100%;position:relative}.ds-search-bar__control{position:relative;background-color:#fff;padding:2px 16px;border-radius:24px;border:2px solid #a7c6ac;min-height:48px;line-height:40px;box-sizing:border-box;flex-wrap:wrap;display:flex;align-items:center}.ds-search-bar__control--multiline{border-radius:16px}.ds-search-bar__control:hover,.ds-search-bar__control:active{border-color:#3b8047}.ds-search-bar__control-item{display:inline-flex;margin-top:4px;margin-bottom:4px;align-items:center;margin-right:8px}.ds-search-bar__control-item--icon{color:#3b8047;align-items:center;justify-content:center;padding:0}.ds-search-bar__control-item--icon>i{width:1em;text-align:center}.ds-search-bar__control-item--input{flex:1;margin-right:0;height:32px;position:relative}.ds-search-bar--suggest-active .ds-search-bar__control{z-index:1000011}.ds-search-bar__input{background-color:transparent;min-width:var(--search-bar-input-min-width, 80px);width:100%;appearance:none;border:0 solid transparent;color:#212018;box-sizing:border-box;padding:0;height:28px;line-height:28px;z-index:1}.ds-search-bar__input:hover,.ds-search-bar__input:focus{outline:0}.ds-search-bar__input::placeholder{color:#a7a7a2}.ds-search-bar__input--autocomplete{position:absolute;color:#595852;z-index:0;line-height:28px}.ds-search-bar__input--autocomplete span{line-height:28px;color:transparent}.ds-search-bar__backdrop{background-color:#21201873;width:100%;height:100%;position:fixed;z-index:1000010;top:0;left:0;opacity:0;visibility:hidden;transition:background-color .15s ease-out}.ds-search-bar--suggest-active .ds-search-bar__backdrop{opacity:1;visibility:visible;transition:background-color .33s ease-in}.ds-search-bar__suggest{box-sizing:border-box;width:100%;position:absolute;left:auto;bottom:auto;right:auto;transform:translate3d(0,16px,0);border-radius:16px;background-color:#fff;box-shadow:0 4px 16px #21201826;transition:opacity .15s ease-out;opacity:0;max-height:0;visibility:hidden;overflow:hidden}.ds-search-bar__suggest-inner{-webkit-overflow-scrolling:touch;overflow:auto;max-height:inherit}.ds-search-bar--suggest-active .ds-search-bar__suggest{opacity:1;z-index:1000011;max-height:calc(var(--search-bar-max-items-visible, 6) * 43px);height:auto;visibility:visible;transition:opacity .33s ease-in}.ds-search-bar__suggest-item{box-sizing:border-box;cursor:pointer;padding:8px 16px;height:43px;display:block;width:100%;overflow:hidden;text-overflow:ellipsis;text-decoration:none;color:#212018;font-weight:600}.ds-search-bar__suggest-item:hover,.ds-search-bar__suggest-item--active{background-color:#f2f2f1}.ds-search-bar__suggest-item em{font-weight:400;font-style:normal}.ds-search-bar__suggest-empty{padding:16px;color:#a7a7a2}.ds-btn--tile{background-color:#e2ece3;color:#37713f}.ds-btn--tile:active{background-color:#e2ece3}.ds-btn--tile .ds-btn__icon{will-change:transform;transition:transform .3s ease-in-out}.ds-btn--tile-action{border-radius:8px;height:48px;justify-content:space-between}.ds-btn--tile-action .ds-btn__icon{font-size:32px}.ds-btn--tile-action:hover .ds-btn__icon{transform:scale(1.4)}.ds-btn--tile-list{border-radius:8px;height:64px}.ds-btn--tile-list .ds-btn__icon{font-size:40px}.ds-btn--tile-list:hover .ds-btn__icon{transform:scale(1.4)}.ds-btn--tile-card{border-radius:24px;position:relative;height:100%;width:100%;border-width:0}.ds-btn--tile-card .ds-btn__icon{font-size:64px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transition:font-size .3s ease-in-out;will-change:font-size}.ds-btn--tile-card:hover .ds-btn__icon{font-size:89.6px}.ds-animate{animation-duration:1s;animation-fill-mode:both}.ds-animate--infinite{animation-iteration-count:infinite}.ds-animate--rotate{animation-duration:2s;animation-name:rotate;animation-timing-function:ease-in-out;transform:rotate(0);transform-origin:center}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.ds-loader{width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;vertical-align:top}.ds-loader__circle{fill:transparent;stroke:currentColor;stroke-width:2px;stroke-dasharray:50,60;stroke-dashoffset:0;stroke-linecap:round;animation:loading-animation 1.8s ease-in-out infinite}@keyframes loading-animation{0%{stroke-dasharray:1,60;stroke-dashoffset:0}50%{stroke-dasharray:35,60;stroke-dashoffset:-16}to{stroke-dasharray:35,60;stroke-dashoffset:-48}}.big-text{font-size:24px}.emptyStateSearch{max-width:85%}.emptyStateSearch__margin{margin-top:64px}
`, O1 = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, s] of t)
    n[i] = s;
  return n;
}, M1 = /* @__PURE__ */ O1(N1, [["styles", [E1]]]);
In(Zg());
const B1 = wc(M1);
customElements.define("save-dialog", B1);
